export type Entity = 'Activity' | 'AuditEntitySimplePropery' | 'BankAccount' | 'BaseTransaction' | 'BonusRequest' | 'CallTask' | 'ClientProfileNote' | 'Company' | 'ComplianceDataQuestionnaire' | 'CreditCard' | 'CreditCardDeposit' | 'CreditCardWithdrawal' | 'Customer' | 'CustomerAmlAlert' | 'CustomerCampaignLogin' | 'CustomerDocument' | 'CustomerECDDQuestion' | 'CustomerPushNotification' | 'CustomerQuestionnaireAnswer' | 'CustomerWorldCheck' | 'EmailVerificationInfo' | 'JointCustomer' | 'MultiCompanyCustomer' | 'Note' | 'PayPalAccountDeposit' | 'PhoneSmsVerificationInfo' | 'PspAccountCustomer' | 'QuestionnaireGroup' | 'Registration' | 'RelatedCustomer' | 'RelatedTransaction' | 'Subscription' | 'TBARequest' | 'Task' | 'TradingAccount' | 'WireTransferDeposit' | 'WireTransferWithdrawal' | 'Withdrawal' | 'WithdrawalRequest';

export enum Entities {
 ACTIVITY = 'Activity',
 AUDIT_ENTITY_SIMPLE_PROPERY = 'AuditEntitySimplePropery',
 BANK_ACCOUNT = 'BankAccount',
 BASE_TRANSACTION = 'BaseTransaction',
 BONUS_REQUEST = 'BonusRequest',
 CALL_TASK = 'CallTask',
 CLIENT_PROFILE_NOTE = 'ClientProfileNote',
 COMPANY = 'Company',
 COMPLIANCE_DATA_QUESTIONNAIRE = 'ComplianceDataQuestionnaire',
 CREDIT_CARD = 'CreditCard',
 CREDIT_CARD_DEPOSIT = 'CreditCardDeposit',
 CREDIT_CARD_WITHDRAWAL = 'CreditCardWithdrawal',
 CUSTOMER = 'Customer',
 CUSTOMER_AML_ALERT = 'CustomerAmlAlert',
 CUSTOMER_CAMPAIGN_LOGIN = 'CustomerCampaignLogin',
 CUSTOMER_DOCUMENT = 'CustomerDocument',
 CUSTOMER_E_C_D_D_QUESTION = 'CustomerECDDQuestion',
 CUSTOMER_PUSH_NOTIFICATION = 'CustomerPushNotification',
 CUSTOMER_QUESTIONNAIRE_ANSWER = 'CustomerQuestionnaireAnswer',
 CUSTOMER_WORLD_CHECK = 'CustomerWorldCheck',
 EMAIL_VERIFICATION_INFO = 'EmailVerificationInfo',
 JOINT_CUSTOMER = 'JointCustomer',
 MULTI_COMPANY_CUSTOMER = 'MultiCompanyCustomer',
 NOTE = 'Note',
 PAY_PAL_ACCOUNT_DEPOSIT = 'PayPalAccountDeposit',
 PHONE_SMS_VERIFICATION_INFO = 'PhoneSmsVerificationInfo',
 PSP_ACCOUNT_CUSTOMER = 'PspAccountCustomer',
 QUESTIONNAIRE_GROUP = 'QuestionnaireGroup',
 REGISTRATION = 'Registration',
 RELATED_CUSTOMER = 'RelatedCustomer',
 RELATED_TRANSACTION = 'RelatedTransaction',
 SUBSCRIPTION = 'Subscription',
 T_B_A_REQUEST = 'TBARequest',
 TASK = 'Task',
 TRADING_ACCOUNT = 'TradingAccount',
 WIRE_TRANSFER_DEPOSIT = 'WireTransferDeposit',
 WIRE_TRANSFER_WITHDRAWAL = 'WireTransferWithdrawal',
 WITHDRAWAL = 'Withdrawal',
 WITHDRAWAL_REQUEST = 'WithdrawalRequest'
}

export enum ActivityEntityGridRowProp {
 __activityButtons = '__activityButtons',
 Campaign = 'campaign',
 ControlGroup = 'controlGroup',
 CreatedBy = 'createdBy',
 CreationTime = 'creationTime',
 Direction = 'direction',
 Event = 'event',
 Id = 'id',
 Medium = 'medium',
 OutcomeLabel = 'outcome.label',
 RelatedEntityId = 'relatedEntity.id',
 RelatedEntityType = 'relatedEntity.type',
 Source = 'source',
 Summary = 'summary',
 Tag = 'tag',
 Timing = 'timing'
}
export type ActivityEntityGridRow__activityButtons = {
 [ActivityEntityGridRowProp.__activityButtons] : string | null
}
export type ActivityEntityGridRowCampaign = {
 [ActivityEntityGridRowProp.Campaign] : string | null
}
export type ActivityEntityGridRowControlGroup = {
 [ActivityEntityGridRowProp.ControlGroup] : boolean | null
}
export type ActivityEntityGridRowCreatedBy = {
 [ActivityEntityGridRowProp.CreatedBy] : string | null
}
export type ActivityEntityGridRowCreationTime = {
 [ActivityEntityGridRowProp.CreationTime] : number | null
}
export type ActivityEntityGridRowDirection = {
 [ActivityEntityGridRowProp.Direction] : 'NONE' | 'INCOMING' | 'OUTGOING' | null
}
export type ActivityEntityGridRowEvent = {
 [ActivityEntityGridRowProp.Event] : string | null
}
export type ActivityEntityGridRowId = {
 [ActivityEntityGridRowProp.Id] : number
}
export type ActivityEntityGridRowMedium = {
 [ActivityEntityGridRowProp.Medium] : 'INTERNAL' | 'MAIL' | 'PHONE' | 'LIVE_CHAT' | 'SMS' | 'MEETING' | 'ZENDESK' | 'APP_POPUP' | 'APP_PUSH' | 'RECORDING' | 'ZENDESK_CHAT' | null
}
export type ActivityEntityGridRowOutcomeLabel = {
 [ActivityEntityGridRowProp.OutcomeLabel] : string | null
}
export type ActivityEntityGridRowRelatedEntityId = {
 [ActivityEntityGridRowProp.RelatedEntityId] : number | null
}
export type ActivityEntityGridRowRelatedEntityType = {
 [ActivityEntityGridRowProp.RelatedEntityType] : string | null
}
export type ActivityEntityGridRowSource = {
 [ActivityEntityGridRowProp.Source] : string | null
}
export type ActivityEntityGridRowSummary = {
 [ActivityEntityGridRowProp.Summary] : string | null
}
export type ActivityEntityGridRowTag = {
 [ActivityEntityGridRowProp.Tag] : string | null
}
export type ActivityEntityGridRowTiming = {
 [ActivityEntityGridRowProp.Timing] : string | null
}
export type ActivityEntityGridRow = 
 Partial<ActivityEntityGridRow__activityButtons> & 
 Partial<ActivityEntityGridRowCampaign> & 
 Partial<ActivityEntityGridRowControlGroup> & 
 Partial<ActivityEntityGridRowCreatedBy> & 
 Partial<ActivityEntityGridRowCreationTime> & 
 Partial<ActivityEntityGridRowDirection> & 
 Partial<ActivityEntityGridRowEvent> & 
 ActivityEntityGridRowId & 
 Partial<ActivityEntityGridRowMedium> & 
 Partial<ActivityEntityGridRowOutcomeLabel> & 
 ActivityEntityGridRowRelatedEntityId & 
 Partial<ActivityEntityGridRowRelatedEntityType> & 
 Partial<ActivityEntityGridRowSource> & 
 Partial<ActivityEntityGridRowSummary> & 
 Partial<ActivityEntityGridRowTag> & 
 Partial<ActivityEntityGridRowTiming>

export enum AuditEntitySimpleProperyEntityGridRowProp {
 CreatedBy = 'createdBy',
 CreationTime = 'creationTime',
 Description = 'description',
 Id = 'id',
 ModifiedBy = 'modifiedBy',
 OldValue = 'oldValue',
 PropertyName = 'propertyName',
 UserId = 'userId',
 UserName = 'userName',
 Value = 'value'
}
export type AuditEntitySimpleProperyEntityGridRowCreatedBy = {
 [AuditEntitySimpleProperyEntityGridRowProp.CreatedBy] : string | null
}
export type AuditEntitySimpleProperyEntityGridRowCreationTime = {
 [AuditEntitySimpleProperyEntityGridRowProp.CreationTime] : number | null
}
export type AuditEntitySimpleProperyEntityGridRowDescription = {
 [AuditEntitySimpleProperyEntityGridRowProp.Description] : string | null
}
export type AuditEntitySimpleProperyEntityGridRowId = {
 [AuditEntitySimpleProperyEntityGridRowProp.Id] : number
}
export type AuditEntitySimpleProperyEntityGridRowModifiedBy = {
 [AuditEntitySimpleProperyEntityGridRowProp.ModifiedBy] : string | null
}
export type AuditEntitySimpleProperyEntityGridRowOldValue = {
 [AuditEntitySimpleProperyEntityGridRowProp.OldValue] : string | null
}
export type AuditEntitySimpleProperyEntityGridRowPropertyName = {
 [AuditEntitySimpleProperyEntityGridRowProp.PropertyName] : string | null
}
export type AuditEntitySimpleProperyEntityGridRowUserId = {
 [AuditEntitySimpleProperyEntityGridRowProp.UserId] : number | null
}
export type AuditEntitySimpleProperyEntityGridRowUserName = {
 [AuditEntitySimpleProperyEntityGridRowProp.UserName] : string | null
}
export type AuditEntitySimpleProperyEntityGridRowValue = {
 [AuditEntitySimpleProperyEntityGridRowProp.Value] : string | null
}
export type AuditEntitySimpleProperyEntityGridRow = 
 Partial<AuditEntitySimpleProperyEntityGridRowCreatedBy> & 
 Partial<AuditEntitySimpleProperyEntityGridRowCreationTime> & 
 Partial<AuditEntitySimpleProperyEntityGridRowDescription> & 
 AuditEntitySimpleProperyEntityGridRowId & 
 Partial<AuditEntitySimpleProperyEntityGridRowModifiedBy> & 
 Partial<AuditEntitySimpleProperyEntityGridRowOldValue> & 
 AuditEntitySimpleProperyEntityGridRowPropertyName & 
 Partial<AuditEntitySimpleProperyEntityGridRowUserId> & 
 Partial<AuditEntitySimpleProperyEntityGridRowUserName> & 
 Partial<AuditEntitySimpleProperyEntityGridRowValue>

export enum BankAccountEntityGridRowProp {
 AccountNumber = 'accountNumber',
 BankName = 'bankName',
 BeneficiaryName = 'beneficiaryName',
 Country = 'country',
 Currency = 'currency',
 Iban = 'iban',
 Id = 'id',
 Name = 'name',
 PaymentAccountStatus = 'paymentAccountStatus'
}
export type BankAccountEntityGridRowAccountNumber = {
 [BankAccountEntityGridRowProp.AccountNumber] : string | null
}
export type BankAccountEntityGridRowBankName = {
 [BankAccountEntityGridRowProp.BankName] : string | null
}
export type BankAccountEntityGridRowBeneficiaryName = {
 [BankAccountEntityGridRowProp.BeneficiaryName] : string | null
}
export type BankAccountEntityGridRowCountry = {
 [BankAccountEntityGridRowProp.Country] : 'NA' | 'AFGHANISTAN' | 'ÅLAND_ISLANDS' | 'ALBANIA' | 'ALGERIA' | 'AMERICAN_SAMOA' | 'ANDORRA' | 'ANGOLA' | 'ANGUILLA' | 'ANTARCTICA' | 'ANTIGUA_AND_BARBUDA' | 'ARGENTINA' | 'ARMENIA' | 'ARUBA' | 'AUSTRALIA' | 'AUSTRIA' | 'AZERBAIJAN' | 'BAHAMAS' | 'BAHRAIN' | 'BANGLADESH' | 'BARBADOS' | 'BELARUS' | 'BELGIUM' | 'BELIZE' | 'BENIN' | 'BERMUDA' | 'BHUTAN' | 'BOLIVIA' | 'BONAIRE_SINT_EUSTATIUS_AND_SABA' | 'BOSNIA_AND_HERZEGOVINA' | 'BOTSWANA' | 'BOUVET_ISLAND' | 'BRAZIL' | 'BRITISH_INDIAN_OCEAN_TERRITORY' | 'BRUNEI_DARUSSALAM' | 'BULGARIA' | 'BURKINA_FASO' | 'BURUNDI' | 'CAMBODIA' | 'CAMEROON' | 'CANADA' | 'CAPE_VERDE' | 'CAYMAN_ISLANDS' | 'CENTRAL_AFRICAN_REPUBLIC' | 'CHAD' | 'CHILE' | 'CHINA' | 'CHRISTMAS_ISLAND' | 'COCOS_ISLANDS' | 'COLOMBIA' | 'COMOROS' | 'CONGO' | 'CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE' | 'COOK_ISLANDS' | 'COSTA_RICA' | 'CROATIA' | 'CUBA' | 'CURAÇAO' | 'CYPRUS' | 'CZECH_REPUBLIC' | 'CÔTE_DIVOIRE' | 'DENMARK' | 'DJIBOUTI' | 'DOMINICA' | 'DOMINICAN_REPUBLIC' | 'EAST_TIMOR' | 'ECUADOR' | 'EGYPT' | 'EL_SALVADOR' | 'EQUATORIAL_GUINEA' | 'ERITREA' | 'ESTONIA' | 'ETHIOPIA' | 'FALKLAND_ISLANDS' | 'FAROE_ISLANDS' | 'FIJI' | 'FINLAND' | 'FRANCE' | 'FRENCH_GUIANA' | 'FRENCH_POLYNESIA' | 'FRENCH_SOUTHERN_TERRITORIES' | 'GABON' | 'GAMBIA' | 'Georgia' | 'GERMANY' | 'GHANA' | 'GIBRALTAR' | 'GREECE' | 'GREENLAND' | 'GRENADA' | 'GUADELOUPE' | 'GUAM' | 'GUATEMALA' | 'GUERNSEY' | 'GUINEA' | 'GUINEA_BISSAU' | 'GUYANA' | 'HAITI' | 'HEARD_ISLAND_AND_MCDONALD_ISLANDS' | 'HONDURAS' | 'HONG_KONG' | 'Hungary' | 'ICELAND' | 'INDIA' | 'INDONESIA' | 'IRAN' | 'IRAQ' | 'IRELAND' | 'ISLE_OF_MAN' | 'ISRAEL' | 'ITALY' | 'JAMAICA' | 'JAPAN' | 'JERSEY' | 'JORDAN' | 'KAZAKHSTAN' | 'KENYA' | 'KIRIBATI' | 'KOSOVO' | 'KOREA_DEMOCRATIC_PEOPLE_REPUBLIC_OF' | 'KOREA_REPUBLIC_OF' | 'KUWAIT' | 'KYRGYZSTAN' | 'LAO_PEOPLE_DEMOCRATIC_REPUBLIC' | 'LATVIA' | 'LEBANON' | 'LESOTHO' | 'LIBERIA' | 'LIBYAN' | 'LIECHTENSTEIN' | 'LITHUANIA' | 'LUXEMBOURG' | 'MACAO' | 'MADAGASCAR' | 'MALAWI' | 'MALAYSIA' | 'MALDIVES' | 'MALI' | 'MALTA' | 'MARSHALL_ISLANDS' | 'MARTINIQUE' | 'MAURITANIA' | 'MAURITIUS' | 'MAYOTTE' | 'MEXICO' | 'MICRONESIA' | 'MOLDOVA_REPUBLIC_OF' | 'MONACO' | 'MONGOLIA' | 'MONTENEGRO' | 'MONTSERRAT' | 'MOROCCO' | 'MOZAMBIQUE' | 'MYANMAR' | 'NAMIBIA' | 'NAURU' | 'NEPAL' | 'NETHERLANDS' | 'NETHERLANDS_ANTILLES' | 'NEW_CALEDONIA' | 'NEW_ZEALAND' | 'NICARAGUA' | 'NIGER' | 'NIGERIA' | 'NIUE' | 'NORFOLK_ISLAND' | 'NORTHERN_MARIANA_ISLANDS' | 'NORWAY' | 'OMAN' | 'PAKISTAN' | 'PALAU' | 'PALESTINIAN_TERRITORY_OCCUPIED' | 'PANAMA' | 'PAPUA_NEW_GUINEA' | 'PARAGUAY' | 'PERU' | 'PHILIPPINES' | 'PITCAIRN' | 'POLAND' | 'PORTUGAL' | 'PUERTO_RICO' | 'QATAR' | 'ROMANIA' | 'RUSSIAN_FEDERATION' | 'RWANDA' | 'RÉUNION' | 'SAINT_BARTHÉLEMY_BL' | 'SAINT_HELENA' | 'SAINT_KITTS_AND_NEVIS' | 'SAINT_LUCIA' | 'SAINT_MARTIN_FRENCH_PART' | 'SAINT_PIERRE_AND_MIQUELON' | 'SAINT_VINCENT_AND_THE_GRENADINES' | 'SAMOA' | 'SAN_MARINO' | 'SAO_TOME_AND_PRINCIPE' | 'SAUDI_ARABIA' | 'SENEGAL' | 'SERBIA' | 'SEYCHELLES' | 'SIERRA_LEONE' | 'SINGAPORE' | 'SINT_MAARTEN_DUTCH_PART' | 'SLOVAKIA' | 'SLOVENIA' | 'SOLOMON_ISLANDS' | 'SOMALIA' | 'SOUTH_AFRICA' | 'SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS' | 'SOUTH_SUDAN' | 'SPAIN' | 'SRI_LANKA' | 'SUDAN' | 'SURINAME' | 'SVALBARD_AND_JAN_MAYEN' | 'SWAZILAND' | 'SWEDEN' | 'SWITZERLAND' | 'SYRIAN_ARAB_REPUBLIC' | 'TAIWAN' | 'TAJIKISTAN' | 'THAILAND' | 'THE_FORMER_YUGOSLAV_REPUBLIC_OF_MACEDONIA' | 'TOGO' | 'TOKELAU' | 'TONGA' | 'TRINIDAD_AND_TOBAGO' | 'TUNISIA' | 'TURKEY' | 'TURKMENISTAN' | 'TURKS_AND_CAICOS_ISLANDS' | 'TUVALU' | 'UGANDA' | 'UKRAINE' | 'UNITED_ARAB_EMIRATES' | 'UNITED_KINGDOM' | 'UNITED_REPUBLIC_OF_TANZANIA' | 'UNITED_STATES_MINOR_OUTLYING_ISLANDS' | 'URUGUAY' | 'USA' | 'UZBEKISTAN' | 'VANUATU' | 'VATICAN_CITY_STATE' | 'VENEZUELA' | 'VIET_NAM' | 'VIRGIN_ISLANDS_GB' | 'VIRGIN_ISLANDS_USA' | 'WALLIS_AND_FUTUNA' | 'WESTERN_SAHARA' | 'YEMEN' | 'ZAMBIA' | 'ZIMBABWE' | null
}
export type BankAccountEntityGridRowCurrency = {
 [BankAccountEntityGridRowProp.Currency] : 'USD' | 'EUR' | 'GBP' | 'CAD' | 'JPY' | 'AED' | 'PLN' | 'AZN' | 'INR' | 'NZD' | 'CUP' | 'EGP' | 'LBP' | 'RMB' | 'AUD' | 'ILS' | 'RON' | 'CHF' | 'CZK' | 'DKK' | 'RUB' | 'BGN' | 'HRK' | 'CNY' | 'MXN' | 'CLP' | 'ALL' | 'NOK' | 'SEK' | 'HUF' | 'BRL' | 'ZAR' | 'HKD' | 'SGD' | 'THB' | 'TRY' | 'KRW' | 'SKK' | 'LKR' | 'COP' | 'VND' | 'CNH' | 'SAR' | 'MYR' | 'USDT' | 'LOCAL_CURRENCY' | null
}
export type BankAccountEntityGridRowIban = {
 [BankAccountEntityGridRowProp.Iban] : string | null
}
export type BankAccountEntityGridRowId = {
 [BankAccountEntityGridRowProp.Id] : number
}
export type BankAccountEntityGridRowName = {
 [BankAccountEntityGridRowProp.Name] : string | null
}
export type BankAccountEntityGridRowPaymentAccountStatus = {
 [BankAccountEntityGridRowProp.PaymentAccountStatus] : 'PENDING' | 'APPROVED' | 'REJECTED' | 'BLACK_LISTED' | 'REVOKE_PENDING' | null
}
export type BankAccountEntityGridRow = 
 Partial<BankAccountEntityGridRowAccountNumber> & 
 Partial<BankAccountEntityGridRowBankName> & 
 Partial<BankAccountEntityGridRowBeneficiaryName> & 
 Partial<BankAccountEntityGridRowCountry> & 
 Partial<BankAccountEntityGridRowCurrency> & 
 Partial<BankAccountEntityGridRowIban> & 
 BankAccountEntityGridRowId & 
 Partial<BankAccountEntityGridRowName> & 
 Partial<BankAccountEntityGridRowPaymentAccountStatus>

export enum BaseTransactionEntityGridRowProp {
 Auth3D = 'auth3D',
 BaseCurrencyAmount = 'baseCurrencyAmount',
 BaseCurrencyConvRate = 'baseCurrencyConvRate',
 BonusDataAdjustedAmount = 'bonusData.adjustedAmount',
 BonusExpirationDate = 'bonusExpirationDate',
 CcExpDate = 'ccExpDate',
 CcNumber = 'ccNumber',
 CreationTime = 'creationTime',
 CustomerBrandCompanyName = 'customer.brand.company.name',
 CustomerBrandName = 'customer.brand.name',
 CustomerId = 'customer.id',
 CustomerPersonCountry = 'customer.person.country',
 CustomerPersonName = 'customer.person.name',
 Ecdd = 'ecdd',
 ExternalId = 'externalId',
 Id = 'id',
 ModificationTime = 'modificationTime',
 ModifiedBy = 'modifiedBy',
 ReasonInternalReason = 'reason.internalReason',
 SourceAmount = 'source.amount',
 SourceCurrency = 'source.currency',
 SourceError = 'source.error',
 Status = 'status',
 TargetAmount = 'target.amount',
 TargetCurrency = 'target.currency',
 TargetCurrencyConvRate = 'targetCurrencyConvRate',
 TransactionType = 'transactionType',
 TxSubType = 'txSubType'
}
export type BaseTransactionEntityGridRowAuth3D = {
 [BaseTransactionEntityGridRowProp.Auth3D] : boolean | null
}
export type BaseTransactionEntityGridRowBaseCurrencyAmount = {
 [BaseTransactionEntityGridRowProp.BaseCurrencyAmount] : number | null
}
export type BaseTransactionEntityGridRowBaseCurrencyConvRate = {
 [BaseTransactionEntityGridRowProp.BaseCurrencyConvRate] : number | null
}
export type BaseTransactionEntityGridRowBonusDataAdjustedAmount = {
 [BaseTransactionEntityGridRowProp.BonusDataAdjustedAmount] : number | null
}
export type BaseTransactionEntityGridRowBonusExpirationDate = {
 [BaseTransactionEntityGridRowProp.BonusExpirationDate] : number | null
}
export type BaseTransactionEntityGridRowCcExpDate = {
 [BaseTransactionEntityGridRowProp.CcExpDate] : string | null
}
export type BaseTransactionEntityGridRowCcNumber = {
 [BaseTransactionEntityGridRowProp.CcNumber] : string | null
}
export type BaseTransactionEntityGridRowCreationTime = {
 [BaseTransactionEntityGridRowProp.CreationTime] : number | null
}
export type BaseTransactionEntityGridRowCustomerBrandCompanyName = {
 [BaseTransactionEntityGridRowProp.CustomerBrandCompanyName] : string | null
}
export type BaseTransactionEntityGridRowCustomerBrandName = {
 [BaseTransactionEntityGridRowProp.CustomerBrandName] : string | null
}
export type BaseTransactionEntityGridRowCustomerId = {
 [BaseTransactionEntityGridRowProp.CustomerId] : number | null
}
export type BaseTransactionEntityGridRowCustomerPersonCountry = {
 [BaseTransactionEntityGridRowProp.CustomerPersonCountry] : 'NA' | 'AFGHANISTAN' | 'ÅLAND_ISLANDS' | 'ALBANIA' | 'ALGERIA' | 'AMERICAN_SAMOA' | 'ANDORRA' | 'ANGOLA' | 'ANGUILLA' | 'ANTARCTICA' | 'ANTIGUA_AND_BARBUDA' | 'ARGENTINA' | 'ARMENIA' | 'ARUBA' | 'AUSTRALIA' | 'AUSTRIA' | 'AZERBAIJAN' | 'BAHAMAS' | 'BAHRAIN' | 'BANGLADESH' | 'BARBADOS' | 'BELARUS' | 'BELGIUM' | 'BELIZE' | 'BENIN' | 'BERMUDA' | 'BHUTAN' | 'BOLIVIA' | 'BONAIRE_SINT_EUSTATIUS_AND_SABA' | 'BOSNIA_AND_HERZEGOVINA' | 'BOTSWANA' | 'BOUVET_ISLAND' | 'BRAZIL' | 'BRITISH_INDIAN_OCEAN_TERRITORY' | 'BRUNEI_DARUSSALAM' | 'BULGARIA' | 'BURKINA_FASO' | 'BURUNDI' | 'CAMBODIA' | 'CAMEROON' | 'CANADA' | 'CAPE_VERDE' | 'CAYMAN_ISLANDS' | 'CENTRAL_AFRICAN_REPUBLIC' | 'CHAD' | 'CHILE' | 'CHINA' | 'CHRISTMAS_ISLAND' | 'COCOS_ISLANDS' | 'COLOMBIA' | 'COMOROS' | 'CONGO' | 'CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE' | 'COOK_ISLANDS' | 'COSTA_RICA' | 'CROATIA' | 'CUBA' | 'CURAÇAO' | 'CYPRUS' | 'CZECH_REPUBLIC' | 'CÔTE_DIVOIRE' | 'DENMARK' | 'DJIBOUTI' | 'DOMINICA' | 'DOMINICAN_REPUBLIC' | 'EAST_TIMOR' | 'ECUADOR' | 'EGYPT' | 'EL_SALVADOR' | 'EQUATORIAL_GUINEA' | 'ERITREA' | 'ESTONIA' | 'ETHIOPIA' | 'FALKLAND_ISLANDS' | 'FAROE_ISLANDS' | 'FIJI' | 'FINLAND' | 'FRANCE' | 'FRENCH_GUIANA' | 'FRENCH_POLYNESIA' | 'FRENCH_SOUTHERN_TERRITORIES' | 'GABON' | 'GAMBIA' | 'Georgia' | 'GERMANY' | 'GHANA' | 'GIBRALTAR' | 'GREECE' | 'GREENLAND' | 'GRENADA' | 'GUADELOUPE' | 'GUAM' | 'GUATEMALA' | 'GUERNSEY' | 'GUINEA' | 'GUINEA_BISSAU' | 'GUYANA' | 'HAITI' | 'HEARD_ISLAND_AND_MCDONALD_ISLANDS' | 'HONDURAS' | 'HONG_KONG' | 'Hungary' | 'ICELAND' | 'INDIA' | 'INDONESIA' | 'IRAN' | 'IRAQ' | 'IRELAND' | 'ISLE_OF_MAN' | 'ISRAEL' | 'ITALY' | 'JAMAICA' | 'JAPAN' | 'JERSEY' | 'JORDAN' | 'KAZAKHSTAN' | 'KENYA' | 'KIRIBATI' | 'KOSOVO' | 'KOREA_DEMOCRATIC_PEOPLE_REPUBLIC_OF' | 'KOREA_REPUBLIC_OF' | 'KUWAIT' | 'KYRGYZSTAN' | 'LAO_PEOPLE_DEMOCRATIC_REPUBLIC' | 'LATVIA' | 'LEBANON' | 'LESOTHO' | 'LIBERIA' | 'LIBYAN' | 'LIECHTENSTEIN' | 'LITHUANIA' | 'LUXEMBOURG' | 'MACAO' | 'MADAGASCAR' | 'MALAWI' | 'MALAYSIA' | 'MALDIVES' | 'MALI' | 'MALTA' | 'MARSHALL_ISLANDS' | 'MARTINIQUE' | 'MAURITANIA' | 'MAURITIUS' | 'MAYOTTE' | 'MEXICO' | 'MICRONESIA' | 'MOLDOVA_REPUBLIC_OF' | 'MONACO' | 'MONGOLIA' | 'MONTENEGRO' | 'MONTSERRAT' | 'MOROCCO' | 'MOZAMBIQUE' | 'MYANMAR' | 'NAMIBIA' | 'NAURU' | 'NEPAL' | 'NETHERLANDS' | 'NETHERLANDS_ANTILLES' | 'NEW_CALEDONIA' | 'NEW_ZEALAND' | 'NICARAGUA' | 'NIGER' | 'NIGERIA' | 'NIUE' | 'NORFOLK_ISLAND' | 'NORTHERN_MARIANA_ISLANDS' | 'NORWAY' | 'OMAN' | 'PAKISTAN' | 'PALAU' | 'PALESTINIAN_TERRITORY_OCCUPIED' | 'PANAMA' | 'PAPUA_NEW_GUINEA' | 'PARAGUAY' | 'PERU' | 'PHILIPPINES' | 'PITCAIRN' | 'POLAND' | 'PORTUGAL' | 'PUERTO_RICO' | 'QATAR' | 'ROMANIA' | 'RUSSIAN_FEDERATION' | 'RWANDA' | 'RÉUNION' | 'SAINT_BARTHÉLEMY_BL' | 'SAINT_HELENA' | 'SAINT_KITTS_AND_NEVIS' | 'SAINT_LUCIA' | 'SAINT_MARTIN_FRENCH_PART' | 'SAINT_PIERRE_AND_MIQUELON' | 'SAINT_VINCENT_AND_THE_GRENADINES' | 'SAMOA' | 'SAN_MARINO' | 'SAO_TOME_AND_PRINCIPE' | 'SAUDI_ARABIA' | 'SENEGAL' | 'SERBIA' | 'SEYCHELLES' | 'SIERRA_LEONE' | 'SINGAPORE' | 'SINT_MAARTEN_DUTCH_PART' | 'SLOVAKIA' | 'SLOVENIA' | 'SOLOMON_ISLANDS' | 'SOMALIA' | 'SOUTH_AFRICA' | 'SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS' | 'SOUTH_SUDAN' | 'SPAIN' | 'SRI_LANKA' | 'SUDAN' | 'SURINAME' | 'SVALBARD_AND_JAN_MAYEN' | 'SWAZILAND' | 'SWEDEN' | 'SWITZERLAND' | 'SYRIAN_ARAB_REPUBLIC' | 'TAIWAN' | 'TAJIKISTAN' | 'THAILAND' | 'THE_FORMER_YUGOSLAV_REPUBLIC_OF_MACEDONIA' | 'TOGO' | 'TOKELAU' | 'TONGA' | 'TRINIDAD_AND_TOBAGO' | 'TUNISIA' | 'TURKEY' | 'TURKMENISTAN' | 'TURKS_AND_CAICOS_ISLANDS' | 'TUVALU' | 'UGANDA' | 'UKRAINE' | 'UNITED_ARAB_EMIRATES' | 'UNITED_KINGDOM' | 'UNITED_REPUBLIC_OF_TANZANIA' | 'UNITED_STATES_MINOR_OUTLYING_ISLANDS' | 'URUGUAY' | 'USA' | 'UZBEKISTAN' | 'VANUATU' | 'VATICAN_CITY_STATE' | 'VENEZUELA' | 'VIET_NAM' | 'VIRGIN_ISLANDS_GB' | 'VIRGIN_ISLANDS_USA' | 'WALLIS_AND_FUTUNA' | 'WESTERN_SAHARA' | 'YEMEN' | 'ZAMBIA' | 'ZIMBABWE' | null
}
export type BaseTransactionEntityGridRowCustomerPersonName = {
 [BaseTransactionEntityGridRowProp.CustomerPersonName] : string | null
}
export type BaseTransactionEntityGridRowEcdd = {
 [BaseTransactionEntityGridRowProp.Ecdd] : boolean | null
}
export type BaseTransactionEntityGridRowExternalId = {
 [BaseTransactionEntityGridRowProp.ExternalId] : string | null
}
export type BaseTransactionEntityGridRowId = {
 [BaseTransactionEntityGridRowProp.Id] : number
}
export type BaseTransactionEntityGridRowModificationTime = {
 [BaseTransactionEntityGridRowProp.ModificationTime] : number | null
}
export type BaseTransactionEntityGridRowModifiedBy = {
 [BaseTransactionEntityGridRowProp.ModifiedBy] : string | null
}
export type BaseTransactionEntityGridRowReasonInternalReason = {
 [BaseTransactionEntityGridRowProp.ReasonInternalReason] : string | null
}
export type BaseTransactionEntityGridRowSourceAmount = {
 [BaseTransactionEntityGridRowProp.SourceAmount] : number | null
}
export type BaseTransactionEntityGridRowSourceCurrency = {
 [BaseTransactionEntityGridRowProp.SourceCurrency] : 'USD' | 'EUR' | 'GBP' | 'CAD' | 'JPY' | 'AED' | 'PLN' | 'AZN' | 'INR' | 'NZD' | 'CUP' | 'EGP' | 'LBP' | 'RMB' | 'AUD' | 'ILS' | 'RON' | 'CHF' | 'CZK' | 'DKK' | 'RUB' | 'BGN' | 'HRK' | 'CNY' | 'MXN' | 'CLP' | 'ALL' | 'NOK' | 'SEK' | 'HUF' | 'BRL' | 'ZAR' | 'HKD' | 'SGD' | 'THB' | 'TRY' | 'KRW' | 'SKK' | 'LKR' | 'COP' | 'VND' | 'CNH' | 'SAR' | 'MYR' | 'USDT' | 'LOCAL_CURRENCY' | null
}
export type BaseTransactionEntityGridRowSourceError = {
 [BaseTransactionEntityGridRowProp.SourceError] : string | null
}
export type BaseTransactionEntityGridRowStatus = {
 [BaseTransactionEntityGridRowProp.Status] : 'PENDING' | 'PENDING_COMPLIANCE' | 'DONE' | 'FAILED' | 'REJECTED' | 'PENDING_PM_APPROVAL' | 'CANCELLED_PENDING_PM_APPROVAL' | 'CANCELLED_PENDING_COMPLIANCE' | null
}
export type BaseTransactionEntityGridRowTargetAmount = {
 [BaseTransactionEntityGridRowProp.TargetAmount] : number | null
}
export type BaseTransactionEntityGridRowTargetCurrency = {
 [BaseTransactionEntityGridRowProp.TargetCurrency] : 'USD' | 'EUR' | 'GBP' | 'CAD' | 'JPY' | 'AED' | 'PLN' | 'AZN' | 'INR' | 'NZD' | 'CUP' | 'EGP' | 'LBP' | 'RMB' | 'AUD' | 'ILS' | 'RON' | 'CHF' | 'CZK' | 'DKK' | 'RUB' | 'BGN' | 'HRK' | 'CNY' | 'MXN' | 'CLP' | 'ALL' | 'NOK' | 'SEK' | 'HUF' | 'BRL' | 'ZAR' | 'HKD' | 'SGD' | 'THB' | 'TRY' | 'KRW' | 'SKK' | 'LKR' | 'COP' | 'VND' | 'CNH' | 'SAR' | 'MYR' | 'USDT' | 'LOCAL_CURRENCY' | null
}
export type BaseTransactionEntityGridRowTargetCurrencyConvRate = {
 [BaseTransactionEntityGridRowProp.TargetCurrencyConvRate] : number | null
}
export type BaseTransactionEntityGridRowTransactionType = {
 [BaseTransactionEntityGridRowProp.TransactionType] : 'DEPOSIT' | 'WITHDRAWAL' | 'CORRECTION' | null
}
export type BaseTransactionEntityGridRowTxSubType = {
 [BaseTransactionEntityGridRowProp.TxSubType] : 'NEGATIVE_ADJUSTMENT' | 'NEGATIVE_DEALING_CORRECTION' | 'NEGATIVE_FRAUD_ADJUSTMENT' | 'NEGATIVE_BONUS_ADJUSTMENT' | 'CLOSING_ACCOUNT_BOOK_NEGATIVE' | 'PARTNER_NEGATIVE_ADJUSTMENT' | 'POSITIVE_ADJUSTMENT' | 'POSITIVE_DEALING_CORRECTION' | 'POSITIVE_FRAUD_ADJUSTMENT' | 'POSITIVE_BONUS_ADJUSTMENT' | 'CLOSING_ACCOUNT_BOOK_POSITIVE' | 'PARTNER_PAYMENT' | 'PARTNER_BONUS' | 'BONUS' | 'CREDIT_CARD_DEPOSIT' | 'WIRE_TRANSFER_DEPOSIT' | 'CREDIT_CREDIT_CARD_WITHDRAWAL' | 'VOID_CREDIT_CARD_WITHDRAWAL' | 'REFUND_CREDIT_CARD_WITHDRAWAL' | 'WIRE_TRANSFER_WITHDRAWAL' | 'MANUAL_DEPOSIT' | 'INTERNAL_DEPOSIT' | 'MANUAL_WITHDRAWAL' | 'INTERNAL_WITHDRAWAL' | 'LIBERTY_RESERVE_DEPOSIT' | 'LIBERTY_RESERVE_WITHDRAWAL' | 'ENVOY_DEPOSIT' | 'ENVOY_WITHDRAWAL' | 'WM_WITHDRAWAL' | 'NETELLER_DEPOSIT' | 'MONEYBOOKERS_DEPOSIT' | 'QIWI_DEPOSIT' | 'WEBMONEY_DEPOSIT' | 'CHINAUNION_DEPOSIT' | 'CUP_DEPOSIT' | 'CHINAUNION_WITHDRAWAL' | 'LOBANET_DEPOSIT' | 'QIWI_WITHDRAWAL' | 'PSP_DEPOSIT' | 'BAOFOO_DEPOSIT' | 'SOLIDPAY_DEPOSIT' | 'FOCAL_DEPOSIT' | 'PAYGATE_DEPOSIT' | 'PAYMENT_ASIA_DEPOSIT' | 'CRYPTO_WITHDRAWAL' | 'MD_APM_WITHDRAWAL' | null
}
export type BaseTransactionEntityGridRow = 
 Partial<BaseTransactionEntityGridRowAuth3D> & 
 Partial<BaseTransactionEntityGridRowBaseCurrencyAmount> & 
 Partial<BaseTransactionEntityGridRowBaseCurrencyConvRate> & 
 Partial<BaseTransactionEntityGridRowBonusDataAdjustedAmount> & 
 Partial<BaseTransactionEntityGridRowBonusExpirationDate> & 
 Partial<BaseTransactionEntityGridRowCcExpDate> & 
 Partial<BaseTransactionEntityGridRowCcNumber> & 
 Partial<BaseTransactionEntityGridRowCreationTime> & 
 Partial<BaseTransactionEntityGridRowCustomerBrandCompanyName> & 
 Partial<BaseTransactionEntityGridRowCustomerBrandName> & 
 Partial<BaseTransactionEntityGridRowCustomerId> & 
 Partial<BaseTransactionEntityGridRowCustomerPersonCountry> & 
 Partial<BaseTransactionEntityGridRowCustomerPersonName> & 
 Partial<BaseTransactionEntityGridRowEcdd> & 
 Partial<BaseTransactionEntityGridRowExternalId> & 
 BaseTransactionEntityGridRowId & 
 Partial<BaseTransactionEntityGridRowModificationTime> & 
 Partial<BaseTransactionEntityGridRowModifiedBy> & 
 Partial<BaseTransactionEntityGridRowReasonInternalReason> & 
 Partial<BaseTransactionEntityGridRowSourceAmount> & 
 BaseTransactionEntityGridRowSourceCurrency & 
 Partial<BaseTransactionEntityGridRowSourceError> & 
 Partial<BaseTransactionEntityGridRowStatus> & 
 Partial<BaseTransactionEntityGridRowTargetAmount> & 
 BaseTransactionEntityGridRowTargetCurrency & 
 Partial<BaseTransactionEntityGridRowTargetCurrencyConvRate> & 
 Partial<BaseTransactionEntityGridRowTransactionType> & 
 Partial<BaseTransactionEntityGridRowTxSubType>

export enum BonusRequestEntityGridRowProp {
 __bonusRequestButtons = '__bonusRequestButtons',
 BonusRequestType = 'bonusRequestType',
 CreationTime = 'creationTime',
 ExpirationPeriod = 'expirationPeriod',
 Id = 'id',
 Status = 'status',
 TargetAmount = 'targetAmount',
 TargetCurrency = 'targetCurrency',
 TargetPoints = 'targetPoints',
 TradingAccountPlatformAccountId = 'tradingAccount.platformAccountId',
 TransactionReason = 'transactionReason'
}
export type BonusRequestEntityGridRow__bonusRequestButtons = {
 [BonusRequestEntityGridRowProp.__bonusRequestButtons] : string | null
}
export type BonusRequestEntityGridRowBonusRequestType = {
 [BonusRequestEntityGridRowProp.BonusRequestType] : 'MANUAL_BONUS' | 'PENDING_BONUS' | 'AUTOMATIC_BONUS' | 'COMPLIANCE_BONUS' | 'INSTANT_COMPLIANCE_BONUS' | 'ELIGIBLE_COMPLIANCE_BONUS' | 'SAS_PENDING_BONUS' | 'VERIFIED_ID_BONUS' | 'VERIFIED_RESIDENCE_BONUS' | 'FULL_REGISTRATION_BONUS' | 'COMPLETE_VERIFICATION_BONUS' | 'DEPOSIT_BONUS' | 'FIRST_DEPOSIT_BONUS' | 'EXTRA_FIRST_DEPOSIT_BONUS' | 'QUIZ_ASIC_BONUS' | 'WEB_TO_MOBILE_BONUS' | 'CUSTOMER_LEVEL_FIRST_DEPOSIT_BONUS' | 'FULL_REGISTRATION_CASH_BONUS' | null
}
export type BonusRequestEntityGridRowCreationTime = {
 [BonusRequestEntityGridRowProp.CreationTime] : number | null
}
export type BonusRequestEntityGridRowExpirationPeriod = {
 [BonusRequestEntityGridRowProp.ExpirationPeriod] : number | null
}
export type BonusRequestEntityGridRowId = {
 [BonusRequestEntityGridRowProp.Id] : number
}
export type BonusRequestEntityGridRowStatus = {
 [BonusRequestEntityGridRowProp.Status] : 'ON_HOLD' | 'DECLINED' | 'ACCEPTED' | 'PENDING_DEPOSIT' | null
}
export type BonusRequestEntityGridRowTargetAmount = {
 [BonusRequestEntityGridRowProp.TargetAmount] : number | null
}
export type BonusRequestEntityGridRowTargetCurrency = {
 [BonusRequestEntityGridRowProp.TargetCurrency] : 'USD' | 'EUR' | 'GBP' | 'CAD' | 'JPY' | 'AED' | 'PLN' | 'AZN' | 'INR' | 'NZD' | 'CUP' | 'EGP' | 'LBP' | 'RMB' | 'AUD' | 'ILS' | 'RON' | 'CHF' | 'CZK' | 'DKK' | 'RUB' | 'BGN' | 'HRK' | 'CNY' | 'MXN' | 'CLP' | 'ALL' | 'NOK' | 'SEK' | 'HUF' | 'BRL' | 'ZAR' | 'HKD' | 'SGD' | 'THB' | 'TRY' | 'KRW' | 'SKK' | 'LKR' | 'COP' | 'VND' | 'CNH' | 'SAR' | 'MYR' | 'USDT' | 'LOCAL_CURRENCY' | null
}
export type BonusRequestEntityGridRowTargetPoints = {
 [BonusRequestEntityGridRowProp.TargetPoints] : number | null
}
export type BonusRequestEntityGridRowTradingAccountPlatformAccountId = {
 [BonusRequestEntityGridRowProp.TradingAccountPlatformAccountId] : string | null
}
export type BonusRequestEntityGridRowTransactionReason = {
 [BonusRequestEntityGridRowProp.TransactionReason] : any /* Entity */
}
export type BonusRequestEntityGridRow = 
 Partial<BonusRequestEntityGridRow__bonusRequestButtons> & 
 Partial<BonusRequestEntityGridRowBonusRequestType> & 
 Partial<BonusRequestEntityGridRowCreationTime> & 
 Partial<BonusRequestEntityGridRowExpirationPeriod> & 
 BonusRequestEntityGridRowId & 
 Partial<BonusRequestEntityGridRowStatus> & 
 Partial<BonusRequestEntityGridRowTargetAmount> & 
 BonusRequestEntityGridRowTargetCurrency & 
 Partial<BonusRequestEntityGridRowTargetPoints> & 
 Partial<BonusRequestEntityGridRowTradingAccountPlatformAccountId> & 
 Partial<BonusRequestEntityGridRowTransactionReason>

export enum CallTaskEntityGridRowProp {
 AssignedPoolName = 'assignedPool.name',
 AssignedUser = 'assignedUser',
 CreationTime = 'creationTime',
 Creator = 'creator',
 Customer = 'customer',
 CustomerBusinessDomain = 'customer.businessDomain',
 CustomerPersonCountry = 'customer.person.country',
 CustomerPersonLanguage = 'customer.person.language',
 CustomerRegistrationStatus = 'customer.registrationStatus',
 CustomerTotalDeposits = 'customer.totalDeposits',
 CustomerTotalWithdrawals = 'customer.totalWithdrawals',
 DueDate = 'dueDate',
 Id = 'id',
 ModificationTime = 'modificationTime',
 ModifiedBy = 'modifiedBy',
 Priority = 'priority',
 ReminderDate = 'reminderDate',
 StartDate = 'startDate',
 Status = 'status',
 Subject = 'subject',
 TaskCategoryLabel = 'taskCategory.label'
}
export type CallTaskEntityGridRowAssignedPoolName = {
 [CallTaskEntityGridRowProp.AssignedPoolName] : string | null
}
export type CallTaskEntityGridRowAssignedUser = {
 [CallTaskEntityGridRowProp.AssignedUser] : any /* Entity */
}
export type CallTaskEntityGridRowCreationTime = {
 [CallTaskEntityGridRowProp.CreationTime] : number | null
}
export type CallTaskEntityGridRowCreator = {
 [CallTaskEntityGridRowProp.Creator] : any /* Entity */
}
export type CallTaskEntityGridRowCustomer = {
 [CallTaskEntityGridRowProp.Customer] : any /* Entity */
}
export type CallTaskEntityGridRowCustomerBusinessDomain = {
 [CallTaskEntityGridRowProp.CustomerBusinessDomain] : any /* Entity */
}
export type CallTaskEntityGridRowCustomerPersonCountry = {
 [CallTaskEntityGridRowProp.CustomerPersonCountry] : 'NA' | 'AFGHANISTAN' | 'ÅLAND_ISLANDS' | 'ALBANIA' | 'ALGERIA' | 'AMERICAN_SAMOA' | 'ANDORRA' | 'ANGOLA' | 'ANGUILLA' | 'ANTARCTICA' | 'ANTIGUA_AND_BARBUDA' | 'ARGENTINA' | 'ARMENIA' | 'ARUBA' | 'AUSTRALIA' | 'AUSTRIA' | 'AZERBAIJAN' | 'BAHAMAS' | 'BAHRAIN' | 'BANGLADESH' | 'BARBADOS' | 'BELARUS' | 'BELGIUM' | 'BELIZE' | 'BENIN' | 'BERMUDA' | 'BHUTAN' | 'BOLIVIA' | 'BONAIRE_SINT_EUSTATIUS_AND_SABA' | 'BOSNIA_AND_HERZEGOVINA' | 'BOTSWANA' | 'BOUVET_ISLAND' | 'BRAZIL' | 'BRITISH_INDIAN_OCEAN_TERRITORY' | 'BRUNEI_DARUSSALAM' | 'BULGARIA' | 'BURKINA_FASO' | 'BURUNDI' | 'CAMBODIA' | 'CAMEROON' | 'CANADA' | 'CAPE_VERDE' | 'CAYMAN_ISLANDS' | 'CENTRAL_AFRICAN_REPUBLIC' | 'CHAD' | 'CHILE' | 'CHINA' | 'CHRISTMAS_ISLAND' | 'COCOS_ISLANDS' | 'COLOMBIA' | 'COMOROS' | 'CONGO' | 'CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE' | 'COOK_ISLANDS' | 'COSTA_RICA' | 'CROATIA' | 'CUBA' | 'CURAÇAO' | 'CYPRUS' | 'CZECH_REPUBLIC' | 'CÔTE_DIVOIRE' | 'DENMARK' | 'DJIBOUTI' | 'DOMINICA' | 'DOMINICAN_REPUBLIC' | 'EAST_TIMOR' | 'ECUADOR' | 'EGYPT' | 'EL_SALVADOR' | 'EQUATORIAL_GUINEA' | 'ERITREA' | 'ESTONIA' | 'ETHIOPIA' | 'FALKLAND_ISLANDS' | 'FAROE_ISLANDS' | 'FIJI' | 'FINLAND' | 'FRANCE' | 'FRENCH_GUIANA' | 'FRENCH_POLYNESIA' | 'FRENCH_SOUTHERN_TERRITORIES' | 'GABON' | 'GAMBIA' | 'Georgia' | 'GERMANY' | 'GHANA' | 'GIBRALTAR' | 'GREECE' | 'GREENLAND' | 'GRENADA' | 'GUADELOUPE' | 'GUAM' | 'GUATEMALA' | 'GUERNSEY' | 'GUINEA' | 'GUINEA_BISSAU' | 'GUYANA' | 'HAITI' | 'HEARD_ISLAND_AND_MCDONALD_ISLANDS' | 'HONDURAS' | 'HONG_KONG' | 'Hungary' | 'ICELAND' | 'INDIA' | 'INDONESIA' | 'IRAN' | 'IRAQ' | 'IRELAND' | 'ISLE_OF_MAN' | 'ISRAEL' | 'ITALY' | 'JAMAICA' | 'JAPAN' | 'JERSEY' | 'JORDAN' | 'KAZAKHSTAN' | 'KENYA' | 'KIRIBATI' | 'KOSOVO' | 'KOREA_DEMOCRATIC_PEOPLE_REPUBLIC_OF' | 'KOREA_REPUBLIC_OF' | 'KUWAIT' | 'KYRGYZSTAN' | 'LAO_PEOPLE_DEMOCRATIC_REPUBLIC' | 'LATVIA' | 'LEBANON' | 'LESOTHO' | 'LIBERIA' | 'LIBYAN' | 'LIECHTENSTEIN' | 'LITHUANIA' | 'LUXEMBOURG' | 'MACAO' | 'MADAGASCAR' | 'MALAWI' | 'MALAYSIA' | 'MALDIVES' | 'MALI' | 'MALTA' | 'MARSHALL_ISLANDS' | 'MARTINIQUE' | 'MAURITANIA' | 'MAURITIUS' | 'MAYOTTE' | 'MEXICO' | 'MICRONESIA' | 'MOLDOVA_REPUBLIC_OF' | 'MONACO' | 'MONGOLIA' | 'MONTENEGRO' | 'MONTSERRAT' | 'MOROCCO' | 'MOZAMBIQUE' | 'MYANMAR' | 'NAMIBIA' | 'NAURU' | 'NEPAL' | 'NETHERLANDS' | 'NETHERLANDS_ANTILLES' | 'NEW_CALEDONIA' | 'NEW_ZEALAND' | 'NICARAGUA' | 'NIGER' | 'NIGERIA' | 'NIUE' | 'NORFOLK_ISLAND' | 'NORTHERN_MARIANA_ISLANDS' | 'NORWAY' | 'OMAN' | 'PAKISTAN' | 'PALAU' | 'PALESTINIAN_TERRITORY_OCCUPIED' | 'PANAMA' | 'PAPUA_NEW_GUINEA' | 'PARAGUAY' | 'PERU' | 'PHILIPPINES' | 'PITCAIRN' | 'POLAND' | 'PORTUGAL' | 'PUERTO_RICO' | 'QATAR' | 'ROMANIA' | 'RUSSIAN_FEDERATION' | 'RWANDA' | 'RÉUNION' | 'SAINT_BARTHÉLEMY_BL' | 'SAINT_HELENA' | 'SAINT_KITTS_AND_NEVIS' | 'SAINT_LUCIA' | 'SAINT_MARTIN_FRENCH_PART' | 'SAINT_PIERRE_AND_MIQUELON' | 'SAINT_VINCENT_AND_THE_GRENADINES' | 'SAMOA' | 'SAN_MARINO' | 'SAO_TOME_AND_PRINCIPE' | 'SAUDI_ARABIA' | 'SENEGAL' | 'SERBIA' | 'SEYCHELLES' | 'SIERRA_LEONE' | 'SINGAPORE' | 'SINT_MAARTEN_DUTCH_PART' | 'SLOVAKIA' | 'SLOVENIA' | 'SOLOMON_ISLANDS' | 'SOMALIA' | 'SOUTH_AFRICA' | 'SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS' | 'SOUTH_SUDAN' | 'SPAIN' | 'SRI_LANKA' | 'SUDAN' | 'SURINAME' | 'SVALBARD_AND_JAN_MAYEN' | 'SWAZILAND' | 'SWEDEN' | 'SWITZERLAND' | 'SYRIAN_ARAB_REPUBLIC' | 'TAIWAN' | 'TAJIKISTAN' | 'THAILAND' | 'THE_FORMER_YUGOSLAV_REPUBLIC_OF_MACEDONIA' | 'TOGO' | 'TOKELAU' | 'TONGA' | 'TRINIDAD_AND_TOBAGO' | 'TUNISIA' | 'TURKEY' | 'TURKMENISTAN' | 'TURKS_AND_CAICOS_ISLANDS' | 'TUVALU' | 'UGANDA' | 'UKRAINE' | 'UNITED_ARAB_EMIRATES' | 'UNITED_KINGDOM' | 'UNITED_REPUBLIC_OF_TANZANIA' | 'UNITED_STATES_MINOR_OUTLYING_ISLANDS' | 'URUGUAY' | 'USA' | 'UZBEKISTAN' | 'VANUATU' | 'VATICAN_CITY_STATE' | 'VENEZUELA' | 'VIET_NAM' | 'VIRGIN_ISLANDS_GB' | 'VIRGIN_ISLANDS_USA' | 'WALLIS_AND_FUTUNA' | 'WESTERN_SAHARA' | 'YEMEN' | 'ZAMBIA' | 'ZIMBABWE' | null
}
export type CallTaskEntityGridRowCustomerPersonLanguage = {
 [CallTaskEntityGridRowProp.CustomerPersonLanguage] : 'OTHER' | 'ALBANIAN' | 'ARABIC' | 'BULGARIAN' | 'CATALAN' | 'CHINESE' | 'CHINESETR' | 'CROATIAN' | 'CZECH' | 'DANISH' | 'DUTCH' | 'ENGLISH' | 'ESTONIAN' | 'FINNISH' | 'FRENCH' | 'GALICIAN' | 'GERMAN' | 'GREEK' | 'HEBREW' | 'HINDI' | 'HUNGARIAN' | 'INDONESIAN' | 'ITALIAN' | 'JAPANESE' | 'KOREAN' | 'LATVIAN' | 'LITHUANIAN' | 'MALAY' | 'MALTESE' | 'NORWEGIAN' | 'PERSIAN' | 'POLISH' | 'PORTUGUESE' | 'PUNJABI' | 'ROMANIAN' | 'RUSSIAN' | 'SERBIAN' | 'SLOVAK' | 'SLOVENIAN' | 'SPANISH' | 'SWEDISH' | 'TAGALOG' | 'THAI' | 'TURKISH' | 'UKRAINIAN' | 'URDU' | 'VIETNAMESE' | null
}
export type CallTaskEntityGridRowCustomerRegistrationStatus = {
 [CallTaskEntityGridRowProp.CustomerRegistrationStatus] : 'LEAD' | 'DEMO' | 'REAL' | 'REAL_FUNDED' | null
}
export type CallTaskEntityGridRowCustomerTotalDeposits = {
 [CallTaskEntityGridRowProp.CustomerTotalDeposits] : number | null
}
export type CallTaskEntityGridRowCustomerTotalWithdrawals = {
 [CallTaskEntityGridRowProp.CustomerTotalWithdrawals] : number | null
}
export type CallTaskEntityGridRowDueDate = {
 [CallTaskEntityGridRowProp.DueDate] : number | null
}
export type CallTaskEntityGridRowId = {
 [CallTaskEntityGridRowProp.Id] : number
}
export type CallTaskEntityGridRowModificationTime = {
 [CallTaskEntityGridRowProp.ModificationTime] : number | null
}
export type CallTaskEntityGridRowModifiedBy = {
 [CallTaskEntityGridRowProp.ModifiedBy] : string | null
}
export type CallTaskEntityGridRowPriority = {
 [CallTaskEntityGridRowProp.Priority] : 'HIGH' | 'MEDIUM' | 'LOW' | null
}
export type CallTaskEntityGridRowReminderDate = {
 [CallTaskEntityGridRowProp.ReminderDate] : number | null
}
export type CallTaskEntityGridRowStartDate = {
 [CallTaskEntityGridRowProp.StartDate] : number | null
}
export type CallTaskEntityGridRowStatus = {
 [CallTaskEntityGridRowProp.Status] : 'NEW' | 'IN_PROGRESS' | 'REJECTED' | 'FAILED' | 'RESOLVED' | 'CLOSED' | 'CANCELED' | null
}
export type CallTaskEntityGridRowSubject = {
 [CallTaskEntityGridRowProp.Subject] : string | null
}
export type CallTaskEntityGridRowTaskCategoryLabel = {
 [CallTaskEntityGridRowProp.TaskCategoryLabel] : string | null
}
export type CallTaskEntityGridRow = 
 Partial<CallTaskEntityGridRowAssignedPoolName> & 
 Partial<CallTaskEntityGridRowAssignedUser> & 
 Partial<CallTaskEntityGridRowCreationTime> & 
 Partial<CallTaskEntityGridRowCreator> & 
 Partial<CallTaskEntityGridRowCustomer> & 
 Partial<CallTaskEntityGridRowCustomerBusinessDomain> & 
 Partial<CallTaskEntityGridRowCustomerPersonCountry> & 
 Partial<CallTaskEntityGridRowCustomerPersonLanguage> & 
 Partial<CallTaskEntityGridRowCustomerRegistrationStatus> & 
 Partial<CallTaskEntityGridRowCustomerTotalDeposits> & 
 Partial<CallTaskEntityGridRowCustomerTotalWithdrawals> & 
 Partial<CallTaskEntityGridRowDueDate> & 
 CallTaskEntityGridRowId & 
 Partial<CallTaskEntityGridRowModificationTime> & 
 Partial<CallTaskEntityGridRowModifiedBy> & 
 Partial<CallTaskEntityGridRowPriority> & 
 Partial<CallTaskEntityGridRowReminderDate> & 
 Partial<CallTaskEntityGridRowStartDate> & 
 Partial<CallTaskEntityGridRowStatus> & 
 Partial<CallTaskEntityGridRowSubject> & 
 Partial<CallTaskEntityGridRowTaskCategoryLabel>

export enum ClientProfileNoteEntityGridRowProp {
 __profileReviewButtons = '__profileReviewButtons',
 CreatedBy = 'createdBy',
 CreationTime = 'creationTime',
 Id = 'id',
 ModificationTime = 'modificationTime',
 ModifiedBy = 'modifiedBy',
 Summary = 'summary'
}
export type ClientProfileNoteEntityGridRow__profileReviewButtons = {
 [ClientProfileNoteEntityGridRowProp.__profileReviewButtons] : string | null
}
export type ClientProfileNoteEntityGridRowCreatedBy = {
 [ClientProfileNoteEntityGridRowProp.CreatedBy] : string | null
}
export type ClientProfileNoteEntityGridRowCreationTime = {
 [ClientProfileNoteEntityGridRowProp.CreationTime] : number | null
}
export type ClientProfileNoteEntityGridRowId = {
 [ClientProfileNoteEntityGridRowProp.Id] : number
}
export type ClientProfileNoteEntityGridRowModificationTime = {
 [ClientProfileNoteEntityGridRowProp.ModificationTime] : number | null
}
export type ClientProfileNoteEntityGridRowModifiedBy = {
 [ClientProfileNoteEntityGridRowProp.ModifiedBy] : string | null
}
export type ClientProfileNoteEntityGridRowSummary = {
 [ClientProfileNoteEntityGridRowProp.Summary] : string | null
}
export type ClientProfileNoteEntityGridRow = 
 Partial<ClientProfileNoteEntityGridRow__profileReviewButtons> & 
 Partial<ClientProfileNoteEntityGridRowCreatedBy> & 
 Partial<ClientProfileNoteEntityGridRowCreationTime> & 
 ClientProfileNoteEntityGridRowId & 
 Partial<ClientProfileNoteEntityGridRowModificationTime> & 
 Partial<ClientProfileNoteEntityGridRowModifiedBy> & 
 Partial<ClientProfileNoteEntityGridRowSummary>

export enum CompanyEntityGridRowProp {
 Id = 'id',
 Name = 'name'
}
export type CompanyEntityGridRowId = {
 [CompanyEntityGridRowProp.Id] : number
}
export type CompanyEntityGridRowName = {
 [CompanyEntityGridRowProp.Name] : string | null
}
export type CompanyEntityGridRow = 
 CompanyEntityGridRowId & 
 Partial<CompanyEntityGridRowName>

export enum ComplianceDataQuestionnaireEntityGridRowProp {
 ComplianceDataCustomerBrandName = 'complianceData.customer.brand.name',
 ComplianceDataCustomerId = 'complianceData.customer.id',
 ComplianceDataCustomerPersonName = 'complianceData.customer.person.name',
 CreatedBy = 'createdBy',
 CreationTime = 'creationTime',
 FullyRegistered = 'fullyRegistered',
 Id = 'id',
 ModificationTime = 'modificationTime',
 ModifiedBy = 'modifiedBy',
 Num = 'num',
 UserApprovalApprovalDate = 'userApproval.approvalDate',
 UserApprovalApprovedByLoginName = 'userApproval.approvedBy.loginName',
 UserApprovalStatus = 'userApproval.status'
}
export type ComplianceDataQuestionnaireEntityGridRowComplianceDataCustomerBrandName = {
 [ComplianceDataQuestionnaireEntityGridRowProp.ComplianceDataCustomerBrandName] : string | null
}
export type ComplianceDataQuestionnaireEntityGridRowComplianceDataCustomerId = {
 [ComplianceDataQuestionnaireEntityGridRowProp.ComplianceDataCustomerId] : number | null
}
export type ComplianceDataQuestionnaireEntityGridRowComplianceDataCustomerPersonName = {
 [ComplianceDataQuestionnaireEntityGridRowProp.ComplianceDataCustomerPersonName] : string | null
}
export type ComplianceDataQuestionnaireEntityGridRowCreatedBy = {
 [ComplianceDataQuestionnaireEntityGridRowProp.CreatedBy] : string | null
}
export type ComplianceDataQuestionnaireEntityGridRowCreationTime = {
 [ComplianceDataQuestionnaireEntityGridRowProp.CreationTime] : number | null
}
export type ComplianceDataQuestionnaireEntityGridRowFullyRegistered = {
 [ComplianceDataQuestionnaireEntityGridRowProp.FullyRegistered] : boolean | null
}
export type ComplianceDataQuestionnaireEntityGridRowId = {
 [ComplianceDataQuestionnaireEntityGridRowProp.Id] : number
}
export type ComplianceDataQuestionnaireEntityGridRowModificationTime = {
 [ComplianceDataQuestionnaireEntityGridRowProp.ModificationTime] : number | null
}
export type ComplianceDataQuestionnaireEntityGridRowModifiedBy = {
 [ComplianceDataQuestionnaireEntityGridRowProp.ModifiedBy] : string | null
}
export type ComplianceDataQuestionnaireEntityGridRowNum = {
 [ComplianceDataQuestionnaireEntityGridRowProp.Num] : number | null
}
export type ComplianceDataQuestionnaireEntityGridRowUserApprovalApprovalDate = {
 [ComplianceDataQuestionnaireEntityGridRowProp.UserApprovalApprovalDate] : number | null
}
export type ComplianceDataQuestionnaireEntityGridRowUserApprovalApprovedByLoginName = {
 [ComplianceDataQuestionnaireEntityGridRowProp.UserApprovalApprovedByLoginName] : string | null
}
export type ComplianceDataQuestionnaireEntityGridRowUserApprovalStatus = {
 [ComplianceDataQuestionnaireEntityGridRowProp.UserApprovalStatus] : 'PENDING' | 'IN_PROGRESS' | 'REJECTED' | 'APPROVED' | null
}
export type ComplianceDataQuestionnaireEntityGridRow = 
 Partial<ComplianceDataQuestionnaireEntityGridRowComplianceDataCustomerBrandName> & 
 Partial<ComplianceDataQuestionnaireEntityGridRowComplianceDataCustomerId> & 
 Partial<ComplianceDataQuestionnaireEntityGridRowComplianceDataCustomerPersonName> & 
 Partial<ComplianceDataQuestionnaireEntityGridRowCreatedBy> & 
 Partial<ComplianceDataQuestionnaireEntityGridRowCreationTime> & 
 Partial<ComplianceDataQuestionnaireEntityGridRowFullyRegistered> & 
 ComplianceDataQuestionnaireEntityGridRowId & 
 Partial<ComplianceDataQuestionnaireEntityGridRowModificationTime> & 
 Partial<ComplianceDataQuestionnaireEntityGridRowModifiedBy> & 
 Partial<ComplianceDataQuestionnaireEntityGridRowNum> & 
 Partial<ComplianceDataQuestionnaireEntityGridRowUserApprovalApprovalDate> & 
 Partial<ComplianceDataQuestionnaireEntityGridRowUserApprovalApprovedByLoginName> & 
 Partial<ComplianceDataQuestionnaireEntityGridRowUserApprovalStatus>

export enum CreditCardEntityGridRowProp {
 CreationTime = 'creationTime',
 CreditCardType = 'creditCardType',
 CustomerBrandName = 'customer.brand.name',
 CustomerCompanyRegulationCountryCompanyRegulationPartnerCompanyName = 'customer.companyRegulationCountry.companyRegulation.partnerCompany.name',
 CustomerComplianceDataComplianceStage = 'customer.complianceData.complianceStage',
 CustomerCreationTime = 'customer.creationTime',
 CustomerId = 'customer.id',
 DepositTotalsTotalDoneDepositsAmount = 'depositTotals.totalDoneDepositsAmount',
 DepositTotalsTotalDoneDepositsCount = 'depositTotals.totalDoneDepositsCount',
 DepositTotalsTotalPendingDepositsAmount = 'depositTotals.totalPendingDepositsAmount',
 DepositTotalsTotalPendingDepositsCount = 'depositTotals.totalPendingDepositsCount',
 Duplicate = 'duplicate',
 ExpirationDate = 'expirationDate',
 Id = 'id',
 Number = 'number',
 Status = 'status'
}
export type CreditCardEntityGridRowCreationTime = {
 [CreditCardEntityGridRowProp.CreationTime] : number | null
}
export type CreditCardEntityGridRowCreditCardType = {
 [CreditCardEntityGridRowProp.CreditCardType] : 'UNKNOWN' | 'MASTER_CARD' | 'VISA' | 'DINERS' | 'AMERICAN_EXPRESS' | 'JCB' | 'DISCOVER' | 'LASERCARD' | 'MAESTRO' | 'SOLO' | 'SWITCH' | 'ENTROPAY' | 'DANKORT_VISA' | null
}
export type CreditCardEntityGridRowCustomerBrandName = {
 [CreditCardEntityGridRowProp.CustomerBrandName] : string | null
}
export type CreditCardEntityGridRowCustomerCompanyRegulationCountryCompanyRegulationPartnerCompanyName = {
 [CreditCardEntityGridRowProp.CustomerCompanyRegulationCountryCompanyRegulationPartnerCompanyName] : string | null
}
export type CreditCardEntityGridRowCustomerComplianceDataComplianceStage = {
 [CreditCardEntityGridRowProp.CustomerComplianceDataComplianceStage] : 'NON_COMPLIANT' | 'COMPLIANT' | 'PENDING_COMPLIANCE' | 'LIMITED_COMPLIED' | 'COMPLIANCE_REVOKED' | 'COMPLIANCE_SUSPENDED' | null
}
export type CreditCardEntityGridRowCustomerCreationTime = {
 [CreditCardEntityGridRowProp.CustomerCreationTime] : number | null
}
export type CreditCardEntityGridRowCustomerId = {
 [CreditCardEntityGridRowProp.CustomerId] : number | null
}
export type CreditCardEntityGridRowDepositTotalsTotalDoneDepositsAmount = {
 [CreditCardEntityGridRowProp.DepositTotalsTotalDoneDepositsAmount] : number | null
}
export type CreditCardEntityGridRowDepositTotalsTotalDoneDepositsCount = {
 [CreditCardEntityGridRowProp.DepositTotalsTotalDoneDepositsCount] : number | null
}
export type CreditCardEntityGridRowDepositTotalsTotalPendingDepositsAmount = {
 [CreditCardEntityGridRowProp.DepositTotalsTotalPendingDepositsAmount] : number | null
}
export type CreditCardEntityGridRowDepositTotalsTotalPendingDepositsCount = {
 [CreditCardEntityGridRowProp.DepositTotalsTotalPendingDepositsCount] : number | null
}
export type CreditCardEntityGridRowDuplicate = {
 [CreditCardEntityGridRowProp.Duplicate] : boolean | null
}
export type CreditCardEntityGridRowExpirationDate = {
 [CreditCardEntityGridRowProp.ExpirationDate] : string | null
}
export type CreditCardEntityGridRowId = {
 [CreditCardEntityGridRowProp.Id] : number
}
export type CreditCardEntityGridRowNumber = {
 [CreditCardEntityGridRowProp.Number] : string | null
}
export type CreditCardEntityGridRowStatus = {
 [CreditCardEntityGridRowProp.Status] : 'PENDING' | 'APPROVED' | 'REJECTED' | 'BLACK_LISTED' | 'REVOKE_PENDING' | null
}
export type CreditCardEntityGridRow = 
 Partial<CreditCardEntityGridRowCreationTime> & 
 Partial<CreditCardEntityGridRowCreditCardType> & 
 Partial<CreditCardEntityGridRowCustomerBrandName> & 
 Partial<CreditCardEntityGridRowCustomerCompanyRegulationCountryCompanyRegulationPartnerCompanyName> & 
 Partial<CreditCardEntityGridRowCustomerComplianceDataComplianceStage> & 
 Partial<CreditCardEntityGridRowCustomerCreationTime> & 
 Partial<CreditCardEntityGridRowCustomerId> & 
 Partial<CreditCardEntityGridRowDepositTotalsTotalDoneDepositsAmount> & 
 CreditCardEntityGridRowDepositTotalsTotalDoneDepositsCount & 
 Partial<CreditCardEntityGridRowDepositTotalsTotalPendingDepositsAmount> & 
 CreditCardEntityGridRowDepositTotalsTotalPendingDepositsCount & 
 Partial<CreditCardEntityGridRowDuplicate> & 
 Partial<CreditCardEntityGridRowExpirationDate> & 
 CreditCardEntityGridRowId & 
 Partial<CreditCardEntityGridRowNumber> & 
 Partial<CreditCardEntityGridRowStatus>

export enum CreditCardDepositEntityGridRowProp {
 Auth3D = 'auth3D',
 BaseCurrencyAmount = 'baseCurrencyAmount',
 BaseCurrencyConvRate = 'baseCurrencyConvRate',
 BonusDataAdjustedAmount = 'bonusData.adjustedAmount',
 BonusExpirationDate = 'bonusExpirationDate',
 CcExpDate = 'ccExpDate',
 CcNumber = 'ccNumber',
 CreationTime = 'creationTime',
 CustomerBrandCompanyName = 'customer.brand.company.name',
 CustomerBrandName = 'customer.brand.name',
 CustomerId = 'customer.id',
 CustomerPersonCountry = 'customer.person.country',
 CustomerPersonName = 'customer.person.name',
 Ecdd = 'ecdd',
 ExternalId = 'externalId',
 Id = 'id',
 ModificationTime = 'modificationTime',
 ModifiedBy = 'modifiedBy',
 ReasonInternalReason = 'reason.internalReason',
 SourceAmount = 'source.amount',
 SourceCurrency = 'source.currency',
 Status = 'status',
 TargetAmount = 'target.amount',
 TargetCurrency = 'target.currency',
 TargetCurrencyConvRate = 'targetCurrencyConvRate',
 TransactionType = 'transactionType',
 TxSubType = 'txSubType'
}
export type CreditCardDepositEntityGridRowAuth3D = {
 [CreditCardDepositEntityGridRowProp.Auth3D] : boolean | null
}
export type CreditCardDepositEntityGridRowBaseCurrencyAmount = {
 [CreditCardDepositEntityGridRowProp.BaseCurrencyAmount] : number | null
}
export type CreditCardDepositEntityGridRowBaseCurrencyConvRate = {
 [CreditCardDepositEntityGridRowProp.BaseCurrencyConvRate] : number | null
}
export type CreditCardDepositEntityGridRowBonusDataAdjustedAmount = {
 [CreditCardDepositEntityGridRowProp.BonusDataAdjustedAmount] : number | null
}
export type CreditCardDepositEntityGridRowBonusExpirationDate = {
 [CreditCardDepositEntityGridRowProp.BonusExpirationDate] : number | null
}
export type CreditCardDepositEntityGridRowCcExpDate = {
 [CreditCardDepositEntityGridRowProp.CcExpDate] : string | null
}
export type CreditCardDepositEntityGridRowCcNumber = {
 [CreditCardDepositEntityGridRowProp.CcNumber] : string | null
}
export type CreditCardDepositEntityGridRowCreationTime = {
 [CreditCardDepositEntityGridRowProp.CreationTime] : number | null
}
export type CreditCardDepositEntityGridRowCustomerBrandCompanyName = {
 [CreditCardDepositEntityGridRowProp.CustomerBrandCompanyName] : string | null
}
export type CreditCardDepositEntityGridRowCustomerBrandName = {
 [CreditCardDepositEntityGridRowProp.CustomerBrandName] : string | null
}
export type CreditCardDepositEntityGridRowCustomerId = {
 [CreditCardDepositEntityGridRowProp.CustomerId] : number | null
}
export type CreditCardDepositEntityGridRowCustomerPersonCountry = {
 [CreditCardDepositEntityGridRowProp.CustomerPersonCountry] : 'NA' | 'AFGHANISTAN' | 'ÅLAND_ISLANDS' | 'ALBANIA' | 'ALGERIA' | 'AMERICAN_SAMOA' | 'ANDORRA' | 'ANGOLA' | 'ANGUILLA' | 'ANTARCTICA' | 'ANTIGUA_AND_BARBUDA' | 'ARGENTINA' | 'ARMENIA' | 'ARUBA' | 'AUSTRALIA' | 'AUSTRIA' | 'AZERBAIJAN' | 'BAHAMAS' | 'BAHRAIN' | 'BANGLADESH' | 'BARBADOS' | 'BELARUS' | 'BELGIUM' | 'BELIZE' | 'BENIN' | 'BERMUDA' | 'BHUTAN' | 'BOLIVIA' | 'BONAIRE_SINT_EUSTATIUS_AND_SABA' | 'BOSNIA_AND_HERZEGOVINA' | 'BOTSWANA' | 'BOUVET_ISLAND' | 'BRAZIL' | 'BRITISH_INDIAN_OCEAN_TERRITORY' | 'BRUNEI_DARUSSALAM' | 'BULGARIA' | 'BURKINA_FASO' | 'BURUNDI' | 'CAMBODIA' | 'CAMEROON' | 'CANADA' | 'CAPE_VERDE' | 'CAYMAN_ISLANDS' | 'CENTRAL_AFRICAN_REPUBLIC' | 'CHAD' | 'CHILE' | 'CHINA' | 'CHRISTMAS_ISLAND' | 'COCOS_ISLANDS' | 'COLOMBIA' | 'COMOROS' | 'CONGO' | 'CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE' | 'COOK_ISLANDS' | 'COSTA_RICA' | 'CROATIA' | 'CUBA' | 'CURAÇAO' | 'CYPRUS' | 'CZECH_REPUBLIC' | 'CÔTE_DIVOIRE' | 'DENMARK' | 'DJIBOUTI' | 'DOMINICA' | 'DOMINICAN_REPUBLIC' | 'EAST_TIMOR' | 'ECUADOR' | 'EGYPT' | 'EL_SALVADOR' | 'EQUATORIAL_GUINEA' | 'ERITREA' | 'ESTONIA' | 'ETHIOPIA' | 'FALKLAND_ISLANDS' | 'FAROE_ISLANDS' | 'FIJI' | 'FINLAND' | 'FRANCE' | 'FRENCH_GUIANA' | 'FRENCH_POLYNESIA' | 'FRENCH_SOUTHERN_TERRITORIES' | 'GABON' | 'GAMBIA' | 'Georgia' | 'GERMANY' | 'GHANA' | 'GIBRALTAR' | 'GREECE' | 'GREENLAND' | 'GRENADA' | 'GUADELOUPE' | 'GUAM' | 'GUATEMALA' | 'GUERNSEY' | 'GUINEA' | 'GUINEA_BISSAU' | 'GUYANA' | 'HAITI' | 'HEARD_ISLAND_AND_MCDONALD_ISLANDS' | 'HONDURAS' | 'HONG_KONG' | 'Hungary' | 'ICELAND' | 'INDIA' | 'INDONESIA' | 'IRAN' | 'IRAQ' | 'IRELAND' | 'ISLE_OF_MAN' | 'ISRAEL' | 'ITALY' | 'JAMAICA' | 'JAPAN' | 'JERSEY' | 'JORDAN' | 'KAZAKHSTAN' | 'KENYA' | 'KIRIBATI' | 'KOSOVO' | 'KOREA_DEMOCRATIC_PEOPLE_REPUBLIC_OF' | 'KOREA_REPUBLIC_OF' | 'KUWAIT' | 'KYRGYZSTAN' | 'LAO_PEOPLE_DEMOCRATIC_REPUBLIC' | 'LATVIA' | 'LEBANON' | 'LESOTHO' | 'LIBERIA' | 'LIBYAN' | 'LIECHTENSTEIN' | 'LITHUANIA' | 'LUXEMBOURG' | 'MACAO' | 'MADAGASCAR' | 'MALAWI' | 'MALAYSIA' | 'MALDIVES' | 'MALI' | 'MALTA' | 'MARSHALL_ISLANDS' | 'MARTINIQUE' | 'MAURITANIA' | 'MAURITIUS' | 'MAYOTTE' | 'MEXICO' | 'MICRONESIA' | 'MOLDOVA_REPUBLIC_OF' | 'MONACO' | 'MONGOLIA' | 'MONTENEGRO' | 'MONTSERRAT' | 'MOROCCO' | 'MOZAMBIQUE' | 'MYANMAR' | 'NAMIBIA' | 'NAURU' | 'NEPAL' | 'NETHERLANDS' | 'NETHERLANDS_ANTILLES' | 'NEW_CALEDONIA' | 'NEW_ZEALAND' | 'NICARAGUA' | 'NIGER' | 'NIGERIA' | 'NIUE' | 'NORFOLK_ISLAND' | 'NORTHERN_MARIANA_ISLANDS' | 'NORWAY' | 'OMAN' | 'PAKISTAN' | 'PALAU' | 'PALESTINIAN_TERRITORY_OCCUPIED' | 'PANAMA' | 'PAPUA_NEW_GUINEA' | 'PARAGUAY' | 'PERU' | 'PHILIPPINES' | 'PITCAIRN' | 'POLAND' | 'PORTUGAL' | 'PUERTO_RICO' | 'QATAR' | 'ROMANIA' | 'RUSSIAN_FEDERATION' | 'RWANDA' | 'RÉUNION' | 'SAINT_BARTHÉLEMY_BL' | 'SAINT_HELENA' | 'SAINT_KITTS_AND_NEVIS' | 'SAINT_LUCIA' | 'SAINT_MARTIN_FRENCH_PART' | 'SAINT_PIERRE_AND_MIQUELON' | 'SAINT_VINCENT_AND_THE_GRENADINES' | 'SAMOA' | 'SAN_MARINO' | 'SAO_TOME_AND_PRINCIPE' | 'SAUDI_ARABIA' | 'SENEGAL' | 'SERBIA' | 'SEYCHELLES' | 'SIERRA_LEONE' | 'SINGAPORE' | 'SINT_MAARTEN_DUTCH_PART' | 'SLOVAKIA' | 'SLOVENIA' | 'SOLOMON_ISLANDS' | 'SOMALIA' | 'SOUTH_AFRICA' | 'SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS' | 'SOUTH_SUDAN' | 'SPAIN' | 'SRI_LANKA' | 'SUDAN' | 'SURINAME' | 'SVALBARD_AND_JAN_MAYEN' | 'SWAZILAND' | 'SWEDEN' | 'SWITZERLAND' | 'SYRIAN_ARAB_REPUBLIC' | 'TAIWAN' | 'TAJIKISTAN' | 'THAILAND' | 'THE_FORMER_YUGOSLAV_REPUBLIC_OF_MACEDONIA' | 'TOGO' | 'TOKELAU' | 'TONGA' | 'TRINIDAD_AND_TOBAGO' | 'TUNISIA' | 'TURKEY' | 'TURKMENISTAN' | 'TURKS_AND_CAICOS_ISLANDS' | 'TUVALU' | 'UGANDA' | 'UKRAINE' | 'UNITED_ARAB_EMIRATES' | 'UNITED_KINGDOM' | 'UNITED_REPUBLIC_OF_TANZANIA' | 'UNITED_STATES_MINOR_OUTLYING_ISLANDS' | 'URUGUAY' | 'USA' | 'UZBEKISTAN' | 'VANUATU' | 'VATICAN_CITY_STATE' | 'VENEZUELA' | 'VIET_NAM' | 'VIRGIN_ISLANDS_GB' | 'VIRGIN_ISLANDS_USA' | 'WALLIS_AND_FUTUNA' | 'WESTERN_SAHARA' | 'YEMEN' | 'ZAMBIA' | 'ZIMBABWE' | null
}
export type CreditCardDepositEntityGridRowCustomerPersonName = {
 [CreditCardDepositEntityGridRowProp.CustomerPersonName] : string | null
}
export type CreditCardDepositEntityGridRowEcdd = {
 [CreditCardDepositEntityGridRowProp.Ecdd] : boolean | null
}
export type CreditCardDepositEntityGridRowExternalId = {
 [CreditCardDepositEntityGridRowProp.ExternalId] : string | null
}
export type CreditCardDepositEntityGridRowId = {
 [CreditCardDepositEntityGridRowProp.Id] : number
}
export type CreditCardDepositEntityGridRowModificationTime = {
 [CreditCardDepositEntityGridRowProp.ModificationTime] : number | null
}
export type CreditCardDepositEntityGridRowModifiedBy = {
 [CreditCardDepositEntityGridRowProp.ModifiedBy] : string | null
}
export type CreditCardDepositEntityGridRowReasonInternalReason = {
 [CreditCardDepositEntityGridRowProp.ReasonInternalReason] : string | null
}
export type CreditCardDepositEntityGridRowSourceAmount = {
 [CreditCardDepositEntityGridRowProp.SourceAmount] : number | null
}
export type CreditCardDepositEntityGridRowSourceCurrency = {
 [CreditCardDepositEntityGridRowProp.SourceCurrency] : 'USD' | 'EUR' | 'GBP' | 'CAD' | 'JPY' | 'AED' | 'PLN' | 'AZN' | 'INR' | 'NZD' | 'CUP' | 'EGP' | 'LBP' | 'RMB' | 'AUD' | 'ILS' | 'RON' | 'CHF' | 'CZK' | 'DKK' | 'RUB' | 'BGN' | 'HRK' | 'CNY' | 'MXN' | 'CLP' | 'ALL' | 'NOK' | 'SEK' | 'HUF' | 'BRL' | 'ZAR' | 'HKD' | 'SGD' | 'THB' | 'TRY' | 'KRW' | 'SKK' | 'LKR' | 'COP' | 'VND' | 'CNH' | 'SAR' | 'MYR' | 'USDT' | 'LOCAL_CURRENCY' | null
}
export type CreditCardDepositEntityGridRowStatus = {
 [CreditCardDepositEntityGridRowProp.Status] : 'PENDING' | 'PENDING_COMPLIANCE' | 'DONE' | 'FAILED' | 'REJECTED' | 'PENDING_PM_APPROVAL' | 'CANCELLED_PENDING_PM_APPROVAL' | 'CANCELLED_PENDING_COMPLIANCE' | null
}
export type CreditCardDepositEntityGridRowTargetAmount = {
 [CreditCardDepositEntityGridRowProp.TargetAmount] : number | null
}
export type CreditCardDepositEntityGridRowTargetCurrency = {
 [CreditCardDepositEntityGridRowProp.TargetCurrency] : 'USD' | 'EUR' | 'GBP' | 'CAD' | 'JPY' | 'AED' | 'PLN' | 'AZN' | 'INR' | 'NZD' | 'CUP' | 'EGP' | 'LBP' | 'RMB' | 'AUD' | 'ILS' | 'RON' | 'CHF' | 'CZK' | 'DKK' | 'RUB' | 'BGN' | 'HRK' | 'CNY' | 'MXN' | 'CLP' | 'ALL' | 'NOK' | 'SEK' | 'HUF' | 'BRL' | 'ZAR' | 'HKD' | 'SGD' | 'THB' | 'TRY' | 'KRW' | 'SKK' | 'LKR' | 'COP' | 'VND' | 'CNH' | 'SAR' | 'MYR' | 'USDT' | 'LOCAL_CURRENCY' | null
}
export type CreditCardDepositEntityGridRowTargetCurrencyConvRate = {
 [CreditCardDepositEntityGridRowProp.TargetCurrencyConvRate] : number | null
}
export type CreditCardDepositEntityGridRowTransactionType = {
 [CreditCardDepositEntityGridRowProp.TransactionType] : 'DEPOSIT' | 'WITHDRAWAL' | 'CORRECTION' | null
}
export type CreditCardDepositEntityGridRowTxSubType = {
 [CreditCardDepositEntityGridRowProp.TxSubType] : 'NEGATIVE_ADJUSTMENT' | 'NEGATIVE_DEALING_CORRECTION' | 'NEGATIVE_FRAUD_ADJUSTMENT' | 'NEGATIVE_BONUS_ADJUSTMENT' | 'CLOSING_ACCOUNT_BOOK_NEGATIVE' | 'PARTNER_NEGATIVE_ADJUSTMENT' | 'POSITIVE_ADJUSTMENT' | 'POSITIVE_DEALING_CORRECTION' | 'POSITIVE_FRAUD_ADJUSTMENT' | 'POSITIVE_BONUS_ADJUSTMENT' | 'CLOSING_ACCOUNT_BOOK_POSITIVE' | 'PARTNER_PAYMENT' | 'PARTNER_BONUS' | 'BONUS' | 'CREDIT_CARD_DEPOSIT' | 'WIRE_TRANSFER_DEPOSIT' | 'CREDIT_CREDIT_CARD_WITHDRAWAL' | 'VOID_CREDIT_CARD_WITHDRAWAL' | 'REFUND_CREDIT_CARD_WITHDRAWAL' | 'WIRE_TRANSFER_WITHDRAWAL' | 'MANUAL_DEPOSIT' | 'INTERNAL_DEPOSIT' | 'MANUAL_WITHDRAWAL' | 'INTERNAL_WITHDRAWAL' | 'LIBERTY_RESERVE_DEPOSIT' | 'LIBERTY_RESERVE_WITHDRAWAL' | 'ENVOY_DEPOSIT' | 'ENVOY_WITHDRAWAL' | 'WM_WITHDRAWAL' | 'NETELLER_DEPOSIT' | 'MONEYBOOKERS_DEPOSIT' | 'QIWI_DEPOSIT' | 'WEBMONEY_DEPOSIT' | 'CHINAUNION_DEPOSIT' | 'CUP_DEPOSIT' | 'CHINAUNION_WITHDRAWAL' | 'LOBANET_DEPOSIT' | 'QIWI_WITHDRAWAL' | 'PSP_DEPOSIT' | 'BAOFOO_DEPOSIT' | 'SOLIDPAY_DEPOSIT' | 'FOCAL_DEPOSIT' | 'PAYGATE_DEPOSIT' | 'PAYMENT_ASIA_DEPOSIT' | 'CRYPTO_WITHDRAWAL' | 'MD_APM_WITHDRAWAL' | null
}
export type CreditCardDepositEntityGridRow = 
 Partial<CreditCardDepositEntityGridRowAuth3D> & 
 Partial<CreditCardDepositEntityGridRowBaseCurrencyAmount> & 
 Partial<CreditCardDepositEntityGridRowBaseCurrencyConvRate> & 
 Partial<CreditCardDepositEntityGridRowBonusDataAdjustedAmount> & 
 Partial<CreditCardDepositEntityGridRowBonusExpirationDate> & 
 Partial<CreditCardDepositEntityGridRowCcExpDate> & 
 Partial<CreditCardDepositEntityGridRowCcNumber> & 
 Partial<CreditCardDepositEntityGridRowCreationTime> & 
 Partial<CreditCardDepositEntityGridRowCustomerBrandCompanyName> & 
 Partial<CreditCardDepositEntityGridRowCustomerBrandName> & 
 Partial<CreditCardDepositEntityGridRowCustomerId> & 
 Partial<CreditCardDepositEntityGridRowCustomerPersonCountry> & 
 Partial<CreditCardDepositEntityGridRowCustomerPersonName> & 
 Partial<CreditCardDepositEntityGridRowEcdd> & 
 Partial<CreditCardDepositEntityGridRowExternalId> & 
 CreditCardDepositEntityGridRowId & 
 Partial<CreditCardDepositEntityGridRowModificationTime> & 
 Partial<CreditCardDepositEntityGridRowModifiedBy> & 
 Partial<CreditCardDepositEntityGridRowReasonInternalReason> & 
 Partial<CreditCardDepositEntityGridRowSourceAmount> & 
 CreditCardDepositEntityGridRowSourceCurrency & 
 Partial<CreditCardDepositEntityGridRowStatus> & 
 Partial<CreditCardDepositEntityGridRowTargetAmount> & 
 CreditCardDepositEntityGridRowTargetCurrency & 
 Partial<CreditCardDepositEntityGridRowTargetCurrencyConvRate> & 
 Partial<CreditCardDepositEntityGridRowTransactionType> & 
 Partial<CreditCardDepositEntityGridRowTxSubType>

export enum CreditCardWithdrawalEntityGridRowProp {
 Auth3D = 'auth3D',
 BaseCurrencyAmount = 'baseCurrencyAmount',
 BaseCurrencyConvRate = 'baseCurrencyConvRate',
 BonusDataAdjustedAmount = 'bonusData.adjustedAmount',
 BonusExpirationDate = 'bonusExpirationDate',
 CcExpDate = 'ccExpDate',
 CcNumber = 'ccNumber',
 CreationTime = 'creationTime',
 CustomerBrandCompanyName = 'customer.brand.company.name',
 CustomerBrandName = 'customer.brand.name',
 CustomerId = 'customer.id',
 CustomerPersonCountry = 'customer.person.country',
 CustomerPersonName = 'customer.person.name',
 Ecdd = 'ecdd',
 ExternalId = 'externalId',
 Id = 'id',
 ModificationTime = 'modificationTime',
 ModifiedBy = 'modifiedBy',
 ReasonInternalReason = 'reason.internalReason',
 SourceAmount = 'source.amount',
 SourceCurrency = 'source.currency',
 Status = 'status',
 TargetAmount = 'target.amount',
 TargetCurrency = 'target.currency',
 TargetCurrencyConvRate = 'targetCurrencyConvRate',
 TransactionType = 'transactionType',
 TxSubType = 'txSubType'
}
export type CreditCardWithdrawalEntityGridRowAuth3D = {
 [CreditCardWithdrawalEntityGridRowProp.Auth3D] : boolean | null
}
export type CreditCardWithdrawalEntityGridRowBaseCurrencyAmount = {
 [CreditCardWithdrawalEntityGridRowProp.BaseCurrencyAmount] : number | null
}
export type CreditCardWithdrawalEntityGridRowBaseCurrencyConvRate = {
 [CreditCardWithdrawalEntityGridRowProp.BaseCurrencyConvRate] : number | null
}
export type CreditCardWithdrawalEntityGridRowBonusDataAdjustedAmount = {
 [CreditCardWithdrawalEntityGridRowProp.BonusDataAdjustedAmount] : number | null
}
export type CreditCardWithdrawalEntityGridRowBonusExpirationDate = {
 [CreditCardWithdrawalEntityGridRowProp.BonusExpirationDate] : number | null
}
export type CreditCardWithdrawalEntityGridRowCcExpDate = {
 [CreditCardWithdrawalEntityGridRowProp.CcExpDate] : string | null
}
export type CreditCardWithdrawalEntityGridRowCcNumber = {
 [CreditCardWithdrawalEntityGridRowProp.CcNumber] : string | null
}
export type CreditCardWithdrawalEntityGridRowCreationTime = {
 [CreditCardWithdrawalEntityGridRowProp.CreationTime] : number | null
}
export type CreditCardWithdrawalEntityGridRowCustomerBrandCompanyName = {
 [CreditCardWithdrawalEntityGridRowProp.CustomerBrandCompanyName] : string | null
}
export type CreditCardWithdrawalEntityGridRowCustomerBrandName = {
 [CreditCardWithdrawalEntityGridRowProp.CustomerBrandName] : string | null
}
export type CreditCardWithdrawalEntityGridRowCustomerId = {
 [CreditCardWithdrawalEntityGridRowProp.CustomerId] : number | null
}
export type CreditCardWithdrawalEntityGridRowCustomerPersonCountry = {
 [CreditCardWithdrawalEntityGridRowProp.CustomerPersonCountry] : 'NA' | 'AFGHANISTAN' | 'ÅLAND_ISLANDS' | 'ALBANIA' | 'ALGERIA' | 'AMERICAN_SAMOA' | 'ANDORRA' | 'ANGOLA' | 'ANGUILLA' | 'ANTARCTICA' | 'ANTIGUA_AND_BARBUDA' | 'ARGENTINA' | 'ARMENIA' | 'ARUBA' | 'AUSTRALIA' | 'AUSTRIA' | 'AZERBAIJAN' | 'BAHAMAS' | 'BAHRAIN' | 'BANGLADESH' | 'BARBADOS' | 'BELARUS' | 'BELGIUM' | 'BELIZE' | 'BENIN' | 'BERMUDA' | 'BHUTAN' | 'BOLIVIA' | 'BONAIRE_SINT_EUSTATIUS_AND_SABA' | 'BOSNIA_AND_HERZEGOVINA' | 'BOTSWANA' | 'BOUVET_ISLAND' | 'BRAZIL' | 'BRITISH_INDIAN_OCEAN_TERRITORY' | 'BRUNEI_DARUSSALAM' | 'BULGARIA' | 'BURKINA_FASO' | 'BURUNDI' | 'CAMBODIA' | 'CAMEROON' | 'CANADA' | 'CAPE_VERDE' | 'CAYMAN_ISLANDS' | 'CENTRAL_AFRICAN_REPUBLIC' | 'CHAD' | 'CHILE' | 'CHINA' | 'CHRISTMAS_ISLAND' | 'COCOS_ISLANDS' | 'COLOMBIA' | 'COMOROS' | 'CONGO' | 'CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE' | 'COOK_ISLANDS' | 'COSTA_RICA' | 'CROATIA' | 'CUBA' | 'CURAÇAO' | 'CYPRUS' | 'CZECH_REPUBLIC' | 'CÔTE_DIVOIRE' | 'DENMARK' | 'DJIBOUTI' | 'DOMINICA' | 'DOMINICAN_REPUBLIC' | 'EAST_TIMOR' | 'ECUADOR' | 'EGYPT' | 'EL_SALVADOR' | 'EQUATORIAL_GUINEA' | 'ERITREA' | 'ESTONIA' | 'ETHIOPIA' | 'FALKLAND_ISLANDS' | 'FAROE_ISLANDS' | 'FIJI' | 'FINLAND' | 'FRANCE' | 'FRENCH_GUIANA' | 'FRENCH_POLYNESIA' | 'FRENCH_SOUTHERN_TERRITORIES' | 'GABON' | 'GAMBIA' | 'Georgia' | 'GERMANY' | 'GHANA' | 'GIBRALTAR' | 'GREECE' | 'GREENLAND' | 'GRENADA' | 'GUADELOUPE' | 'GUAM' | 'GUATEMALA' | 'GUERNSEY' | 'GUINEA' | 'GUINEA_BISSAU' | 'GUYANA' | 'HAITI' | 'HEARD_ISLAND_AND_MCDONALD_ISLANDS' | 'HONDURAS' | 'HONG_KONG' | 'Hungary' | 'ICELAND' | 'INDIA' | 'INDONESIA' | 'IRAN' | 'IRAQ' | 'IRELAND' | 'ISLE_OF_MAN' | 'ISRAEL' | 'ITALY' | 'JAMAICA' | 'JAPAN' | 'JERSEY' | 'JORDAN' | 'KAZAKHSTAN' | 'KENYA' | 'KIRIBATI' | 'KOSOVO' | 'KOREA_DEMOCRATIC_PEOPLE_REPUBLIC_OF' | 'KOREA_REPUBLIC_OF' | 'KUWAIT' | 'KYRGYZSTAN' | 'LAO_PEOPLE_DEMOCRATIC_REPUBLIC' | 'LATVIA' | 'LEBANON' | 'LESOTHO' | 'LIBERIA' | 'LIBYAN' | 'LIECHTENSTEIN' | 'LITHUANIA' | 'LUXEMBOURG' | 'MACAO' | 'MADAGASCAR' | 'MALAWI' | 'MALAYSIA' | 'MALDIVES' | 'MALI' | 'MALTA' | 'MARSHALL_ISLANDS' | 'MARTINIQUE' | 'MAURITANIA' | 'MAURITIUS' | 'MAYOTTE' | 'MEXICO' | 'MICRONESIA' | 'MOLDOVA_REPUBLIC_OF' | 'MONACO' | 'MONGOLIA' | 'MONTENEGRO' | 'MONTSERRAT' | 'MOROCCO' | 'MOZAMBIQUE' | 'MYANMAR' | 'NAMIBIA' | 'NAURU' | 'NEPAL' | 'NETHERLANDS' | 'NETHERLANDS_ANTILLES' | 'NEW_CALEDONIA' | 'NEW_ZEALAND' | 'NICARAGUA' | 'NIGER' | 'NIGERIA' | 'NIUE' | 'NORFOLK_ISLAND' | 'NORTHERN_MARIANA_ISLANDS' | 'NORWAY' | 'OMAN' | 'PAKISTAN' | 'PALAU' | 'PALESTINIAN_TERRITORY_OCCUPIED' | 'PANAMA' | 'PAPUA_NEW_GUINEA' | 'PARAGUAY' | 'PERU' | 'PHILIPPINES' | 'PITCAIRN' | 'POLAND' | 'PORTUGAL' | 'PUERTO_RICO' | 'QATAR' | 'ROMANIA' | 'RUSSIAN_FEDERATION' | 'RWANDA' | 'RÉUNION' | 'SAINT_BARTHÉLEMY_BL' | 'SAINT_HELENA' | 'SAINT_KITTS_AND_NEVIS' | 'SAINT_LUCIA' | 'SAINT_MARTIN_FRENCH_PART' | 'SAINT_PIERRE_AND_MIQUELON' | 'SAINT_VINCENT_AND_THE_GRENADINES' | 'SAMOA' | 'SAN_MARINO' | 'SAO_TOME_AND_PRINCIPE' | 'SAUDI_ARABIA' | 'SENEGAL' | 'SERBIA' | 'SEYCHELLES' | 'SIERRA_LEONE' | 'SINGAPORE' | 'SINT_MAARTEN_DUTCH_PART' | 'SLOVAKIA' | 'SLOVENIA' | 'SOLOMON_ISLANDS' | 'SOMALIA' | 'SOUTH_AFRICA' | 'SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS' | 'SOUTH_SUDAN' | 'SPAIN' | 'SRI_LANKA' | 'SUDAN' | 'SURINAME' | 'SVALBARD_AND_JAN_MAYEN' | 'SWAZILAND' | 'SWEDEN' | 'SWITZERLAND' | 'SYRIAN_ARAB_REPUBLIC' | 'TAIWAN' | 'TAJIKISTAN' | 'THAILAND' | 'THE_FORMER_YUGOSLAV_REPUBLIC_OF_MACEDONIA' | 'TOGO' | 'TOKELAU' | 'TONGA' | 'TRINIDAD_AND_TOBAGO' | 'TUNISIA' | 'TURKEY' | 'TURKMENISTAN' | 'TURKS_AND_CAICOS_ISLANDS' | 'TUVALU' | 'UGANDA' | 'UKRAINE' | 'UNITED_ARAB_EMIRATES' | 'UNITED_KINGDOM' | 'UNITED_REPUBLIC_OF_TANZANIA' | 'UNITED_STATES_MINOR_OUTLYING_ISLANDS' | 'URUGUAY' | 'USA' | 'UZBEKISTAN' | 'VANUATU' | 'VATICAN_CITY_STATE' | 'VENEZUELA' | 'VIET_NAM' | 'VIRGIN_ISLANDS_GB' | 'VIRGIN_ISLANDS_USA' | 'WALLIS_AND_FUTUNA' | 'WESTERN_SAHARA' | 'YEMEN' | 'ZAMBIA' | 'ZIMBABWE' | null
}
export type CreditCardWithdrawalEntityGridRowCustomerPersonName = {
 [CreditCardWithdrawalEntityGridRowProp.CustomerPersonName] : string | null
}
export type CreditCardWithdrawalEntityGridRowEcdd = {
 [CreditCardWithdrawalEntityGridRowProp.Ecdd] : boolean | null
}
export type CreditCardWithdrawalEntityGridRowExternalId = {
 [CreditCardWithdrawalEntityGridRowProp.ExternalId] : string | null
}
export type CreditCardWithdrawalEntityGridRowId = {
 [CreditCardWithdrawalEntityGridRowProp.Id] : number
}
export type CreditCardWithdrawalEntityGridRowModificationTime = {
 [CreditCardWithdrawalEntityGridRowProp.ModificationTime] : number | null
}
export type CreditCardWithdrawalEntityGridRowModifiedBy = {
 [CreditCardWithdrawalEntityGridRowProp.ModifiedBy] : string | null
}
export type CreditCardWithdrawalEntityGridRowReasonInternalReason = {
 [CreditCardWithdrawalEntityGridRowProp.ReasonInternalReason] : string | null
}
export type CreditCardWithdrawalEntityGridRowSourceAmount = {
 [CreditCardWithdrawalEntityGridRowProp.SourceAmount] : number | null
}
export type CreditCardWithdrawalEntityGridRowSourceCurrency = {
 [CreditCardWithdrawalEntityGridRowProp.SourceCurrency] : 'USD' | 'EUR' | 'GBP' | 'CAD' | 'JPY' | 'AED' | 'PLN' | 'AZN' | 'INR' | 'NZD' | 'CUP' | 'EGP' | 'LBP' | 'RMB' | 'AUD' | 'ILS' | 'RON' | 'CHF' | 'CZK' | 'DKK' | 'RUB' | 'BGN' | 'HRK' | 'CNY' | 'MXN' | 'CLP' | 'ALL' | 'NOK' | 'SEK' | 'HUF' | 'BRL' | 'ZAR' | 'HKD' | 'SGD' | 'THB' | 'TRY' | 'KRW' | 'SKK' | 'LKR' | 'COP' | 'VND' | 'CNH' | 'SAR' | 'MYR' | 'USDT' | 'LOCAL_CURRENCY' | null
}
export type CreditCardWithdrawalEntityGridRowStatus = {
 [CreditCardWithdrawalEntityGridRowProp.Status] : 'PENDING' | 'PENDING_COMPLIANCE' | 'DONE' | 'FAILED' | 'REJECTED' | 'PENDING_PM_APPROVAL' | 'CANCELLED_PENDING_PM_APPROVAL' | 'CANCELLED_PENDING_COMPLIANCE' | null
}
export type CreditCardWithdrawalEntityGridRowTargetAmount = {
 [CreditCardWithdrawalEntityGridRowProp.TargetAmount] : number | null
}
export type CreditCardWithdrawalEntityGridRowTargetCurrency = {
 [CreditCardWithdrawalEntityGridRowProp.TargetCurrency] : 'USD' | 'EUR' | 'GBP' | 'CAD' | 'JPY' | 'AED' | 'PLN' | 'AZN' | 'INR' | 'NZD' | 'CUP' | 'EGP' | 'LBP' | 'RMB' | 'AUD' | 'ILS' | 'RON' | 'CHF' | 'CZK' | 'DKK' | 'RUB' | 'BGN' | 'HRK' | 'CNY' | 'MXN' | 'CLP' | 'ALL' | 'NOK' | 'SEK' | 'HUF' | 'BRL' | 'ZAR' | 'HKD' | 'SGD' | 'THB' | 'TRY' | 'KRW' | 'SKK' | 'LKR' | 'COP' | 'VND' | 'CNH' | 'SAR' | 'MYR' | 'USDT' | 'LOCAL_CURRENCY' | null
}
export type CreditCardWithdrawalEntityGridRowTargetCurrencyConvRate = {
 [CreditCardWithdrawalEntityGridRowProp.TargetCurrencyConvRate] : number | null
}
export type CreditCardWithdrawalEntityGridRowTransactionType = {
 [CreditCardWithdrawalEntityGridRowProp.TransactionType] : 'DEPOSIT' | 'WITHDRAWAL' | 'CORRECTION' | null
}
export type CreditCardWithdrawalEntityGridRowTxSubType = {
 [CreditCardWithdrawalEntityGridRowProp.TxSubType] : 'NEGATIVE_ADJUSTMENT' | 'NEGATIVE_DEALING_CORRECTION' | 'NEGATIVE_FRAUD_ADJUSTMENT' | 'NEGATIVE_BONUS_ADJUSTMENT' | 'CLOSING_ACCOUNT_BOOK_NEGATIVE' | 'PARTNER_NEGATIVE_ADJUSTMENT' | 'POSITIVE_ADJUSTMENT' | 'POSITIVE_DEALING_CORRECTION' | 'POSITIVE_FRAUD_ADJUSTMENT' | 'POSITIVE_BONUS_ADJUSTMENT' | 'CLOSING_ACCOUNT_BOOK_POSITIVE' | 'PARTNER_PAYMENT' | 'PARTNER_BONUS' | 'BONUS' | 'CREDIT_CARD_DEPOSIT' | 'WIRE_TRANSFER_DEPOSIT' | 'CREDIT_CREDIT_CARD_WITHDRAWAL' | 'VOID_CREDIT_CARD_WITHDRAWAL' | 'REFUND_CREDIT_CARD_WITHDRAWAL' | 'WIRE_TRANSFER_WITHDRAWAL' | 'MANUAL_DEPOSIT' | 'INTERNAL_DEPOSIT' | 'MANUAL_WITHDRAWAL' | 'INTERNAL_WITHDRAWAL' | 'LIBERTY_RESERVE_DEPOSIT' | 'LIBERTY_RESERVE_WITHDRAWAL' | 'ENVOY_DEPOSIT' | 'ENVOY_WITHDRAWAL' | 'WM_WITHDRAWAL' | 'NETELLER_DEPOSIT' | 'MONEYBOOKERS_DEPOSIT' | 'QIWI_DEPOSIT' | 'WEBMONEY_DEPOSIT' | 'CHINAUNION_DEPOSIT' | 'CUP_DEPOSIT' | 'CHINAUNION_WITHDRAWAL' | 'LOBANET_DEPOSIT' | 'QIWI_WITHDRAWAL' | 'PSP_DEPOSIT' | 'BAOFOO_DEPOSIT' | 'SOLIDPAY_DEPOSIT' | 'FOCAL_DEPOSIT' | 'PAYGATE_DEPOSIT' | 'PAYMENT_ASIA_DEPOSIT' | 'CRYPTO_WITHDRAWAL' | 'MD_APM_WITHDRAWAL' | null
}
export type CreditCardWithdrawalEntityGridRow = 
 Partial<CreditCardWithdrawalEntityGridRowAuth3D> & 
 Partial<CreditCardWithdrawalEntityGridRowBaseCurrencyAmount> & 
 Partial<CreditCardWithdrawalEntityGridRowBaseCurrencyConvRate> & 
 Partial<CreditCardWithdrawalEntityGridRowBonusDataAdjustedAmount> & 
 Partial<CreditCardWithdrawalEntityGridRowBonusExpirationDate> & 
 Partial<CreditCardWithdrawalEntityGridRowCcExpDate> & 
 Partial<CreditCardWithdrawalEntityGridRowCcNumber> & 
 Partial<CreditCardWithdrawalEntityGridRowCreationTime> & 
 Partial<CreditCardWithdrawalEntityGridRowCustomerBrandCompanyName> & 
 Partial<CreditCardWithdrawalEntityGridRowCustomerBrandName> & 
 Partial<CreditCardWithdrawalEntityGridRowCustomerId> & 
 Partial<CreditCardWithdrawalEntityGridRowCustomerPersonCountry> & 
 Partial<CreditCardWithdrawalEntityGridRowCustomerPersonName> & 
 Partial<CreditCardWithdrawalEntityGridRowEcdd> & 
 Partial<CreditCardWithdrawalEntityGridRowExternalId> & 
 CreditCardWithdrawalEntityGridRowId & 
 Partial<CreditCardWithdrawalEntityGridRowModificationTime> & 
 Partial<CreditCardWithdrawalEntityGridRowModifiedBy> & 
 Partial<CreditCardWithdrawalEntityGridRowReasonInternalReason> & 
 Partial<CreditCardWithdrawalEntityGridRowSourceAmount> & 
 CreditCardWithdrawalEntityGridRowSourceCurrency & 
 Partial<CreditCardWithdrawalEntityGridRowStatus> & 
 Partial<CreditCardWithdrawalEntityGridRowTargetAmount> & 
 CreditCardWithdrawalEntityGridRowTargetCurrency & 
 Partial<CreditCardWithdrawalEntityGridRowTargetCurrencyConvRate> & 
 Partial<CreditCardWithdrawalEntityGridRowTransactionType> & 
 Partial<CreditCardWithdrawalEntityGridRowTxSubType>

export enum CustomerEntityGridRowProp {
 AssignedPoolName = 'assignedPool.name',
 AssignedUserLoginName = 'assignedUser.loginName',
 BrandName = 'brand.name',
 CompanyRegulationCountryCompanyRegulationRegulationTypeName = 'companyRegulationCountry.companyRegulation.regulationType.name',
 ComplianceDataAmlCustomerQuestionnaireScore = 'complianceData.amlCustomerQuestionnaire.score',
 ComplianceDataAppScoreLevel = 'complianceData.appScoreLevel',
 ComplianceDataComplianceApprovedDate = 'complianceData.complianceApprovedDate',
 ComplianceDataComplianceStage = 'complianceData.complianceStage',
 ComplianceDataComplianceSuspensionDate = 'complianceData.complianceSuspensionDate',
 ComplianceDataEcddPerformed = 'complianceData.ecddPerformed',
 ComplianceDataEvAgreement = 'complianceData.evAgreement',
 ComplianceDataFatca = 'complianceData.fatca',
 ComplianceDataFirstDepositCountry = 'complianceData.firstDepositCountry',
 ComplianceDataGbgApproved = 'complianceData.gbgApproved',
 ComplianceDataHasProofOfId = 'complianceData.hasProofOfId',
 ComplianceDataHasProofOfResidence = 'complianceData.hasProofOfResidence',
 ComplianceDataPoliticallyExposedPerson = 'complianceData.politicallyExposedPerson',
 ComplianceDataTaxJurisdiction = 'complianceData.taxJurisdiction',
 ComplianceDataW8Form = 'complianceData.w8Form',
 ComplianceDataWorldCheckFulfilled = 'complianceData.worldCheckFulfilled',
 CreationTime = 'creationTime',
 CustomerAccountType = 'customerAccountType',
 CustomerEntityType = 'customerEntityType',
 CustomerFinancesTotalPendingDepositsAmount = 'customerFinances.totalPendingDepositsAmount',
 Id = 'id',
 ModificationTime = 'modificationTime',
 OneClickClosingAccountStatus = 'oneClickClosingAccountStatus',
 OneClickClosingAccountStatusModificationTime = 'oneClickClosingAccountStatusModificationTime',
 PartnerCompanyName = 'partnerCompany.name',
 PersonCountry = 'person.country',
 PersonFirstName = 'person.firstName',
 PersonLanguage = 'person.language',
 PersonLastName = 'person.lastName',
 PersonLeiExpirationDate = 'person.leiExpirationDate',
 RegistrationTrafficSourceAffiliateId = 'registration.trafficSource.affiliateId',
 RegistrationStatus = 'registrationStatus',
 TotalDeposits = 'totalDeposits',
 TotalWithdrawals = 'totalWithdrawals',
 TradingTotalsRealEquity = 'tradingTotals.realEquity'
}
export type CustomerEntityGridRowAssignedPoolName = {
 [CustomerEntityGridRowProp.AssignedPoolName] : string | null
}
export type CustomerEntityGridRowAssignedUserLoginName = {
 [CustomerEntityGridRowProp.AssignedUserLoginName] : string | null
}
export type CustomerEntityGridRowBrandName = {
 [CustomerEntityGridRowProp.BrandName] : string | null
}
export type CustomerEntityGridRowCompanyRegulationCountryCompanyRegulationRegulationTypeName = {
 [CustomerEntityGridRowProp.CompanyRegulationCountryCompanyRegulationRegulationTypeName] : string | null
}
export type CustomerEntityGridRowComplianceDataAmlCustomerQuestionnaireScore = {
 [CustomerEntityGridRowProp.ComplianceDataAmlCustomerQuestionnaireScore] : number | null
}
export type CustomerEntityGridRowComplianceDataAppScoreLevel = {
 [CustomerEntityGridRowProp.ComplianceDataAppScoreLevel] : 'LOW' | 'MEDIUM' | 'HIGH' | null
}
export type CustomerEntityGridRowComplianceDataComplianceApprovedDate = {
 [CustomerEntityGridRowProp.ComplianceDataComplianceApprovedDate] : number | null
}
export type CustomerEntityGridRowComplianceDataComplianceStage = {
 [CustomerEntityGridRowProp.ComplianceDataComplianceStage] : 'NON_COMPLIANT' | 'COMPLIANT' | 'PENDING_COMPLIANCE' | 'LIMITED_COMPLIED' | 'COMPLIANCE_REVOKED' | 'COMPLIANCE_SUSPENDED' | null
}
export type CustomerEntityGridRowComplianceDataComplianceSuspensionDate = {
 [CustomerEntityGridRowProp.ComplianceDataComplianceSuspensionDate] : number | null
}
export type CustomerEntityGridRowComplianceDataEcddPerformed = {
 [CustomerEntityGridRowProp.ComplianceDataEcddPerformed] : boolean | null
}
export type CustomerEntityGridRowComplianceDataEvAgreement = {
 [CustomerEntityGridRowProp.ComplianceDataEvAgreement] : boolean | null
}
export type CustomerEntityGridRowComplianceDataFatca = {
 [CustomerEntityGridRowProp.ComplianceDataFatca] : 'YES' | 'NO' | null
}
export type CustomerEntityGridRowComplianceDataFirstDepositCountry = {
 [CustomerEntityGridRowProp.ComplianceDataFirstDepositCountry] : 'NA' | 'AFGHANISTAN' | 'ÅLAND_ISLANDS' | 'ALBANIA' | 'ALGERIA' | 'AMERICAN_SAMOA' | 'ANDORRA' | 'ANGOLA' | 'ANGUILLA' | 'ANTARCTICA' | 'ANTIGUA_AND_BARBUDA' | 'ARGENTINA' | 'ARMENIA' | 'ARUBA' | 'AUSTRALIA' | 'AUSTRIA' | 'AZERBAIJAN' | 'BAHAMAS' | 'BAHRAIN' | 'BANGLADESH' | 'BARBADOS' | 'BELARUS' | 'BELGIUM' | 'BELIZE' | 'BENIN' | 'BERMUDA' | 'BHUTAN' | 'BOLIVIA' | 'BONAIRE_SINT_EUSTATIUS_AND_SABA' | 'BOSNIA_AND_HERZEGOVINA' | 'BOTSWANA' | 'BOUVET_ISLAND' | 'BRAZIL' | 'BRITISH_INDIAN_OCEAN_TERRITORY' | 'BRUNEI_DARUSSALAM' | 'BULGARIA' | 'BURKINA_FASO' | 'BURUNDI' | 'CAMBODIA' | 'CAMEROON' | 'CANADA' | 'CAPE_VERDE' | 'CAYMAN_ISLANDS' | 'CENTRAL_AFRICAN_REPUBLIC' | 'CHAD' | 'CHILE' | 'CHINA' | 'CHRISTMAS_ISLAND' | 'COCOS_ISLANDS' | 'COLOMBIA' | 'COMOROS' | 'CONGO' | 'CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE' | 'COOK_ISLANDS' | 'COSTA_RICA' | 'CROATIA' | 'CUBA' | 'CURAÇAO' | 'CYPRUS' | 'CZECH_REPUBLIC' | 'CÔTE_DIVOIRE' | 'DENMARK' | 'DJIBOUTI' | 'DOMINICA' | 'DOMINICAN_REPUBLIC' | 'EAST_TIMOR' | 'ECUADOR' | 'EGYPT' | 'EL_SALVADOR' | 'EQUATORIAL_GUINEA' | 'ERITREA' | 'ESTONIA' | 'ETHIOPIA' | 'FALKLAND_ISLANDS' | 'FAROE_ISLANDS' | 'FIJI' | 'FINLAND' | 'FRANCE' | 'FRENCH_GUIANA' | 'FRENCH_POLYNESIA' | 'FRENCH_SOUTHERN_TERRITORIES' | 'GABON' | 'GAMBIA' | 'Georgia' | 'GERMANY' | 'GHANA' | 'GIBRALTAR' | 'GREECE' | 'GREENLAND' | 'GRENADA' | 'GUADELOUPE' | 'GUAM' | 'GUATEMALA' | 'GUERNSEY' | 'GUINEA' | 'GUINEA_BISSAU' | 'GUYANA' | 'HAITI' | 'HEARD_ISLAND_AND_MCDONALD_ISLANDS' | 'HONDURAS' | 'HONG_KONG' | 'Hungary' | 'ICELAND' | 'INDIA' | 'INDONESIA' | 'IRAN' | 'IRAQ' | 'IRELAND' | 'ISLE_OF_MAN' | 'ISRAEL' | 'ITALY' | 'JAMAICA' | 'JAPAN' | 'JERSEY' | 'JORDAN' | 'KAZAKHSTAN' | 'KENYA' | 'KIRIBATI' | 'KOSOVO' | 'KOREA_DEMOCRATIC_PEOPLE_REPUBLIC_OF' | 'KOREA_REPUBLIC_OF' | 'KUWAIT' | 'KYRGYZSTAN' | 'LAO_PEOPLE_DEMOCRATIC_REPUBLIC' | 'LATVIA' | 'LEBANON' | 'LESOTHO' | 'LIBERIA' | 'LIBYAN' | 'LIECHTENSTEIN' | 'LITHUANIA' | 'LUXEMBOURG' | 'MACAO' | 'MADAGASCAR' | 'MALAWI' | 'MALAYSIA' | 'MALDIVES' | 'MALI' | 'MALTA' | 'MARSHALL_ISLANDS' | 'MARTINIQUE' | 'MAURITANIA' | 'MAURITIUS' | 'MAYOTTE' | 'MEXICO' | 'MICRONESIA' | 'MOLDOVA_REPUBLIC_OF' | 'MONACO' | 'MONGOLIA' | 'MONTENEGRO' | 'MONTSERRAT' | 'MOROCCO' | 'MOZAMBIQUE' | 'MYANMAR' | 'NAMIBIA' | 'NAURU' | 'NEPAL' | 'NETHERLANDS' | 'NETHERLANDS_ANTILLES' | 'NEW_CALEDONIA' | 'NEW_ZEALAND' | 'NICARAGUA' | 'NIGER' | 'NIGERIA' | 'NIUE' | 'NORFOLK_ISLAND' | 'NORTHERN_MARIANA_ISLANDS' | 'NORWAY' | 'OMAN' | 'PAKISTAN' | 'PALAU' | 'PALESTINIAN_TERRITORY_OCCUPIED' | 'PANAMA' | 'PAPUA_NEW_GUINEA' | 'PARAGUAY' | 'PERU' | 'PHILIPPINES' | 'PITCAIRN' | 'POLAND' | 'PORTUGAL' | 'PUERTO_RICO' | 'QATAR' | 'ROMANIA' | 'RUSSIAN_FEDERATION' | 'RWANDA' | 'RÉUNION' | 'SAINT_BARTHÉLEMY_BL' | 'SAINT_HELENA' | 'SAINT_KITTS_AND_NEVIS' | 'SAINT_LUCIA' | 'SAINT_MARTIN_FRENCH_PART' | 'SAINT_PIERRE_AND_MIQUELON' | 'SAINT_VINCENT_AND_THE_GRENADINES' | 'SAMOA' | 'SAN_MARINO' | 'SAO_TOME_AND_PRINCIPE' | 'SAUDI_ARABIA' | 'SENEGAL' | 'SERBIA' | 'SEYCHELLES' | 'SIERRA_LEONE' | 'SINGAPORE' | 'SINT_MAARTEN_DUTCH_PART' | 'SLOVAKIA' | 'SLOVENIA' | 'SOLOMON_ISLANDS' | 'SOMALIA' | 'SOUTH_AFRICA' | 'SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS' | 'SOUTH_SUDAN' | 'SPAIN' | 'SRI_LANKA' | 'SUDAN' | 'SURINAME' | 'SVALBARD_AND_JAN_MAYEN' | 'SWAZILAND' | 'SWEDEN' | 'SWITZERLAND' | 'SYRIAN_ARAB_REPUBLIC' | 'TAIWAN' | 'TAJIKISTAN' | 'THAILAND' | 'THE_FORMER_YUGOSLAV_REPUBLIC_OF_MACEDONIA' | 'TOGO' | 'TOKELAU' | 'TONGA' | 'TRINIDAD_AND_TOBAGO' | 'TUNISIA' | 'TURKEY' | 'TURKMENISTAN' | 'TURKS_AND_CAICOS_ISLANDS' | 'TUVALU' | 'UGANDA' | 'UKRAINE' | 'UNITED_ARAB_EMIRATES' | 'UNITED_KINGDOM' | 'UNITED_REPUBLIC_OF_TANZANIA' | 'UNITED_STATES_MINOR_OUTLYING_ISLANDS' | 'URUGUAY' | 'USA' | 'UZBEKISTAN' | 'VANUATU' | 'VATICAN_CITY_STATE' | 'VENEZUELA' | 'VIET_NAM' | 'VIRGIN_ISLANDS_GB' | 'VIRGIN_ISLANDS_USA' | 'WALLIS_AND_FUTUNA' | 'WESTERN_SAHARA' | 'YEMEN' | 'ZAMBIA' | 'ZIMBABWE' | null
}
export type CustomerEntityGridRowComplianceDataGbgApproved = {
 [CustomerEntityGridRowProp.ComplianceDataGbgApproved] : 'UN_CHECKED' | 'PASSED' | 'REFER' | 'ALERT' | null
}
export type CustomerEntityGridRowComplianceDataHasProofOfId = {
 [CustomerEntityGridRowProp.ComplianceDataHasProofOfId] : boolean | null
}
export type CustomerEntityGridRowComplianceDataHasProofOfResidence = {
 [CustomerEntityGridRowProp.ComplianceDataHasProofOfResidence] : boolean | null
}
export type CustomerEntityGridRowComplianceDataPoliticallyExposedPerson = {
 [CustomerEntityGridRowProp.ComplianceDataPoliticallyExposedPerson] : 'NOT_RELEVANT' | 'YES' | 'NO' | null
}
export type CustomerEntityGridRowComplianceDataTaxJurisdiction = {
 [CustomerEntityGridRowProp.ComplianceDataTaxJurisdiction] : 'NOT_RELEVANT' | 'NO_JURISDICTION' | 'AFGHANISTAN' | 'ÅLAND_ISLANDS' | 'ALBANIA' | 'ALGERIA' | 'AMERICAN_SAMOA' | 'ANDORRA' | 'ANGOLA' | 'ANGUILLA' | 'ANTARCTICA' | 'ANTIGUA_AND_BARBUDA' | 'ARGENTINA' | 'ARMENIA' | 'ARUBA' | 'AUSTRALIA' | 'AUSTRIA' | 'AZERBAIJAN' | 'BAHAMAS' | 'BAHRAIN' | 'BANGLADESH' | 'BARBADOS' | 'BELARUS' | 'BELGIUM' | 'BELIZE' | 'BENIN' | 'BERMUDA' | 'BHUTAN' | 'BOLIVIA' | 'BONAIRE_SINT_EUSTATIUS_AND_SABA' | 'BOSNIA_AND_HERZEGOVINA' | 'BOTSWANA' | 'BOUVET_ISLAND' | 'BRAZIL' | 'BRITISH_INDIAN_OCEAN_TERRITORY' | 'BRUNEI_DARUSSALAM' | 'BULGARIA' | 'BURKINA_FASO' | 'BURUNDI' | 'CAMBODIA' | 'CAMEROON' | 'CANADA' | 'CAPE_VERDE' | 'CAYMAN_ISLANDS' | 'CENTRAL_AFRICAN_REPUBLIC' | 'CHAD' | 'CHILE' | 'CHINA' | 'CHRISTMAS_ISLAND' | 'COCOS_ISLANDS' | 'COLOMBIA' | 'COMOROS' | 'CONGO' | 'CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE' | 'COOK_ISLANDS' | 'COSTA_RICA' | 'CROATIA' | 'CUBA' | 'CURAÇAO' | 'CYPRUS' | 'CZECH_REPUBLIC' | 'CÔTE_DIVOIRE' | 'DENMARK' | 'DJIBOUTI' | 'DOMINICA' | 'DOMINICAN_REPUBLIC' | 'EAST_TIMOR' | 'ECUADOR' | 'EGYPT' | 'EL_SALVADOR' | 'EQUATORIAL_GUINEA' | 'ERITREA' | 'ESTONIA' | 'ETHIOPIA' | 'FALKLAND_ISLANDS' | 'FAROE_ISLANDS' | 'FIJI' | 'FINLAND' | 'FRANCE' | 'FRENCH_GUIANA' | 'FRENCH_POLYNESIA' | 'FRENCH_SOUTHERN_TERRITORIES' | 'GABON' | 'GAMBIA' | 'Georgia' | 'GERMANY' | 'GHANA' | 'GIBRALTAR' | 'GREECE' | 'GREENLAND' | 'GRENADA' | 'GUADELOUPE' | 'GUAM' | 'GUATEMALA' | 'GUERNSEY' | 'GUINEA' | 'GUINEA_BISSAU' | 'GUYANA' | 'HAITI' | 'HEARD_ISLAND_AND_MCDONALD_ISLANDS' | 'HONDURAS' | 'HONG_KONG' | 'Hungary' | 'ICELAND' | 'INDIA' | 'INDONESIA' | 'IRAN' | 'IRAQ' | 'IRELAND' | 'ISLE_OF_MAN' | 'ISRAEL' | 'ITALY' | 'JAMAICA' | 'JAPAN' | 'JERSEY' | 'JORDAN' | 'KAZAKHSTAN' | 'KENYA' | 'KIRIBATI' | 'KOREA_DEMOCRATIC_PEOPLE_REPUBLIC_OF' | 'KOREA_REPUBLIC_OF' | 'KOSOVO' | 'KUWAIT' | 'KYRGYZSTAN' | 'LAO_PEOPLE_DEMOCRATIC_REPUBLIC' | 'LATVIA' | 'LEBANON' | 'LESOTHO' | 'LIBERIA' | 'LIBYAN' | 'LIECHTENSTEIN' | 'LITHUANIA' | 'LUXEMBOURG' | 'MACAO' | 'MADAGASCAR' | 'MALAWI' | 'MALAYSIA' | 'MALDIVES' | 'MALI' | 'MALTA' | 'MARSHALL_ISLANDS' | 'MARTINIQUE' | 'MAURITANIA' | 'MAURITIUS' | 'MAYOTTE' | 'MEXICO' | 'MICRONESIA' | 'MOLDOVA_REPUBLIC_OF' | 'MONACO' | 'MONGOLIA' | 'MONTENEGRO' | 'MONTSERRAT' | 'MOROCCO' | 'MOZAMBIQUE' | 'MYANMAR' | 'NAMIBIA' | 'NAURU' | 'NEPAL' | 'NETHERLANDS' | 'NETHERLANDS_ANTILLES' | 'NEW_CALEDONIA' | 'NEW_ZEALAND' | 'NICARAGUA' | 'NIGER' | 'NIGERIA' | 'NIUE' | 'NORFOLK_ISLAND' | 'NORTHERN_MARIANA_ISLANDS' | 'NORWAY' | 'OMAN' | 'PAKISTAN' | 'PALAU' | 'PALESTINIAN_TERRITORY_OCCUPIED' | 'PANAMA' | 'PAPUA_NEW_GUINEA' | 'PARAGUAY' | 'PERU' | 'PHILIPPINES' | 'PITCAIRN' | 'POLAND' | 'PORTUGAL' | 'PUERTO_RICO' | 'QATAR' | 'ROMANIA' | 'RUSSIAN_FEDERATION' | 'RWANDA' | 'RÉUNION' | 'SAINT_BARTHÉLEMY_BL' | 'SAINT_HELENA' | 'SAINT_KITTS_AND_NEVIS' | 'SAINT_LUCIA' | 'SAINT_MARTIN_FRENCH_PART' | 'SAINT_PIERRE_AND_MIQUELON' | 'SAINT_VINCENT_AND_THE_GRENADINES' | 'SAMOA' | 'SAN_MARINO' | 'SAO_TOME_AND_PRINCIPE' | 'SAUDI_ARABIA' | 'SENEGAL' | 'SERBIA' | 'SEYCHELLES' | 'SIERRA_LEONE' | 'SINGAPORE' | 'SINT_MAARTEN_DUTCH_PART' | 'SLOVAKIA' | 'SLOVENIA' | 'SOLOMON_ISLANDS' | 'SOMALIA' | 'SOUTH_AFRICA' | 'SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS' | 'SOUTH_SUDAN' | 'SPAIN' | 'SRI_LANKA' | 'SUDAN' | 'SURINAME' | 'SVALBARD_AND_JAN_MAYEN' | 'SWAZILAND' | 'SWEDEN' | 'SWITZERLAND' | 'SYRIAN_ARAB_REPUBLIC' | 'TAIWAN' | 'TAJIKISTAN' | 'THAILAND' | 'THE_FORMER_YUGOSLAV_REPUBLIC_OF_MACEDONIA' | 'TOGO' | 'TOKELAU' | 'TONGA' | 'TRINIDAD_AND_TOBAGO' | 'TUNISIA' | 'TURKEY' | 'TURKMENISTAN' | 'TURKS_AND_CAICOS_ISLANDS' | 'TUVALU' | 'UGANDA' | 'UKRAINE' | 'UNITED_ARAB_EMIRATES' | 'UNITED_KINGDOM' | 'UNITED_REPUBLIC_OF_TANZANIA' | 'UNITED_STATES_MINOR_OUTLYING_ISLANDS' | 'URUGUAY' | 'USA' | 'UZBEKISTAN' | 'VANUATU' | 'VATICAN_CITY_STATE' | 'VENEZUELA' | 'VIET_NAM' | 'VIRGIN_ISLANDS_GB' | 'VIRGIN_ISLANDS_USA' | 'WALLIS_AND_FUTUNA' | 'WESTERN_SAHARA' | 'YEMEN' | 'ZAMBIA' | 'ZIMBABWE' | null
}
export type CustomerEntityGridRowComplianceDataW8Form = {
 [CustomerEntityGridRowProp.ComplianceDataW8Form] : boolean | null
}
export type CustomerEntityGridRowComplianceDataWorldCheckFulfilled = {
 [CustomerEntityGridRowProp.ComplianceDataWorldCheckFulfilled] : boolean | null
}
export type CustomerEntityGridRowCreationTime = {
 [CustomerEntityGridRowProp.CreationTime] : number | null
}
export type CustomerEntityGridRowCustomerAccountType = {
 [CustomerEntityGridRowProp.CustomerAccountType] : 'INDIVIDUALS' | 'INDIVIDUALS_HIGH_RISK' | 'INDIVIDUAL_PARTNER' | 'INDIVIDUAL_CLIENT' | 'INDIVIDUAL_LAPI' | 'CORPORATE_COMPANY_WITH_ORDINARY_SHARES' | 'CORPORATE_PARTNER' | 'CORPORATE_CLIENT' | 'CORPORATE_LAPI' | 'CORPORATE_LISTED_COMPANY' | 'CORPORATE_LICENSED_COMPANY' | 'CORPORATE_COMPANY_WITH_BEARER_SHARES' | 'CORPORATE_PARTNERSHIP' | 'CORPORATE_TRUST' | 'CORPORATE_FUNDS' | 'CORPORATE_OTHER' | 'DEALER_ACCOUNT' | 'JOINT_ACCOUNT' | 'MANAGED_AC' | 'INSTITUTIONAL_CLIENTS' | 'HEDGING_COUNTERPARTY' | 'CLEARING_ACCOUNT' | 'OFFSET_ACCOUNT' | 'OMNIBUS_PARTNER' | 'MAM_AC' | 'PROFESSIONAL_CORPORATE' | 'PROFESSIONAL_INDIVIDUAL' | 'PROFESSIONAL_INDIVIDUAL_SPREADBET' | 'RETAIL_CORPORATE' | 'CORPORATE_DATA_SALES_PARTNER' | 'CORPORATE_DATA_DISTRIBUTION_PARTNER' | 'OTHER' | null
}
export type CustomerEntityGridRowCustomerEntityType = {
 [CustomerEntityGridRowProp.CustomerEntityType] : 'Individual' | 'Corporate' | null
}
export type CustomerEntityGridRowCustomerFinancesTotalPendingDepositsAmount = {
 [CustomerEntityGridRowProp.CustomerFinancesTotalPendingDepositsAmount] : number | null
}
export type CustomerEntityGridRowId = {
 [CustomerEntityGridRowProp.Id] : number
}
export type CustomerEntityGridRowModificationTime = {
 [CustomerEntityGridRowProp.ModificationTime] : number | null
}
export type CustomerEntityGridRowOneClickClosingAccountStatus = {
 [CustomerEntityGridRowProp.OneClickClosingAccountStatus] : 'OPEN' | 'DECLINED' | 'TERMINATED' | null
}
export type CustomerEntityGridRowOneClickClosingAccountStatusModificationTime = {
 [CustomerEntityGridRowProp.OneClickClosingAccountStatusModificationTime] : number | null
}
export type CustomerEntityGridRowPartnerCompanyName = {
 [CustomerEntityGridRowProp.PartnerCompanyName] : string | null
}
export type CustomerEntityGridRowPersonCountry = {
 [CustomerEntityGridRowProp.PersonCountry] : 'NA' | 'AFGHANISTAN' | 'ÅLAND_ISLANDS' | 'ALBANIA' | 'ALGERIA' | 'AMERICAN_SAMOA' | 'ANDORRA' | 'ANGOLA' | 'ANGUILLA' | 'ANTARCTICA' | 'ANTIGUA_AND_BARBUDA' | 'ARGENTINA' | 'ARMENIA' | 'ARUBA' | 'AUSTRALIA' | 'AUSTRIA' | 'AZERBAIJAN' | 'BAHAMAS' | 'BAHRAIN' | 'BANGLADESH' | 'BARBADOS' | 'BELARUS' | 'BELGIUM' | 'BELIZE' | 'BENIN' | 'BERMUDA' | 'BHUTAN' | 'BOLIVIA' | 'BONAIRE_SINT_EUSTATIUS_AND_SABA' | 'BOSNIA_AND_HERZEGOVINA' | 'BOTSWANA' | 'BOUVET_ISLAND' | 'BRAZIL' | 'BRITISH_INDIAN_OCEAN_TERRITORY' | 'BRUNEI_DARUSSALAM' | 'BULGARIA' | 'BURKINA_FASO' | 'BURUNDI' | 'CAMBODIA' | 'CAMEROON' | 'CANADA' | 'CAPE_VERDE' | 'CAYMAN_ISLANDS' | 'CENTRAL_AFRICAN_REPUBLIC' | 'CHAD' | 'CHILE' | 'CHINA' | 'CHRISTMAS_ISLAND' | 'COCOS_ISLANDS' | 'COLOMBIA' | 'COMOROS' | 'CONGO' | 'CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE' | 'COOK_ISLANDS' | 'COSTA_RICA' | 'CROATIA' | 'CUBA' | 'CURAÇAO' | 'CYPRUS' | 'CZECH_REPUBLIC' | 'CÔTE_DIVOIRE' | 'DENMARK' | 'DJIBOUTI' | 'DOMINICA' | 'DOMINICAN_REPUBLIC' | 'EAST_TIMOR' | 'ECUADOR' | 'EGYPT' | 'EL_SALVADOR' | 'EQUATORIAL_GUINEA' | 'ERITREA' | 'ESTONIA' | 'ETHIOPIA' | 'FALKLAND_ISLANDS' | 'FAROE_ISLANDS' | 'FIJI' | 'FINLAND' | 'FRANCE' | 'FRENCH_GUIANA' | 'FRENCH_POLYNESIA' | 'FRENCH_SOUTHERN_TERRITORIES' | 'GABON' | 'GAMBIA' | 'Georgia' | 'GERMANY' | 'GHANA' | 'GIBRALTAR' | 'GREECE' | 'GREENLAND' | 'GRENADA' | 'GUADELOUPE' | 'GUAM' | 'GUATEMALA' | 'GUERNSEY' | 'GUINEA' | 'GUINEA_BISSAU' | 'GUYANA' | 'HAITI' | 'HEARD_ISLAND_AND_MCDONALD_ISLANDS' | 'HONDURAS' | 'HONG_KONG' | 'Hungary' | 'ICELAND' | 'INDIA' | 'INDONESIA' | 'IRAN' | 'IRAQ' | 'IRELAND' | 'ISLE_OF_MAN' | 'ISRAEL' | 'ITALY' | 'JAMAICA' | 'JAPAN' | 'JERSEY' | 'JORDAN' | 'KAZAKHSTAN' | 'KENYA' | 'KIRIBATI' | 'KOSOVO' | 'KOREA_DEMOCRATIC_PEOPLE_REPUBLIC_OF' | 'KOREA_REPUBLIC_OF' | 'KUWAIT' | 'KYRGYZSTAN' | 'LAO_PEOPLE_DEMOCRATIC_REPUBLIC' | 'LATVIA' | 'LEBANON' | 'LESOTHO' | 'LIBERIA' | 'LIBYAN' | 'LIECHTENSTEIN' | 'LITHUANIA' | 'LUXEMBOURG' | 'MACAO' | 'MADAGASCAR' | 'MALAWI' | 'MALAYSIA' | 'MALDIVES' | 'MALI' | 'MALTA' | 'MARSHALL_ISLANDS' | 'MARTINIQUE' | 'MAURITANIA' | 'MAURITIUS' | 'MAYOTTE' | 'MEXICO' | 'MICRONESIA' | 'MOLDOVA_REPUBLIC_OF' | 'MONACO' | 'MONGOLIA' | 'MONTENEGRO' | 'MONTSERRAT' | 'MOROCCO' | 'MOZAMBIQUE' | 'MYANMAR' | 'NAMIBIA' | 'NAURU' | 'NEPAL' | 'NETHERLANDS' | 'NETHERLANDS_ANTILLES' | 'NEW_CALEDONIA' | 'NEW_ZEALAND' | 'NICARAGUA' | 'NIGER' | 'NIGERIA' | 'NIUE' | 'NORFOLK_ISLAND' | 'NORTHERN_MARIANA_ISLANDS' | 'NORWAY' | 'OMAN' | 'PAKISTAN' | 'PALAU' | 'PALESTINIAN_TERRITORY_OCCUPIED' | 'PANAMA' | 'PAPUA_NEW_GUINEA' | 'PARAGUAY' | 'PERU' | 'PHILIPPINES' | 'PITCAIRN' | 'POLAND' | 'PORTUGAL' | 'PUERTO_RICO' | 'QATAR' | 'ROMANIA' | 'RUSSIAN_FEDERATION' | 'RWANDA' | 'RÉUNION' | 'SAINT_BARTHÉLEMY_BL' | 'SAINT_HELENA' | 'SAINT_KITTS_AND_NEVIS' | 'SAINT_LUCIA' | 'SAINT_MARTIN_FRENCH_PART' | 'SAINT_PIERRE_AND_MIQUELON' | 'SAINT_VINCENT_AND_THE_GRENADINES' | 'SAMOA' | 'SAN_MARINO' | 'SAO_TOME_AND_PRINCIPE' | 'SAUDI_ARABIA' | 'SENEGAL' | 'SERBIA' | 'SEYCHELLES' | 'SIERRA_LEONE' | 'SINGAPORE' | 'SINT_MAARTEN_DUTCH_PART' | 'SLOVAKIA' | 'SLOVENIA' | 'SOLOMON_ISLANDS' | 'SOMALIA' | 'SOUTH_AFRICA' | 'SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS' | 'SOUTH_SUDAN' | 'SPAIN' | 'SRI_LANKA' | 'SUDAN' | 'SURINAME' | 'SVALBARD_AND_JAN_MAYEN' | 'SWAZILAND' | 'SWEDEN' | 'SWITZERLAND' | 'SYRIAN_ARAB_REPUBLIC' | 'TAIWAN' | 'TAJIKISTAN' | 'THAILAND' | 'THE_FORMER_YUGOSLAV_REPUBLIC_OF_MACEDONIA' | 'TOGO' | 'TOKELAU' | 'TONGA' | 'TRINIDAD_AND_TOBAGO' | 'TUNISIA' | 'TURKEY' | 'TURKMENISTAN' | 'TURKS_AND_CAICOS_ISLANDS' | 'TUVALU' | 'UGANDA' | 'UKRAINE' | 'UNITED_ARAB_EMIRATES' | 'UNITED_KINGDOM' | 'UNITED_REPUBLIC_OF_TANZANIA' | 'UNITED_STATES_MINOR_OUTLYING_ISLANDS' | 'URUGUAY' | 'USA' | 'UZBEKISTAN' | 'VANUATU' | 'VATICAN_CITY_STATE' | 'VENEZUELA' | 'VIET_NAM' | 'VIRGIN_ISLANDS_GB' | 'VIRGIN_ISLANDS_USA' | 'WALLIS_AND_FUTUNA' | 'WESTERN_SAHARA' | 'YEMEN' | 'ZAMBIA' | 'ZIMBABWE' | null
}
export type CustomerEntityGridRowPersonFirstName = {
 [CustomerEntityGridRowProp.PersonFirstName] : string | null
}
export type CustomerEntityGridRowPersonLanguage = {
 [CustomerEntityGridRowProp.PersonLanguage] : 'OTHER' | 'ALBANIAN' | 'ARABIC' | 'BULGARIAN' | 'CATALAN' | 'CHINESE' | 'CHINESETR' | 'CROATIAN' | 'CZECH' | 'DANISH' | 'DUTCH' | 'ENGLISH' | 'ESTONIAN' | 'FINNISH' | 'FRENCH' | 'GALICIAN' | 'GERMAN' | 'GREEK' | 'HEBREW' | 'HINDI' | 'HUNGARIAN' | 'INDONESIAN' | 'ITALIAN' | 'JAPANESE' | 'KOREAN' | 'LATVIAN' | 'LITHUANIAN' | 'MALAY' | 'MALTESE' | 'NORWEGIAN' | 'PERSIAN' | 'POLISH' | 'PORTUGUESE' | 'PUNJABI' | 'ROMANIAN' | 'RUSSIAN' | 'SERBIAN' | 'SLOVAK' | 'SLOVENIAN' | 'SPANISH' | 'SWEDISH' | 'TAGALOG' | 'THAI' | 'TURKISH' | 'UKRAINIAN' | 'URDU' | 'VIETNAMESE' | null
}
export type CustomerEntityGridRowPersonLastName = {
 [CustomerEntityGridRowProp.PersonLastName] : string | null
}
export type CustomerEntityGridRowPersonLeiExpirationDate = {
 [CustomerEntityGridRowProp.PersonLeiExpirationDate] : number | null
}
export type CustomerEntityGridRowRegistrationTrafficSourceAffiliateId = {
 [CustomerEntityGridRowProp.RegistrationTrafficSourceAffiliateId] : string | null
}
export type CustomerEntityGridRowRegistrationStatus = {
 [CustomerEntityGridRowProp.RegistrationStatus] : 'LEAD' | 'DEMO' | 'REAL' | 'REAL_FUNDED' | null
}
export type CustomerEntityGridRowTotalDeposits = {
 [CustomerEntityGridRowProp.TotalDeposits] : number | null
}
export type CustomerEntityGridRowTotalWithdrawals = {
 [CustomerEntityGridRowProp.TotalWithdrawals] : number | null
}
export type CustomerEntityGridRowTradingTotalsRealEquity = {
 [CustomerEntityGridRowProp.TradingTotalsRealEquity] : number | null
}
export type CustomerEntityGridRow = 
 Partial<CustomerEntityGridRowAssignedPoolName> & 
 Partial<CustomerEntityGridRowAssignedUserLoginName> & 
 Partial<CustomerEntityGridRowBrandName> & 
 Partial<CustomerEntityGridRowCompanyRegulationCountryCompanyRegulationRegulationTypeName> & 
 Partial<CustomerEntityGridRowComplianceDataAmlCustomerQuestionnaireScore> & 
 Partial<CustomerEntityGridRowComplianceDataAppScoreLevel> & 
 Partial<CustomerEntityGridRowComplianceDataComplianceApprovedDate> & 
 Partial<CustomerEntityGridRowComplianceDataComplianceStage> & 
 Partial<CustomerEntityGridRowComplianceDataComplianceSuspensionDate> & 
 Partial<CustomerEntityGridRowComplianceDataEcddPerformed> & 
 Partial<CustomerEntityGridRowComplianceDataEvAgreement> & 
 Partial<CustomerEntityGridRowComplianceDataFatca> & 
 Partial<CustomerEntityGridRowComplianceDataFirstDepositCountry> & 
 Partial<CustomerEntityGridRowComplianceDataGbgApproved> & 
 Partial<CustomerEntityGridRowComplianceDataHasProofOfId> & 
 Partial<CustomerEntityGridRowComplianceDataHasProofOfResidence> & 
 Partial<CustomerEntityGridRowComplianceDataPoliticallyExposedPerson> & 
 Partial<CustomerEntityGridRowComplianceDataTaxJurisdiction> & 
 Partial<CustomerEntityGridRowComplianceDataW8Form> & 
 Partial<CustomerEntityGridRowComplianceDataWorldCheckFulfilled> & 
 Partial<CustomerEntityGridRowCreationTime> & 
 Partial<CustomerEntityGridRowCustomerAccountType> & 
 CustomerEntityGridRowCustomerEntityType & 
 Partial<CustomerEntityGridRowCustomerFinancesTotalPendingDepositsAmount> & 
 CustomerEntityGridRowId & 
 Partial<CustomerEntityGridRowModificationTime> & 
 Partial<CustomerEntityGridRowOneClickClosingAccountStatus> & 
 Partial<CustomerEntityGridRowOneClickClosingAccountStatusModificationTime> & 
 Partial<CustomerEntityGridRowPartnerCompanyName> & 
 Partial<CustomerEntityGridRowPersonCountry> & 
 Partial<CustomerEntityGridRowPersonFirstName> & 
 Partial<CustomerEntityGridRowPersonLanguage> & 
 Partial<CustomerEntityGridRowPersonLastName> & 
 Partial<CustomerEntityGridRowPersonLeiExpirationDate> & 
 Partial<CustomerEntityGridRowRegistrationTrafficSourceAffiliateId> & 
 Partial<CustomerEntityGridRowRegistrationStatus> & 
 Partial<CustomerEntityGridRowTotalDeposits> & 
 Partial<CustomerEntityGridRowTotalWithdrawals> & 
 Partial<CustomerEntityGridRowTradingTotalsRealEquity>

export enum CustomerAmlAlertEntityGridRowProp {
 AlertStage = 'alertStage',
 AmlAlertConfigurationAlertType = 'amlAlertConfiguration.alertType',
 AmlAlertConfigurationName = 'amlAlertConfiguration.name',
 CreationTime = 'creationTime',
 CustomerAssignedUser = 'customer.assignedUser',
 CustomerComplianceDataAmlCustomerQuestionnaireScore = 'customer.complianceData.amlCustomerQuestionnaire.score',
 CustomerComplianceDataClientClassification = 'customer.complianceData.clientClassification',
 CustomerComplianceDataComplianceStage = 'customer.complianceData.complianceStage',
 CustomerComplianceDataGbgApproved = 'customer.complianceData.gbgApproved',
 CustomerComplianceDataPoliticallyExposedPerson = 'customer.complianceData.politicallyExposedPerson',
 CustomerCustomerEntityType = 'customer.customerEntityType',
 CustomerCustomerFinancesLastActivityDate = 'customer.customerFinances.lastActivityDate',
 CustomerId = 'customer.id',
 CustomerOneClickClosingAccountStatus = 'customer.oneClickClosingAccountStatus',
 CustomerPartnerCompanyName = 'customer.partnerCompany.name',
 CustomerPersonCountry = 'customer.person.country',
 CustomerTotalDeposits = 'customer.totalDeposits',
 Id = 'id',
 ModificationTime = 'modificationTime',
 ModifiedBy = 'modifiedBy',
 StatusAvailableEntityStatusValue = 'status.availableEntityStatus.value'
}
export type CustomerAmlAlertEntityGridRowAlertStage = {
 [CustomerAmlAlertEntityGridRowProp.AlertStage] : 'NOT_TRIGGERED_ARROW' | 'TRIGGERED_PUQ_1ST_NOTICE' | 'TRIGGERED_PUQ_2ND_NOTICE' | 'PUQ_APPROVED' | 'PUQ_DECLINED' | 'PUQ_PENDING_FOR_REVIEW' | 'PUQ_NON_RESPONDED_CLIENTS' | 'TRIGGERED_TPSD_1ST_NOTICE' | 'TRIGGERED_TPSD_2ND_NOTICE' | 'TPSD_APPROVED' | 'TPSD_DECLINED' | 'TPSD_PENDING_FOR_REVIEW' | 'TPSD_NON_RESPONDED_CLIENTS' | 'TRIGGERED_RL_1ST_NOTICE' | 'TRIGGERED_RL_2ND_NOTICE' | 'RL_APPROVED' | 'RL_DECLINED' | 'RL_PENDING_FOR_REVIEW' | 'RL_NON_RESPONDED_CLIENTS' | null
}
export type CustomerAmlAlertEntityGridRowAmlAlertConfigurationAlertType = {
 [CustomerAmlAlertEntityGridRowProp.AmlAlertConfigurationAlertType] : 'GENERAL' | 'ARROW' | null
}
export type CustomerAmlAlertEntityGridRowAmlAlertConfigurationName = {
 [CustomerAmlAlertEntityGridRowProp.AmlAlertConfigurationName] : string | null
}
export type CustomerAmlAlertEntityGridRowCreationTime = {
 [CustomerAmlAlertEntityGridRowProp.CreationTime] : number | null
}
export type CustomerAmlAlertEntityGridRowCustomerAssignedUser = {
 [CustomerAmlAlertEntityGridRowProp.CustomerAssignedUser] : any /* Entity */
}
export type CustomerAmlAlertEntityGridRowCustomerComplianceDataAmlCustomerQuestionnaireScore = {
 [CustomerAmlAlertEntityGridRowProp.CustomerComplianceDataAmlCustomerQuestionnaireScore] : number | null
}
export type CustomerAmlAlertEntityGridRowCustomerComplianceDataClientClassification = {
 [CustomerAmlAlertEntityGridRowProp.CustomerComplianceDataClientClassification] : 'RETAIL' | 'ELECTIVE_PROFESSIONAL' | 'PROFESSIONAL' | 'ELIGIBLE_COUNTER_PARTY' | 'TECH_WHITELABEL' | null
}
export type CustomerAmlAlertEntityGridRowCustomerComplianceDataComplianceStage = {
 [CustomerAmlAlertEntityGridRowProp.CustomerComplianceDataComplianceStage] : 'NON_COMPLIANT' | 'COMPLIANT' | 'PENDING_COMPLIANCE' | 'LIMITED_COMPLIED' | 'COMPLIANCE_REVOKED' | 'COMPLIANCE_SUSPENDED' | null
}
export type CustomerAmlAlertEntityGridRowCustomerComplianceDataGbgApproved = {
 [CustomerAmlAlertEntityGridRowProp.CustomerComplianceDataGbgApproved] : 'UN_CHECKED' | 'PASSED' | 'REFER' | 'ALERT' | null
}
export type CustomerAmlAlertEntityGridRowCustomerComplianceDataPoliticallyExposedPerson = {
 [CustomerAmlAlertEntityGridRowProp.CustomerComplianceDataPoliticallyExposedPerson] : 'NOT_RELEVANT' | 'YES' | 'NO' | null
}
export type CustomerAmlAlertEntityGridRowCustomerCustomerEntityType = {
 [CustomerAmlAlertEntityGridRowProp.CustomerCustomerEntityType] : 'Individual' | 'Corporate' | null
}
export type CustomerAmlAlertEntityGridRowCustomerCustomerFinancesLastActivityDate = {
 [CustomerAmlAlertEntityGridRowProp.CustomerCustomerFinancesLastActivityDate] : number | null
}
export type CustomerAmlAlertEntityGridRowCustomerId = {
 [CustomerAmlAlertEntityGridRowProp.CustomerId] : number | null
}
export type CustomerAmlAlertEntityGridRowCustomerOneClickClosingAccountStatus = {
 [CustomerAmlAlertEntityGridRowProp.CustomerOneClickClosingAccountStatus] : 'OPEN' | 'DECLINED' | 'TERMINATED' | null
}
export type CustomerAmlAlertEntityGridRowCustomerPartnerCompanyName = {
 [CustomerAmlAlertEntityGridRowProp.CustomerPartnerCompanyName] : string | null
}
export type CustomerAmlAlertEntityGridRowCustomerPersonCountry = {
 [CustomerAmlAlertEntityGridRowProp.CustomerPersonCountry] : 'NA' | 'AFGHANISTAN' | 'ÅLAND_ISLANDS' | 'ALBANIA' | 'ALGERIA' | 'AMERICAN_SAMOA' | 'ANDORRA' | 'ANGOLA' | 'ANGUILLA' | 'ANTARCTICA' | 'ANTIGUA_AND_BARBUDA' | 'ARGENTINA' | 'ARMENIA' | 'ARUBA' | 'AUSTRALIA' | 'AUSTRIA' | 'AZERBAIJAN' | 'BAHAMAS' | 'BAHRAIN' | 'BANGLADESH' | 'BARBADOS' | 'BELARUS' | 'BELGIUM' | 'BELIZE' | 'BENIN' | 'BERMUDA' | 'BHUTAN' | 'BOLIVIA' | 'BONAIRE_SINT_EUSTATIUS_AND_SABA' | 'BOSNIA_AND_HERZEGOVINA' | 'BOTSWANA' | 'BOUVET_ISLAND' | 'BRAZIL' | 'BRITISH_INDIAN_OCEAN_TERRITORY' | 'BRUNEI_DARUSSALAM' | 'BULGARIA' | 'BURKINA_FASO' | 'BURUNDI' | 'CAMBODIA' | 'CAMEROON' | 'CANADA' | 'CAPE_VERDE' | 'CAYMAN_ISLANDS' | 'CENTRAL_AFRICAN_REPUBLIC' | 'CHAD' | 'CHILE' | 'CHINA' | 'CHRISTMAS_ISLAND' | 'COCOS_ISLANDS' | 'COLOMBIA' | 'COMOROS' | 'CONGO' | 'CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE' | 'COOK_ISLANDS' | 'COSTA_RICA' | 'CROATIA' | 'CUBA' | 'CURAÇAO' | 'CYPRUS' | 'CZECH_REPUBLIC' | 'CÔTE_DIVOIRE' | 'DENMARK' | 'DJIBOUTI' | 'DOMINICA' | 'DOMINICAN_REPUBLIC' | 'EAST_TIMOR' | 'ECUADOR' | 'EGYPT' | 'EL_SALVADOR' | 'EQUATORIAL_GUINEA' | 'ERITREA' | 'ESTONIA' | 'ETHIOPIA' | 'FALKLAND_ISLANDS' | 'FAROE_ISLANDS' | 'FIJI' | 'FINLAND' | 'FRANCE' | 'FRENCH_GUIANA' | 'FRENCH_POLYNESIA' | 'FRENCH_SOUTHERN_TERRITORIES' | 'GABON' | 'GAMBIA' | 'Georgia' | 'GERMANY' | 'GHANA' | 'GIBRALTAR' | 'GREECE' | 'GREENLAND' | 'GRENADA' | 'GUADELOUPE' | 'GUAM' | 'GUATEMALA' | 'GUERNSEY' | 'GUINEA' | 'GUINEA_BISSAU' | 'GUYANA' | 'HAITI' | 'HEARD_ISLAND_AND_MCDONALD_ISLANDS' | 'HONDURAS' | 'HONG_KONG' | 'Hungary' | 'ICELAND' | 'INDIA' | 'INDONESIA' | 'IRAN' | 'IRAQ' | 'IRELAND' | 'ISLE_OF_MAN' | 'ISRAEL' | 'ITALY' | 'JAMAICA' | 'JAPAN' | 'JERSEY' | 'JORDAN' | 'KAZAKHSTAN' | 'KENYA' | 'KIRIBATI' | 'KOSOVO' | 'KOREA_DEMOCRATIC_PEOPLE_REPUBLIC_OF' | 'KOREA_REPUBLIC_OF' | 'KUWAIT' | 'KYRGYZSTAN' | 'LAO_PEOPLE_DEMOCRATIC_REPUBLIC' | 'LATVIA' | 'LEBANON' | 'LESOTHO' | 'LIBERIA' | 'LIBYAN' | 'LIECHTENSTEIN' | 'LITHUANIA' | 'LUXEMBOURG' | 'MACAO' | 'MADAGASCAR' | 'MALAWI' | 'MALAYSIA' | 'MALDIVES' | 'MALI' | 'MALTA' | 'MARSHALL_ISLANDS' | 'MARTINIQUE' | 'MAURITANIA' | 'MAURITIUS' | 'MAYOTTE' | 'MEXICO' | 'MICRONESIA' | 'MOLDOVA_REPUBLIC_OF' | 'MONACO' | 'MONGOLIA' | 'MONTENEGRO' | 'MONTSERRAT' | 'MOROCCO' | 'MOZAMBIQUE' | 'MYANMAR' | 'NAMIBIA' | 'NAURU' | 'NEPAL' | 'NETHERLANDS' | 'NETHERLANDS_ANTILLES' | 'NEW_CALEDONIA' | 'NEW_ZEALAND' | 'NICARAGUA' | 'NIGER' | 'NIGERIA' | 'NIUE' | 'NORFOLK_ISLAND' | 'NORTHERN_MARIANA_ISLANDS' | 'NORWAY' | 'OMAN' | 'PAKISTAN' | 'PALAU' | 'PALESTINIAN_TERRITORY_OCCUPIED' | 'PANAMA' | 'PAPUA_NEW_GUINEA' | 'PARAGUAY' | 'PERU' | 'PHILIPPINES' | 'PITCAIRN' | 'POLAND' | 'PORTUGAL' | 'PUERTO_RICO' | 'QATAR' | 'ROMANIA' | 'RUSSIAN_FEDERATION' | 'RWANDA' | 'RÉUNION' | 'SAINT_BARTHÉLEMY_BL' | 'SAINT_HELENA' | 'SAINT_KITTS_AND_NEVIS' | 'SAINT_LUCIA' | 'SAINT_MARTIN_FRENCH_PART' | 'SAINT_PIERRE_AND_MIQUELON' | 'SAINT_VINCENT_AND_THE_GRENADINES' | 'SAMOA' | 'SAN_MARINO' | 'SAO_TOME_AND_PRINCIPE' | 'SAUDI_ARABIA' | 'SENEGAL' | 'SERBIA' | 'SEYCHELLES' | 'SIERRA_LEONE' | 'SINGAPORE' | 'SINT_MAARTEN_DUTCH_PART' | 'SLOVAKIA' | 'SLOVENIA' | 'SOLOMON_ISLANDS' | 'SOMALIA' | 'SOUTH_AFRICA' | 'SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS' | 'SOUTH_SUDAN' | 'SPAIN' | 'SRI_LANKA' | 'SUDAN' | 'SURINAME' | 'SVALBARD_AND_JAN_MAYEN' | 'SWAZILAND' | 'SWEDEN' | 'SWITZERLAND' | 'SYRIAN_ARAB_REPUBLIC' | 'TAIWAN' | 'TAJIKISTAN' | 'THAILAND' | 'THE_FORMER_YUGOSLAV_REPUBLIC_OF_MACEDONIA' | 'TOGO' | 'TOKELAU' | 'TONGA' | 'TRINIDAD_AND_TOBAGO' | 'TUNISIA' | 'TURKEY' | 'TURKMENISTAN' | 'TURKS_AND_CAICOS_ISLANDS' | 'TUVALU' | 'UGANDA' | 'UKRAINE' | 'UNITED_ARAB_EMIRATES' | 'UNITED_KINGDOM' | 'UNITED_REPUBLIC_OF_TANZANIA' | 'UNITED_STATES_MINOR_OUTLYING_ISLANDS' | 'URUGUAY' | 'USA' | 'UZBEKISTAN' | 'VANUATU' | 'VATICAN_CITY_STATE' | 'VENEZUELA' | 'VIET_NAM' | 'VIRGIN_ISLANDS_GB' | 'VIRGIN_ISLANDS_USA' | 'WALLIS_AND_FUTUNA' | 'WESTERN_SAHARA' | 'YEMEN' | 'ZAMBIA' | 'ZIMBABWE' | null
}
export type CustomerAmlAlertEntityGridRowCustomerTotalDeposits = {
 [CustomerAmlAlertEntityGridRowProp.CustomerTotalDeposits] : number | null
}
export type CustomerAmlAlertEntityGridRowId = {
 [CustomerAmlAlertEntityGridRowProp.Id] : number
}
export type CustomerAmlAlertEntityGridRowModificationTime = {
 [CustomerAmlAlertEntityGridRowProp.ModificationTime] : number | null
}
export type CustomerAmlAlertEntityGridRowModifiedBy = {
 [CustomerAmlAlertEntityGridRowProp.ModifiedBy] : string | null
}
export type CustomerAmlAlertEntityGridRowStatusAvailableEntityStatusValue = {
 [CustomerAmlAlertEntityGridRowProp.StatusAvailableEntityStatusValue] : string | null
}
export type CustomerAmlAlertEntityGridRow = 
 Partial<CustomerAmlAlertEntityGridRowAlertStage> & 
 Partial<CustomerAmlAlertEntityGridRowAmlAlertConfigurationAlertType> & 
 Partial<CustomerAmlAlertEntityGridRowAmlAlertConfigurationName> & 
 Partial<CustomerAmlAlertEntityGridRowCreationTime> & 
 Partial<CustomerAmlAlertEntityGridRowCustomerAssignedUser> & 
 Partial<CustomerAmlAlertEntityGridRowCustomerComplianceDataAmlCustomerQuestionnaireScore> & 
 Partial<CustomerAmlAlertEntityGridRowCustomerComplianceDataClientClassification> & 
 Partial<CustomerAmlAlertEntityGridRowCustomerComplianceDataComplianceStage> & 
 Partial<CustomerAmlAlertEntityGridRowCustomerComplianceDataGbgApproved> & 
 Partial<CustomerAmlAlertEntityGridRowCustomerComplianceDataPoliticallyExposedPerson> & 
 Partial<CustomerAmlAlertEntityGridRowCustomerCustomerEntityType> & 
 Partial<CustomerAmlAlertEntityGridRowCustomerCustomerFinancesLastActivityDate> & 
 Partial<CustomerAmlAlertEntityGridRowCustomerId> & 
 Partial<CustomerAmlAlertEntityGridRowCustomerOneClickClosingAccountStatus> & 
 Partial<CustomerAmlAlertEntityGridRowCustomerPartnerCompanyName> & 
 Partial<CustomerAmlAlertEntityGridRowCustomerPersonCountry> & 
 Partial<CustomerAmlAlertEntityGridRowCustomerTotalDeposits> & 
 CustomerAmlAlertEntityGridRowId & 
 Partial<CustomerAmlAlertEntityGridRowModificationTime> & 
 Partial<CustomerAmlAlertEntityGridRowModifiedBy> & 
 Partial<CustomerAmlAlertEntityGridRowStatusAvailableEntityStatusValue>

export enum CustomerCampaignLoginEntityGridRowProp {
 AffiliateId = 'affiliateId',
 CampaignName = 'campaignName',
 Id = 'id'
}
export type CustomerCampaignLoginEntityGridRowAffiliateId = {
 [CustomerCampaignLoginEntityGridRowProp.AffiliateId] : string | null
}
export type CustomerCampaignLoginEntityGridRowCampaignName = {
 [CustomerCampaignLoginEntityGridRowProp.CampaignName] : string | null
}
export type CustomerCampaignLoginEntityGridRowId = {
 [CustomerCampaignLoginEntityGridRowProp.Id] : number
}
export type CustomerCampaignLoginEntityGridRow = 
 Partial<CustomerCampaignLoginEntityGridRowAffiliateId> & 
 Partial<CustomerCampaignLoginEntityGridRowCampaignName> & 
 CustomerCampaignLoginEntityGridRowId

export enum CustomerDocumentEntityGridRowProp {
 __documentButtons = '__documentButtons',
 CreatedBy = 'createdBy',
 CreationTime = 'creationTime',
 Description = 'description',
 DocumentType = 'documentType',
 DocumentableEntityBrandName = 'documentableEntity.brand.name',
 DocumentableEntityCompanyRegulationCountryCompanyRegulationPartnerCompanyName = 'documentableEntity.companyRegulationCountry.companyRegulation.partnerCompany.name',
 DocumentableEntityComplianceDataComplianceStage = 'documentableEntity.complianceData.complianceStage',
 DocumentableEntityCustomerFinancesTotalPendingDepositsAmount = 'documentableEntity.customerFinances.totalPendingDepositsAmount',
 DocumentableEntityId = 'documentableEntity.id',
 DocumentableEntityPersonCitizenship = 'documentableEntity.person.citizenship',
 DocumentableEntityPersonCountry = 'documentableEntity.person.country',
 DocumentableEntityPersonName = 'documentableEntity.person.name',
 DocumentableEntityTotalDeposits = 'documentableEntity.totalDeposits',
 ExpirationDate = 'expirationDate',
 Id = 'id',
 ModificationTime = 'modificationTime',
 ModifiedBy = 'modifiedBy',
 Name = 'name',
 Primary = 'primary',
 Status = 'status',
 VerificationStatus = 'verificationStatus',
 VerifiedBy = 'verifiedBy'
}
export type CustomerDocumentEntityGridRow__documentButtons = {
 [CustomerDocumentEntityGridRowProp.__documentButtons] : string | null
}
export type CustomerDocumentEntityGridRowCreatedBy = {
 [CustomerDocumentEntityGridRowProp.CreatedBy] : string | null
}
export type CustomerDocumentEntityGridRowCreationTime = {
 [CustomerDocumentEntityGridRowProp.CreationTime] : number | null
}
export type CustomerDocumentEntityGridRowDescription = {
 [CustomerDocumentEntityGridRowProp.Description] : string | null
}
export type CustomerDocumentEntityGridRowDocumentType = {
 [CustomerDocumentEntityGridRowProp.DocumentType] : 'ADDITIONAL_RESEARCH' | 'API_AGREEMENT' | 'BANK_CONFIRMATION_LETTER' | 'CERTIFIED_PROOF_OF_ID' | 'CERTIFIED_PROOF_OF_RESIDENCE' | 'CLARIFICATIONS' | 'CLIENT_PROFILE_REVIEW' | 'CONTRACT_AGREEMENT' | 'CREDIT_CARD_BACK' | 'CREDIT_CARD_CANCELLATION_LETTER' | 'CREDIT_CARD_FRONT' | 'CREDIT_CARD_OWNERSHIP_LETTER' | 'CREDIT_CARD_SCREENSHOT_WITHIN_ONLINE_BANKING' | 'CREDIT_CARD_STATEMENT' | 'CREDIT_LINE_AGREEMENT' | 'DECLARATION_OF_ADDRESS' | 'DECLARATION_OF_FAMILY_MEMBER' | 'DMA_STATEMENT' | 'ELECTIVE_PROFESSIONAL_CLASSIFICATION_NOTICE' | 'ELECTIVE_PROFESSIONAL_QUESTIONNAIRE' | 'EMAIL' | 'EMIR_FORM' | 'ENHANCED_VERIFICATION_PROOF' | 'FINANCIAL_DOCUMENTS' | 'IB_AGREEMENT' | 'JOINT_ACCOUNT_FORM' | 'LANDLINE_MOBILE_PHONE_BILL' | 'MARRIAGE_CERTIFICATE' | 'MASTERFILE' | 'NDA' | 'NEGATIVE_BALANCE_PROTECTION' | 'PAYMENT_ADDENDUM' | 'PAYMENT_METHOD_CANCELLATION' | 'PAYMENT_METHOD_OWNERSHIP' | 'PER_SE_PROFESSIONAL_CLASSIFICATION_NOTICE' | 'PHONE_VERIFICATION' | 'POWER_OF_ATTORNEY' | 'PROFESSIONAL_CLIENT_APPLICATION' | 'PROFILE_UPDATE_QUESTIONNAIRE' | 'PROOF_OF_ID' | 'PROOF_OF_ID_BACK' | 'PROOF_OF_ID_FAMILY_MEMBER' | 'PROOF_OF_ID_FRONT' | 'PROOF_OF_RESIDENCE' | 'REFERENCE_LETTER' | 'SELFIE' | 'STATEMENTS_OF_DEPOSITS' | 'STATEMENT_REGARDING_MEETING' | 'SWAP_FREE_FORM' | 'SWIFT' | 'TECH_QUESTIONNAIRE' | 'THIRD_PARTY_CREDIT_CARD_AGREEMENT' | 'THIRD_PARTY_E_WALLET_AGREEMENT' | 'THIRD_PARTY_PROOF_OF_ID' | 'THIRD_PARTY_PROOF_OF_RESIDENCE' | 'THIRD_PARTY_SUPPORTING_EVIDENCE' | 'THIRD_PARTY_WIRE_TRANSFER_AGREEMENT' | 'TITLE_TRANSFER_AGREEMENT_FULL' | 'TITLE_TRANSFER_AGREEMENT_MARGIN_ONLY' | 'W8_FORM' | 'WAIVER_LETTER' | 'WIRE_TRANSFER_DOCUMENT' | 'WITHDRAWAL_REQUEST' | 'WOLFSBERG_FORM' | 'WORLD_CHECK_PASSOWRD_RESULT' | 'WORLD_CHECK_SEARCH_RESULT' | 'OTHER' | null
}
export type CustomerDocumentEntityGridRowDocumentableEntityBrandName = {
 [CustomerDocumentEntityGridRowProp.DocumentableEntityBrandName] : string | null
}
export type CustomerDocumentEntityGridRowDocumentableEntityCompanyRegulationCountryCompanyRegulationPartnerCompanyName = {
 [CustomerDocumentEntityGridRowProp.DocumentableEntityCompanyRegulationCountryCompanyRegulationPartnerCompanyName] : string | null
}
export type CustomerDocumentEntityGridRowDocumentableEntityComplianceDataComplianceStage = {
 [CustomerDocumentEntityGridRowProp.DocumentableEntityComplianceDataComplianceStage] : 'NON_COMPLIANT' | 'COMPLIANT' | 'PENDING_COMPLIANCE' | 'LIMITED_COMPLIED' | 'COMPLIANCE_REVOKED' | 'COMPLIANCE_SUSPENDED' | null
}
export type CustomerDocumentEntityGridRowDocumentableEntityCustomerFinancesTotalPendingDepositsAmount = {
 [CustomerDocumentEntityGridRowProp.DocumentableEntityCustomerFinancesTotalPendingDepositsAmount] : number | null
}
export type CustomerDocumentEntityGridRowDocumentableEntityId = {
 [CustomerDocumentEntityGridRowProp.DocumentableEntityId] : number | null
}
export type CustomerDocumentEntityGridRowDocumentableEntityPersonCitizenship = {
 [CustomerDocumentEntityGridRowProp.DocumentableEntityPersonCitizenship] : 'NA' | 'AFGHANISTAN' | 'ÅLAND_ISLANDS' | 'ALBANIA' | 'ALGERIA' | 'AMERICAN_SAMOA' | 'ANDORRA' | 'ANGOLA' | 'ANGUILLA' | 'ANTARCTICA' | 'ANTIGUA_AND_BARBUDA' | 'ARGENTINA' | 'ARMENIA' | 'ARUBA' | 'AUSTRALIA' | 'AUSTRIA' | 'AZERBAIJAN' | 'BAHAMAS' | 'BAHRAIN' | 'BANGLADESH' | 'BARBADOS' | 'BELARUS' | 'BELGIUM' | 'BELIZE' | 'BENIN' | 'BERMUDA' | 'BHUTAN' | 'BOLIVIA' | 'BONAIRE_SINT_EUSTATIUS_AND_SABA' | 'BOSNIA_AND_HERZEGOVINA' | 'BOTSWANA' | 'BOUVET_ISLAND' | 'BRAZIL' | 'BRITISH_INDIAN_OCEAN_TERRITORY' | 'BRUNEI_DARUSSALAM' | 'BULGARIA' | 'BURKINA_FASO' | 'BURUNDI' | 'CAMBODIA' | 'CAMEROON' | 'CANADA' | 'CAPE_VERDE' | 'CAYMAN_ISLANDS' | 'CENTRAL_AFRICAN_REPUBLIC' | 'CHAD' | 'CHILE' | 'CHINA' | 'CHRISTMAS_ISLAND' | 'COCOS_ISLANDS' | 'COLOMBIA' | 'COMOROS' | 'CONGO' | 'CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE' | 'COOK_ISLANDS' | 'COSTA_RICA' | 'CROATIA' | 'CUBA' | 'CURAÇAO' | 'CYPRUS' | 'CZECH_REPUBLIC' | 'CÔTE_DIVOIRE' | 'DENMARK' | 'DJIBOUTI' | 'DOMINICA' | 'DOMINICAN_REPUBLIC' | 'EAST_TIMOR' | 'ECUADOR' | 'EGYPT' | 'EL_SALVADOR' | 'EQUATORIAL_GUINEA' | 'ERITREA' | 'ESTONIA' | 'ETHIOPIA' | 'FALKLAND_ISLANDS' | 'FAROE_ISLANDS' | 'FIJI' | 'FINLAND' | 'FRANCE' | 'FRENCH_GUIANA' | 'FRENCH_POLYNESIA' | 'FRENCH_SOUTHERN_TERRITORIES' | 'GABON' | 'GAMBIA' | 'Georgia' | 'GERMANY' | 'GHANA' | 'GIBRALTAR' | 'GREECE' | 'GREENLAND' | 'GRENADA' | 'GUADELOUPE' | 'GUAM' | 'GUATEMALA' | 'GUERNSEY' | 'GUINEA' | 'GUINEA_BISSAU' | 'GUYANA' | 'HAITI' | 'HEARD_ISLAND_AND_MCDONALD_ISLANDS' | 'HONDURAS' | 'HONG_KONG' | 'Hungary' | 'ICELAND' | 'INDIA' | 'INDONESIA' | 'IRAN' | 'IRAQ' | 'IRELAND' | 'ISLE_OF_MAN' | 'ISRAEL' | 'ITALY' | 'JAMAICA' | 'JAPAN' | 'JERSEY' | 'JORDAN' | 'KAZAKHSTAN' | 'KENYA' | 'KIRIBATI' | 'KOSOVO' | 'KOREA_DEMOCRATIC_PEOPLE_REPUBLIC_OF' | 'KOREA_REPUBLIC_OF' | 'KUWAIT' | 'KYRGYZSTAN' | 'LAO_PEOPLE_DEMOCRATIC_REPUBLIC' | 'LATVIA' | 'LEBANON' | 'LESOTHO' | 'LIBERIA' | 'LIBYAN' | 'LIECHTENSTEIN' | 'LITHUANIA' | 'LUXEMBOURG' | 'MACAO' | 'MADAGASCAR' | 'MALAWI' | 'MALAYSIA' | 'MALDIVES' | 'MALI' | 'MALTA' | 'MARSHALL_ISLANDS' | 'MARTINIQUE' | 'MAURITANIA' | 'MAURITIUS' | 'MAYOTTE' | 'MEXICO' | 'MICRONESIA' | 'MOLDOVA_REPUBLIC_OF' | 'MONACO' | 'MONGOLIA' | 'MONTENEGRO' | 'MONTSERRAT' | 'MOROCCO' | 'MOZAMBIQUE' | 'MYANMAR' | 'NAMIBIA' | 'NAURU' | 'NEPAL' | 'NETHERLANDS' | 'NETHERLANDS_ANTILLES' | 'NEW_CALEDONIA' | 'NEW_ZEALAND' | 'NICARAGUA' | 'NIGER' | 'NIGERIA' | 'NIUE' | 'NORFOLK_ISLAND' | 'NORTHERN_MARIANA_ISLANDS' | 'NORWAY' | 'OMAN' | 'PAKISTAN' | 'PALAU' | 'PALESTINIAN_TERRITORY_OCCUPIED' | 'PANAMA' | 'PAPUA_NEW_GUINEA' | 'PARAGUAY' | 'PERU' | 'PHILIPPINES' | 'PITCAIRN' | 'POLAND' | 'PORTUGAL' | 'PUERTO_RICO' | 'QATAR' | 'ROMANIA' | 'RUSSIAN_FEDERATION' | 'RWANDA' | 'RÉUNION' | 'SAINT_BARTHÉLEMY_BL' | 'SAINT_HELENA' | 'SAINT_KITTS_AND_NEVIS' | 'SAINT_LUCIA' | 'SAINT_MARTIN_FRENCH_PART' | 'SAINT_PIERRE_AND_MIQUELON' | 'SAINT_VINCENT_AND_THE_GRENADINES' | 'SAMOA' | 'SAN_MARINO' | 'SAO_TOME_AND_PRINCIPE' | 'SAUDI_ARABIA' | 'SENEGAL' | 'SERBIA' | 'SEYCHELLES' | 'SIERRA_LEONE' | 'SINGAPORE' | 'SINT_MAARTEN_DUTCH_PART' | 'SLOVAKIA' | 'SLOVENIA' | 'SOLOMON_ISLANDS' | 'SOMALIA' | 'SOUTH_AFRICA' | 'SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS' | 'SOUTH_SUDAN' | 'SPAIN' | 'SRI_LANKA' | 'SUDAN' | 'SURINAME' | 'SVALBARD_AND_JAN_MAYEN' | 'SWAZILAND' | 'SWEDEN' | 'SWITZERLAND' | 'SYRIAN_ARAB_REPUBLIC' | 'TAIWAN' | 'TAJIKISTAN' | 'THAILAND' | 'THE_FORMER_YUGOSLAV_REPUBLIC_OF_MACEDONIA' | 'TOGO' | 'TOKELAU' | 'TONGA' | 'TRINIDAD_AND_TOBAGO' | 'TUNISIA' | 'TURKEY' | 'TURKMENISTAN' | 'TURKS_AND_CAICOS_ISLANDS' | 'TUVALU' | 'UGANDA' | 'UKRAINE' | 'UNITED_ARAB_EMIRATES' | 'UNITED_KINGDOM' | 'UNITED_REPUBLIC_OF_TANZANIA' | 'UNITED_STATES_MINOR_OUTLYING_ISLANDS' | 'URUGUAY' | 'USA' | 'UZBEKISTAN' | 'VANUATU' | 'VATICAN_CITY_STATE' | 'VENEZUELA' | 'VIET_NAM' | 'VIRGIN_ISLANDS_GB' | 'VIRGIN_ISLANDS_USA' | 'WALLIS_AND_FUTUNA' | 'WESTERN_SAHARA' | 'YEMEN' | 'ZAMBIA' | 'ZIMBABWE' | null
}
export type CustomerDocumentEntityGridRowDocumentableEntityPersonCountry = {
 [CustomerDocumentEntityGridRowProp.DocumentableEntityPersonCountry] : 'NA' | 'AFGHANISTAN' | 'ÅLAND_ISLANDS' | 'ALBANIA' | 'ALGERIA' | 'AMERICAN_SAMOA' | 'ANDORRA' | 'ANGOLA' | 'ANGUILLA' | 'ANTARCTICA' | 'ANTIGUA_AND_BARBUDA' | 'ARGENTINA' | 'ARMENIA' | 'ARUBA' | 'AUSTRALIA' | 'AUSTRIA' | 'AZERBAIJAN' | 'BAHAMAS' | 'BAHRAIN' | 'BANGLADESH' | 'BARBADOS' | 'BELARUS' | 'BELGIUM' | 'BELIZE' | 'BENIN' | 'BERMUDA' | 'BHUTAN' | 'BOLIVIA' | 'BONAIRE_SINT_EUSTATIUS_AND_SABA' | 'BOSNIA_AND_HERZEGOVINA' | 'BOTSWANA' | 'BOUVET_ISLAND' | 'BRAZIL' | 'BRITISH_INDIAN_OCEAN_TERRITORY' | 'BRUNEI_DARUSSALAM' | 'BULGARIA' | 'BURKINA_FASO' | 'BURUNDI' | 'CAMBODIA' | 'CAMEROON' | 'CANADA' | 'CAPE_VERDE' | 'CAYMAN_ISLANDS' | 'CENTRAL_AFRICAN_REPUBLIC' | 'CHAD' | 'CHILE' | 'CHINA' | 'CHRISTMAS_ISLAND' | 'COCOS_ISLANDS' | 'COLOMBIA' | 'COMOROS' | 'CONGO' | 'CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE' | 'COOK_ISLANDS' | 'COSTA_RICA' | 'CROATIA' | 'CUBA' | 'CURAÇAO' | 'CYPRUS' | 'CZECH_REPUBLIC' | 'CÔTE_DIVOIRE' | 'DENMARK' | 'DJIBOUTI' | 'DOMINICA' | 'DOMINICAN_REPUBLIC' | 'EAST_TIMOR' | 'ECUADOR' | 'EGYPT' | 'EL_SALVADOR' | 'EQUATORIAL_GUINEA' | 'ERITREA' | 'ESTONIA' | 'ETHIOPIA' | 'FALKLAND_ISLANDS' | 'FAROE_ISLANDS' | 'FIJI' | 'FINLAND' | 'FRANCE' | 'FRENCH_GUIANA' | 'FRENCH_POLYNESIA' | 'FRENCH_SOUTHERN_TERRITORIES' | 'GABON' | 'GAMBIA' | 'Georgia' | 'GERMANY' | 'GHANA' | 'GIBRALTAR' | 'GREECE' | 'GREENLAND' | 'GRENADA' | 'GUADELOUPE' | 'GUAM' | 'GUATEMALA' | 'GUERNSEY' | 'GUINEA' | 'GUINEA_BISSAU' | 'GUYANA' | 'HAITI' | 'HEARD_ISLAND_AND_MCDONALD_ISLANDS' | 'HONDURAS' | 'HONG_KONG' | 'Hungary' | 'ICELAND' | 'INDIA' | 'INDONESIA' | 'IRAN' | 'IRAQ' | 'IRELAND' | 'ISLE_OF_MAN' | 'ISRAEL' | 'ITALY' | 'JAMAICA' | 'JAPAN' | 'JERSEY' | 'JORDAN' | 'KAZAKHSTAN' | 'KENYA' | 'KIRIBATI' | 'KOSOVO' | 'KOREA_DEMOCRATIC_PEOPLE_REPUBLIC_OF' | 'KOREA_REPUBLIC_OF' | 'KUWAIT' | 'KYRGYZSTAN' | 'LAO_PEOPLE_DEMOCRATIC_REPUBLIC' | 'LATVIA' | 'LEBANON' | 'LESOTHO' | 'LIBERIA' | 'LIBYAN' | 'LIECHTENSTEIN' | 'LITHUANIA' | 'LUXEMBOURG' | 'MACAO' | 'MADAGASCAR' | 'MALAWI' | 'MALAYSIA' | 'MALDIVES' | 'MALI' | 'MALTA' | 'MARSHALL_ISLANDS' | 'MARTINIQUE' | 'MAURITANIA' | 'MAURITIUS' | 'MAYOTTE' | 'MEXICO' | 'MICRONESIA' | 'MOLDOVA_REPUBLIC_OF' | 'MONACO' | 'MONGOLIA' | 'MONTENEGRO' | 'MONTSERRAT' | 'MOROCCO' | 'MOZAMBIQUE' | 'MYANMAR' | 'NAMIBIA' | 'NAURU' | 'NEPAL' | 'NETHERLANDS' | 'NETHERLANDS_ANTILLES' | 'NEW_CALEDONIA' | 'NEW_ZEALAND' | 'NICARAGUA' | 'NIGER' | 'NIGERIA' | 'NIUE' | 'NORFOLK_ISLAND' | 'NORTHERN_MARIANA_ISLANDS' | 'NORWAY' | 'OMAN' | 'PAKISTAN' | 'PALAU' | 'PALESTINIAN_TERRITORY_OCCUPIED' | 'PANAMA' | 'PAPUA_NEW_GUINEA' | 'PARAGUAY' | 'PERU' | 'PHILIPPINES' | 'PITCAIRN' | 'POLAND' | 'PORTUGAL' | 'PUERTO_RICO' | 'QATAR' | 'ROMANIA' | 'RUSSIAN_FEDERATION' | 'RWANDA' | 'RÉUNION' | 'SAINT_BARTHÉLEMY_BL' | 'SAINT_HELENA' | 'SAINT_KITTS_AND_NEVIS' | 'SAINT_LUCIA' | 'SAINT_MARTIN_FRENCH_PART' | 'SAINT_PIERRE_AND_MIQUELON' | 'SAINT_VINCENT_AND_THE_GRENADINES' | 'SAMOA' | 'SAN_MARINO' | 'SAO_TOME_AND_PRINCIPE' | 'SAUDI_ARABIA' | 'SENEGAL' | 'SERBIA' | 'SEYCHELLES' | 'SIERRA_LEONE' | 'SINGAPORE' | 'SINT_MAARTEN_DUTCH_PART' | 'SLOVAKIA' | 'SLOVENIA' | 'SOLOMON_ISLANDS' | 'SOMALIA' | 'SOUTH_AFRICA' | 'SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS' | 'SOUTH_SUDAN' | 'SPAIN' | 'SRI_LANKA' | 'SUDAN' | 'SURINAME' | 'SVALBARD_AND_JAN_MAYEN' | 'SWAZILAND' | 'SWEDEN' | 'SWITZERLAND' | 'SYRIAN_ARAB_REPUBLIC' | 'TAIWAN' | 'TAJIKISTAN' | 'THAILAND' | 'THE_FORMER_YUGOSLAV_REPUBLIC_OF_MACEDONIA' | 'TOGO' | 'TOKELAU' | 'TONGA' | 'TRINIDAD_AND_TOBAGO' | 'TUNISIA' | 'TURKEY' | 'TURKMENISTAN' | 'TURKS_AND_CAICOS_ISLANDS' | 'TUVALU' | 'UGANDA' | 'UKRAINE' | 'UNITED_ARAB_EMIRATES' | 'UNITED_KINGDOM' | 'UNITED_REPUBLIC_OF_TANZANIA' | 'UNITED_STATES_MINOR_OUTLYING_ISLANDS' | 'URUGUAY' | 'USA' | 'UZBEKISTAN' | 'VANUATU' | 'VATICAN_CITY_STATE' | 'VENEZUELA' | 'VIET_NAM' | 'VIRGIN_ISLANDS_GB' | 'VIRGIN_ISLANDS_USA' | 'WALLIS_AND_FUTUNA' | 'WESTERN_SAHARA' | 'YEMEN' | 'ZAMBIA' | 'ZIMBABWE' | null
}
export type CustomerDocumentEntityGridRowDocumentableEntityPersonName = {
 [CustomerDocumentEntityGridRowProp.DocumentableEntityPersonName] : string | null
}
export type CustomerDocumentEntityGridRowDocumentableEntityTotalDeposits = {
 [CustomerDocumentEntityGridRowProp.DocumentableEntityTotalDeposits] : number | null
}
export type CustomerDocumentEntityGridRowExpirationDate = {
 [CustomerDocumentEntityGridRowProp.ExpirationDate] : number | null
}
export type CustomerDocumentEntityGridRowId = {
 [CustomerDocumentEntityGridRowProp.Id] : number
}
export type CustomerDocumentEntityGridRowModificationTime = {
 [CustomerDocumentEntityGridRowProp.ModificationTime] : number | null
}
export type CustomerDocumentEntityGridRowModifiedBy = {
 [CustomerDocumentEntityGridRowProp.ModifiedBy] : string | null
}
export type CustomerDocumentEntityGridRowName = {
 [CustomerDocumentEntityGridRowProp.Name] : string | null
}
export type CustomerDocumentEntityGridRowPrimary = {
 [CustomerDocumentEntityGridRowProp.Primary] : boolean | null
}
export type CustomerDocumentEntityGridRowStatus = {
 [CustomerDocumentEntityGridRowProp.Status] : 'PENDING' | 'APPROVED' | 'REJECTED' | 'EXPIRED' | 'INPROCCESS' | 'PENDING_EXPIRATION' | null
}
export type CustomerDocumentEntityGridRowVerificationStatus = {
 [CustomerDocumentEntityGridRowProp.VerificationStatus] : string | null
}
export type CustomerDocumentEntityGridRowVerifiedBy = {
 [CustomerDocumentEntityGridRowProp.VerifiedBy] : any /* Entity */
}
export type CustomerDocumentEntityGridRow = 
 Partial<CustomerDocumentEntityGridRow__documentButtons> & 
 Partial<CustomerDocumentEntityGridRowCreatedBy> & 
 Partial<CustomerDocumentEntityGridRowCreationTime> & 
 Partial<CustomerDocumentEntityGridRowDescription> & 
 Partial<CustomerDocumentEntityGridRowDocumentType> & 
 Partial<CustomerDocumentEntityGridRowDocumentableEntityBrandName> & 
 Partial<CustomerDocumentEntityGridRowDocumentableEntityCompanyRegulationCountryCompanyRegulationPartnerCompanyName> & 
 Partial<CustomerDocumentEntityGridRowDocumentableEntityComplianceDataComplianceStage> & 
 Partial<CustomerDocumentEntityGridRowDocumentableEntityCustomerFinancesTotalPendingDepositsAmount> & 
 Partial<CustomerDocumentEntityGridRowDocumentableEntityId> & 
 Partial<CustomerDocumentEntityGridRowDocumentableEntityPersonCitizenship> & 
 Partial<CustomerDocumentEntityGridRowDocumentableEntityPersonCountry> & 
 Partial<CustomerDocumentEntityGridRowDocumentableEntityPersonName> & 
 Partial<CustomerDocumentEntityGridRowDocumentableEntityTotalDeposits> & 
 Partial<CustomerDocumentEntityGridRowExpirationDate> & 
 CustomerDocumentEntityGridRowId & 
 Partial<CustomerDocumentEntityGridRowModificationTime> & 
 Partial<CustomerDocumentEntityGridRowModifiedBy> & 
 Partial<CustomerDocumentEntityGridRowName> & 
 Partial<CustomerDocumentEntityGridRowPrimary> & 
 Partial<CustomerDocumentEntityGridRowStatus> & 
 Partial<CustomerDocumentEntityGridRowVerificationStatus> & 
 Partial<CustomerDocumentEntityGridRowVerifiedBy>

export enum CustomerECDDQuestionEntityGridRowProp {
 CreationTime = 'creationTime',
 EcddQuestionQuestionName = 'ecddQuestion.questionName',
 Id = 'id',
 VerificationTime = 'verificationTime',
 Verified = 'verified',
 VerifiedBy = 'verifiedBy'
}
export type CustomerECDDQuestionEntityGridRowCreationTime = {
 [CustomerECDDQuestionEntityGridRowProp.CreationTime] : number | null
}
export type CustomerECDDQuestionEntityGridRowEcddQuestionQuestionName = {
 [CustomerECDDQuestionEntityGridRowProp.EcddQuestionQuestionName] : string | null
}
export type CustomerECDDQuestionEntityGridRowId = {
 [CustomerECDDQuestionEntityGridRowProp.Id] : number
}
export type CustomerECDDQuestionEntityGridRowVerificationTime = {
 [CustomerECDDQuestionEntityGridRowProp.VerificationTime] : number | null
}
export type CustomerECDDQuestionEntityGridRowVerified = {
 [CustomerECDDQuestionEntityGridRowProp.Verified] : boolean | null
}
export type CustomerECDDQuestionEntityGridRowVerifiedBy = {
 [CustomerECDDQuestionEntityGridRowProp.VerifiedBy] : any /* Entity */
}
export type CustomerECDDQuestionEntityGridRow = 
 Partial<CustomerECDDQuestionEntityGridRowCreationTime> & 
 Partial<CustomerECDDQuestionEntityGridRowEcddQuestionQuestionName> & 
 CustomerECDDQuestionEntityGridRowId & 
 Partial<CustomerECDDQuestionEntityGridRowVerificationTime> & 
 Partial<CustomerECDDQuestionEntityGridRowVerified> & 
 Partial<CustomerECDDQuestionEntityGridRowVerifiedBy>

export enum CustomerPushNotificationEntityGridRowProp {
 DeviceId = 'deviceId',
 Id = 'id',
 PushNotificationId = 'pushNotificationId'
}
export type CustomerPushNotificationEntityGridRowDeviceId = {
 [CustomerPushNotificationEntityGridRowProp.DeviceId] : string | null
}
export type CustomerPushNotificationEntityGridRowId = {
 [CustomerPushNotificationEntityGridRowProp.Id] : number
}
export type CustomerPushNotificationEntityGridRowPushNotificationId = {
 [CustomerPushNotificationEntityGridRowProp.PushNotificationId] : string | null
}
export type CustomerPushNotificationEntityGridRow = 
 Partial<CustomerPushNotificationEntityGridRowDeviceId> & 
 CustomerPushNotificationEntityGridRowId & 
 Partial<CustomerPushNotificationEntityGridRowPushNotificationId>

export enum CustomerQuestionnaireAnswerEntityGridRowProp {
 __questionnaireCriteriaReviewButtons = '__questionnaireCriteriaReviewButtons',
 __questionnaireDefaultButtons = '__questionnaireDefaultButtons',
 AnswerName = 'answer.name',
 AnswerScore = 'answer.score',
 Description = 'description',
 Id = 'id',
 ModificationTime = 'modificationTime',
 OtherAnswer = 'otherAnswer',
 QuestionName = 'question.name',
 QuestionShortName = 'question.shortName',
 UserApprovalApprovalDate = 'userApproval.approvalDate',
 UserApprovalApprovedByLoginName = 'userApproval.approvedBy.loginName',
 UserApprovalStatus = 'userApproval.status'
}
export type CustomerQuestionnaireAnswerEntityGridRow__questionnaireCriteriaReviewButtons = {
 [CustomerQuestionnaireAnswerEntityGridRowProp.__questionnaireCriteriaReviewButtons] : string | null
}
export type CustomerQuestionnaireAnswerEntityGridRow__questionnaireDefaultButtons = {
 [CustomerQuestionnaireAnswerEntityGridRowProp.__questionnaireDefaultButtons] : string | null
}
export type CustomerQuestionnaireAnswerEntityGridRowAnswerName = {
 [CustomerQuestionnaireAnswerEntityGridRowProp.AnswerName] : string | null
}
export type CustomerQuestionnaireAnswerEntityGridRowAnswerScore = {
 [CustomerQuestionnaireAnswerEntityGridRowProp.AnswerScore] : number | null
}
export type CustomerQuestionnaireAnswerEntityGridRowDescription = {
 [CustomerQuestionnaireAnswerEntityGridRowProp.Description] : string | null
}
export type CustomerQuestionnaireAnswerEntityGridRowId = {
 [CustomerQuestionnaireAnswerEntityGridRowProp.Id] : number
}
export type CustomerQuestionnaireAnswerEntityGridRowModificationTime = {
 [CustomerQuestionnaireAnswerEntityGridRowProp.ModificationTime] : number | null
}
export type CustomerQuestionnaireAnswerEntityGridRowOtherAnswer = {
 [CustomerQuestionnaireAnswerEntityGridRowProp.OtherAnswer] : string | null
}
export type CustomerQuestionnaireAnswerEntityGridRowQuestionName = {
 [CustomerQuestionnaireAnswerEntityGridRowProp.QuestionName] : string | null
}
export type CustomerQuestionnaireAnswerEntityGridRowQuestionShortName = {
 [CustomerQuestionnaireAnswerEntityGridRowProp.QuestionShortName] : string | null
}
export type CustomerQuestionnaireAnswerEntityGridRowUserApprovalApprovalDate = {
 [CustomerQuestionnaireAnswerEntityGridRowProp.UserApprovalApprovalDate] : number | null
}
export type CustomerQuestionnaireAnswerEntityGridRowUserApprovalApprovedByLoginName = {
 [CustomerQuestionnaireAnswerEntityGridRowProp.UserApprovalApprovedByLoginName] : string | null
}
export type CustomerQuestionnaireAnswerEntityGridRowUserApprovalStatus = {
 [CustomerQuestionnaireAnswerEntityGridRowProp.UserApprovalStatus] : 'PENDING' | 'IN_PROGRESS' | 'REJECTED' | 'APPROVED' | null
}
export type CustomerQuestionnaireAnswerEntityGridRow = 
 Partial<CustomerQuestionnaireAnswerEntityGridRow__questionnaireCriteriaReviewButtons> & 
 Partial<CustomerQuestionnaireAnswerEntityGridRow__questionnaireDefaultButtons> & 
 Partial<CustomerQuestionnaireAnswerEntityGridRowAnswerName> & 
 Partial<CustomerQuestionnaireAnswerEntityGridRowAnswerScore> & 
 Partial<CustomerQuestionnaireAnswerEntityGridRowDescription> & 
 CustomerQuestionnaireAnswerEntityGridRowId & 
 Partial<CustomerQuestionnaireAnswerEntityGridRowModificationTime> & 
 Partial<CustomerQuestionnaireAnswerEntityGridRowOtherAnswer> & 
 Partial<CustomerQuestionnaireAnswerEntityGridRowQuestionName> & 
 Partial<CustomerQuestionnaireAnswerEntityGridRowQuestionShortName> & 
 Partial<CustomerQuestionnaireAnswerEntityGridRowUserApprovalApprovalDate> & 
 Partial<CustomerQuestionnaireAnswerEntityGridRowUserApprovalApprovedByLoginName> & 
 Partial<CustomerQuestionnaireAnswerEntityGridRowUserApprovalStatus>

export enum CustomerWorldCheckEntityGridRowProp {
 CaseId = 'caseId',
 CreationTime = 'creationTime',
 Id = 'id',
 ModificationTime = 'modificationTime',
 Status = 'status',
 TotalFalse = 'totalFalse',
 TotalNumberOfMatches = 'totalNumberOfMatches',
 TotalPositive = 'totalPositive',
 TotalPossible = 'totalPossible',
 TotalUnresolved = 'totalUnresolved',
 TotalUnspecified = 'totalUnspecified'
}
export type CustomerWorldCheckEntityGridRowCaseId = {
 [CustomerWorldCheckEntityGridRowProp.CaseId] : string | null
}
export type CustomerWorldCheckEntityGridRowCreationTime = {
 [CustomerWorldCheckEntityGridRowProp.CreationTime] : number | null
}
export type CustomerWorldCheckEntityGridRowId = {
 [CustomerWorldCheckEntityGridRowProp.Id] : number
}
export type CustomerWorldCheckEntityGridRowModificationTime = {
 [CustomerWorldCheckEntityGridRowProp.ModificationTime] : number | null
}
export type CustomerWorldCheckEntityGridRowStatus = {
 [CustomerWorldCheckEntityGridRowProp.Status] : 'PENDING' | 'NO_MATCH' | 'MATCHED' | 'FAILED' | 'POSITIVE' | null
}
export type CustomerWorldCheckEntityGridRowTotalFalse = {
 [CustomerWorldCheckEntityGridRowProp.TotalFalse] : number | null
}
export type CustomerWorldCheckEntityGridRowTotalNumberOfMatches = {
 [CustomerWorldCheckEntityGridRowProp.TotalNumberOfMatches] : number | null
}
export type CustomerWorldCheckEntityGridRowTotalPositive = {
 [CustomerWorldCheckEntityGridRowProp.TotalPositive] : number | null
}
export type CustomerWorldCheckEntityGridRowTotalPossible = {
 [CustomerWorldCheckEntityGridRowProp.TotalPossible] : number | null
}
export type CustomerWorldCheckEntityGridRowTotalUnresolved = {
 [CustomerWorldCheckEntityGridRowProp.TotalUnresolved] : number | null
}
export type CustomerWorldCheckEntityGridRowTotalUnspecified = {
 [CustomerWorldCheckEntityGridRowProp.TotalUnspecified] : number | null
}
export type CustomerWorldCheckEntityGridRow = 
 Partial<CustomerWorldCheckEntityGridRowCaseId> & 
 Partial<CustomerWorldCheckEntityGridRowCreationTime> & 
 CustomerWorldCheckEntityGridRowId & 
 Partial<CustomerWorldCheckEntityGridRowModificationTime> & 
 Partial<CustomerWorldCheckEntityGridRowStatus> & 
 Partial<CustomerWorldCheckEntityGridRowTotalFalse> & 
 Partial<CustomerWorldCheckEntityGridRowTotalNumberOfMatches> & 
 Partial<CustomerWorldCheckEntityGridRowTotalPositive> & 
 Partial<CustomerWorldCheckEntityGridRowTotalPossible> & 
 Partial<CustomerWorldCheckEntityGridRowTotalUnresolved> & 
 Partial<CustomerWorldCheckEntityGridRowTotalUnspecified>

export enum EmailVerificationInfoEntityGridRowProp {
 Code = 'code',
 CreationTime = 'creationTime',
 EmailTo = 'emailTo',
 Id = 'id',
 Language = 'language',
 Source = 'source',
 VerificationCount = 'verificationCount',
 VerificationTime = 'verificationTime'
}
export type EmailVerificationInfoEntityGridRowCode = {
 [EmailVerificationInfoEntityGridRowProp.Code] : string | null
}
export type EmailVerificationInfoEntityGridRowCreationTime = {
 [EmailVerificationInfoEntityGridRowProp.CreationTime] : number | null
}
export type EmailVerificationInfoEntityGridRowEmailTo = {
 [EmailVerificationInfoEntityGridRowProp.EmailTo] : string | null
}
export type EmailVerificationInfoEntityGridRowId = {
 [EmailVerificationInfoEntityGridRowProp.Id] : number
}
export type EmailVerificationInfoEntityGridRowLanguage = {
 [EmailVerificationInfoEntityGridRowProp.Language] : string | null
}
export type EmailVerificationInfoEntityGridRowSource = {
 [EmailVerificationInfoEntityGridRowProp.Source] : 'REGISTRATION' | 'LOGIN' | 'UPDATE_PASSWORD' | null
}
export type EmailVerificationInfoEntityGridRowVerificationCount = {
 [EmailVerificationInfoEntityGridRowProp.VerificationCount] : number | null
}
export type EmailVerificationInfoEntityGridRowVerificationTime = {
 [EmailVerificationInfoEntityGridRowProp.VerificationTime] : number | null
}
export type EmailVerificationInfoEntityGridRow = 
 Partial<EmailVerificationInfoEntityGridRowCode> & 
 Partial<EmailVerificationInfoEntityGridRowCreationTime> & 
 Partial<EmailVerificationInfoEntityGridRowEmailTo> & 
 EmailVerificationInfoEntityGridRowId & 
 Partial<EmailVerificationInfoEntityGridRowLanguage> & 
 Partial<EmailVerificationInfoEntityGridRowSource> & 
 Partial<EmailVerificationInfoEntityGridRowVerificationCount> & 
 Partial<EmailVerificationInfoEntityGridRowVerificationTime>

export enum JointCustomerEntityGridRowProp {
 AssignedPoolName = 'assignedPool.name',
 AssignedUser = 'assignedUser',
 ComplianceDataComplianceStage = 'complianceData.complianceStage',
 ComplianceDataCustomerQuestionnaireScore = 'complianceData.customerQuestionnaire.score',
 CreationTime = 'creationTime',
 Id = 'id',
 JointAccountReason = 'jointAccountReason',
 JointPrimaryOwner = 'jointPrimaryOwner',
 Objective = 'objective',
 PersonCountry = 'person.country',
 PersonFirstName = 'person.firstName',
 PersonLastName = 'person.lastName',
 PersonNameEnglish = 'person.nameEnglish',
 RegistrationTrafficSourceAffiliateId = 'registration.trafficSource.affiliateId',
 RegistrationStatus = 'registrationStatus',
 TotalDeposits = 'totalDeposits'
}
export type JointCustomerEntityGridRowAssignedPoolName = {
 [JointCustomerEntityGridRowProp.AssignedPoolName] : string | null
}
export type JointCustomerEntityGridRowAssignedUser = {
 [JointCustomerEntityGridRowProp.AssignedUser] : any /* Entity */
}
export type JointCustomerEntityGridRowComplianceDataComplianceStage = {
 [JointCustomerEntityGridRowProp.ComplianceDataComplianceStage] : 'NON_COMPLIANT' | 'COMPLIANT' | 'PENDING_COMPLIANCE' | 'LIMITED_COMPLIED' | 'COMPLIANCE_REVOKED' | 'COMPLIANCE_SUSPENDED' | null
}
export type JointCustomerEntityGridRowComplianceDataCustomerQuestionnaireScore = {
 [JointCustomerEntityGridRowProp.ComplianceDataCustomerQuestionnaireScore] : number | null
}
export type JointCustomerEntityGridRowCreationTime = {
 [JointCustomerEntityGridRowProp.CreationTime] : number | null
}
export type JointCustomerEntityGridRowId = {
 [JointCustomerEntityGridRowProp.Id] : number
}
export type JointCustomerEntityGridRowJointAccountReason = {
 [JointCustomerEntityGridRowProp.JointAccountReason] : string | null
}
export type JointCustomerEntityGridRowJointPrimaryOwner = {
 [JointCustomerEntityGridRowProp.JointPrimaryOwner] : boolean | null
}
export type JointCustomerEntityGridRowObjective = {
 [JointCustomerEntityGridRowProp.Objective] : 'SALE_INTRODUCTION_CALL' | 'DEPOSIT' | 'COMPLETE_COMPLIANCE' | 'RETENTION' | null
}
export type JointCustomerEntityGridRowPersonCountry = {
 [JointCustomerEntityGridRowProp.PersonCountry] : 'NA' | 'AFGHANISTAN' | 'ÅLAND_ISLANDS' | 'ALBANIA' | 'ALGERIA' | 'AMERICAN_SAMOA' | 'ANDORRA' | 'ANGOLA' | 'ANGUILLA' | 'ANTARCTICA' | 'ANTIGUA_AND_BARBUDA' | 'ARGENTINA' | 'ARMENIA' | 'ARUBA' | 'AUSTRALIA' | 'AUSTRIA' | 'AZERBAIJAN' | 'BAHAMAS' | 'BAHRAIN' | 'BANGLADESH' | 'BARBADOS' | 'BELARUS' | 'BELGIUM' | 'BELIZE' | 'BENIN' | 'BERMUDA' | 'BHUTAN' | 'BOLIVIA' | 'BONAIRE_SINT_EUSTATIUS_AND_SABA' | 'BOSNIA_AND_HERZEGOVINA' | 'BOTSWANA' | 'BOUVET_ISLAND' | 'BRAZIL' | 'BRITISH_INDIAN_OCEAN_TERRITORY' | 'BRUNEI_DARUSSALAM' | 'BULGARIA' | 'BURKINA_FASO' | 'BURUNDI' | 'CAMBODIA' | 'CAMEROON' | 'CANADA' | 'CAPE_VERDE' | 'CAYMAN_ISLANDS' | 'CENTRAL_AFRICAN_REPUBLIC' | 'CHAD' | 'CHILE' | 'CHINA' | 'CHRISTMAS_ISLAND' | 'COCOS_ISLANDS' | 'COLOMBIA' | 'COMOROS' | 'CONGO' | 'CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE' | 'COOK_ISLANDS' | 'COSTA_RICA' | 'CROATIA' | 'CUBA' | 'CURAÇAO' | 'CYPRUS' | 'CZECH_REPUBLIC' | 'CÔTE_DIVOIRE' | 'DENMARK' | 'DJIBOUTI' | 'DOMINICA' | 'DOMINICAN_REPUBLIC' | 'EAST_TIMOR' | 'ECUADOR' | 'EGYPT' | 'EL_SALVADOR' | 'EQUATORIAL_GUINEA' | 'ERITREA' | 'ESTONIA' | 'ETHIOPIA' | 'FALKLAND_ISLANDS' | 'FAROE_ISLANDS' | 'FIJI' | 'FINLAND' | 'FRANCE' | 'FRENCH_GUIANA' | 'FRENCH_POLYNESIA' | 'FRENCH_SOUTHERN_TERRITORIES' | 'GABON' | 'GAMBIA' | 'Georgia' | 'GERMANY' | 'GHANA' | 'GIBRALTAR' | 'GREECE' | 'GREENLAND' | 'GRENADA' | 'GUADELOUPE' | 'GUAM' | 'GUATEMALA' | 'GUERNSEY' | 'GUINEA' | 'GUINEA_BISSAU' | 'GUYANA' | 'HAITI' | 'HEARD_ISLAND_AND_MCDONALD_ISLANDS' | 'HONDURAS' | 'HONG_KONG' | 'Hungary' | 'ICELAND' | 'INDIA' | 'INDONESIA' | 'IRAN' | 'IRAQ' | 'IRELAND' | 'ISLE_OF_MAN' | 'ISRAEL' | 'ITALY' | 'JAMAICA' | 'JAPAN' | 'JERSEY' | 'JORDAN' | 'KAZAKHSTAN' | 'KENYA' | 'KIRIBATI' | 'KOSOVO' | 'KOREA_DEMOCRATIC_PEOPLE_REPUBLIC_OF' | 'KOREA_REPUBLIC_OF' | 'KUWAIT' | 'KYRGYZSTAN' | 'LAO_PEOPLE_DEMOCRATIC_REPUBLIC' | 'LATVIA' | 'LEBANON' | 'LESOTHO' | 'LIBERIA' | 'LIBYAN' | 'LIECHTENSTEIN' | 'LITHUANIA' | 'LUXEMBOURG' | 'MACAO' | 'MADAGASCAR' | 'MALAWI' | 'MALAYSIA' | 'MALDIVES' | 'MALI' | 'MALTA' | 'MARSHALL_ISLANDS' | 'MARTINIQUE' | 'MAURITANIA' | 'MAURITIUS' | 'MAYOTTE' | 'MEXICO' | 'MICRONESIA' | 'MOLDOVA_REPUBLIC_OF' | 'MONACO' | 'MONGOLIA' | 'MONTENEGRO' | 'MONTSERRAT' | 'MOROCCO' | 'MOZAMBIQUE' | 'MYANMAR' | 'NAMIBIA' | 'NAURU' | 'NEPAL' | 'NETHERLANDS' | 'NETHERLANDS_ANTILLES' | 'NEW_CALEDONIA' | 'NEW_ZEALAND' | 'NICARAGUA' | 'NIGER' | 'NIGERIA' | 'NIUE' | 'NORFOLK_ISLAND' | 'NORTHERN_MARIANA_ISLANDS' | 'NORWAY' | 'OMAN' | 'PAKISTAN' | 'PALAU' | 'PALESTINIAN_TERRITORY_OCCUPIED' | 'PANAMA' | 'PAPUA_NEW_GUINEA' | 'PARAGUAY' | 'PERU' | 'PHILIPPINES' | 'PITCAIRN' | 'POLAND' | 'PORTUGAL' | 'PUERTO_RICO' | 'QATAR' | 'ROMANIA' | 'RUSSIAN_FEDERATION' | 'RWANDA' | 'RÉUNION' | 'SAINT_BARTHÉLEMY_BL' | 'SAINT_HELENA' | 'SAINT_KITTS_AND_NEVIS' | 'SAINT_LUCIA' | 'SAINT_MARTIN_FRENCH_PART' | 'SAINT_PIERRE_AND_MIQUELON' | 'SAINT_VINCENT_AND_THE_GRENADINES' | 'SAMOA' | 'SAN_MARINO' | 'SAO_TOME_AND_PRINCIPE' | 'SAUDI_ARABIA' | 'SENEGAL' | 'SERBIA' | 'SEYCHELLES' | 'SIERRA_LEONE' | 'SINGAPORE' | 'SINT_MAARTEN_DUTCH_PART' | 'SLOVAKIA' | 'SLOVENIA' | 'SOLOMON_ISLANDS' | 'SOMALIA' | 'SOUTH_AFRICA' | 'SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS' | 'SOUTH_SUDAN' | 'SPAIN' | 'SRI_LANKA' | 'SUDAN' | 'SURINAME' | 'SVALBARD_AND_JAN_MAYEN' | 'SWAZILAND' | 'SWEDEN' | 'SWITZERLAND' | 'SYRIAN_ARAB_REPUBLIC' | 'TAIWAN' | 'TAJIKISTAN' | 'THAILAND' | 'THE_FORMER_YUGOSLAV_REPUBLIC_OF_MACEDONIA' | 'TOGO' | 'TOKELAU' | 'TONGA' | 'TRINIDAD_AND_TOBAGO' | 'TUNISIA' | 'TURKEY' | 'TURKMENISTAN' | 'TURKS_AND_CAICOS_ISLANDS' | 'TUVALU' | 'UGANDA' | 'UKRAINE' | 'UNITED_ARAB_EMIRATES' | 'UNITED_KINGDOM' | 'UNITED_REPUBLIC_OF_TANZANIA' | 'UNITED_STATES_MINOR_OUTLYING_ISLANDS' | 'URUGUAY' | 'USA' | 'UZBEKISTAN' | 'VANUATU' | 'VATICAN_CITY_STATE' | 'VENEZUELA' | 'VIET_NAM' | 'VIRGIN_ISLANDS_GB' | 'VIRGIN_ISLANDS_USA' | 'WALLIS_AND_FUTUNA' | 'WESTERN_SAHARA' | 'YEMEN' | 'ZAMBIA' | 'ZIMBABWE' | null
}
export type JointCustomerEntityGridRowPersonFirstName = {
 [JointCustomerEntityGridRowProp.PersonFirstName] : string | null
}
export type JointCustomerEntityGridRowPersonLastName = {
 [JointCustomerEntityGridRowProp.PersonLastName] : string | null
}
export type JointCustomerEntityGridRowPersonNameEnglish = {
 [JointCustomerEntityGridRowProp.PersonNameEnglish] : string | null
}
export type JointCustomerEntityGridRowRegistrationTrafficSourceAffiliateId = {
 [JointCustomerEntityGridRowProp.RegistrationTrafficSourceAffiliateId] : string | null
}
export type JointCustomerEntityGridRowRegistrationStatus = {
 [JointCustomerEntityGridRowProp.RegistrationStatus] : 'LEAD' | 'DEMO' | 'REAL' | 'REAL_FUNDED' | null
}
export type JointCustomerEntityGridRowTotalDeposits = {
 [JointCustomerEntityGridRowProp.TotalDeposits] : number | null
}
export type JointCustomerEntityGridRow = 
 Partial<JointCustomerEntityGridRowAssignedPoolName> & 
 Partial<JointCustomerEntityGridRowAssignedUser> & 
 Partial<JointCustomerEntityGridRowComplianceDataComplianceStage> & 
 Partial<JointCustomerEntityGridRowComplianceDataCustomerQuestionnaireScore> & 
 Partial<JointCustomerEntityGridRowCreationTime> & 
 JointCustomerEntityGridRowId & 
 Partial<JointCustomerEntityGridRowJointAccountReason> & 
 Partial<JointCustomerEntityGridRowJointPrimaryOwner> & 
 Partial<JointCustomerEntityGridRowObjective> & 
 Partial<JointCustomerEntityGridRowPersonCountry> & 
 Partial<JointCustomerEntityGridRowPersonFirstName> & 
 Partial<JointCustomerEntityGridRowPersonLastName> & 
 Partial<JointCustomerEntityGridRowPersonNameEnglish> & 
 Partial<JointCustomerEntityGridRowRegistrationTrafficSourceAffiliateId> & 
 Partial<JointCustomerEntityGridRowRegistrationStatus> & 
 Partial<JointCustomerEntityGridRowTotalDeposits>

export enum MultiCompanyCustomerEntityGridRowProp {
 AssignedPoolName = 'assignedPool.name',
 AssignedUser = 'assignedUser',
 ComplianceDataComplianceStage = 'complianceData.complianceStage',
 ComplianceDataCustomerQuestionnaireScore = 'complianceData.customerQuestionnaire.score',
 CreationTime = 'creationTime',
 Id = 'id',
 JointAccountReason = 'jointAccountReason',
 JointPrimaryOwner = 'jointPrimaryOwner',
 Objective = 'objective',
 PersonCountry = 'person.country',
 PersonFirstName = 'person.firstName',
 PersonLastName = 'person.lastName',
 PersonNameEnglish = 'person.nameEnglish',
 RegistrationTrafficSourceAffiliateId = 'registration.trafficSource.affiliateId',
 RegistrationStatus = 'registrationStatus',
 TotalDeposits = 'totalDeposits'
}
export type MultiCompanyCustomerEntityGridRowAssignedPoolName = {
 [MultiCompanyCustomerEntityGridRowProp.AssignedPoolName] : string | null
}
export type MultiCompanyCustomerEntityGridRowAssignedUser = {
 [MultiCompanyCustomerEntityGridRowProp.AssignedUser] : any /* Entity */
}
export type MultiCompanyCustomerEntityGridRowComplianceDataComplianceStage = {
 [MultiCompanyCustomerEntityGridRowProp.ComplianceDataComplianceStage] : 'NON_COMPLIANT' | 'COMPLIANT' | 'PENDING_COMPLIANCE' | 'LIMITED_COMPLIED' | 'COMPLIANCE_REVOKED' | 'COMPLIANCE_SUSPENDED' | null
}
export type MultiCompanyCustomerEntityGridRowComplianceDataCustomerQuestionnaireScore = {
 [MultiCompanyCustomerEntityGridRowProp.ComplianceDataCustomerQuestionnaireScore] : number | null
}
export type MultiCompanyCustomerEntityGridRowCreationTime = {
 [MultiCompanyCustomerEntityGridRowProp.CreationTime] : number | null
}
export type MultiCompanyCustomerEntityGridRowId = {
 [MultiCompanyCustomerEntityGridRowProp.Id] : number
}
export type MultiCompanyCustomerEntityGridRowJointAccountReason = {
 [MultiCompanyCustomerEntityGridRowProp.JointAccountReason] : string | null
}
export type MultiCompanyCustomerEntityGridRowJointPrimaryOwner = {
 [MultiCompanyCustomerEntityGridRowProp.JointPrimaryOwner] : boolean | null
}
export type MultiCompanyCustomerEntityGridRowObjective = {
 [MultiCompanyCustomerEntityGridRowProp.Objective] : 'SALE_INTRODUCTION_CALL' | 'DEPOSIT' | 'COMPLETE_COMPLIANCE' | 'RETENTION' | null
}
export type MultiCompanyCustomerEntityGridRowPersonCountry = {
 [MultiCompanyCustomerEntityGridRowProp.PersonCountry] : 'NA' | 'AFGHANISTAN' | 'ÅLAND_ISLANDS' | 'ALBANIA' | 'ALGERIA' | 'AMERICAN_SAMOA' | 'ANDORRA' | 'ANGOLA' | 'ANGUILLA' | 'ANTARCTICA' | 'ANTIGUA_AND_BARBUDA' | 'ARGENTINA' | 'ARMENIA' | 'ARUBA' | 'AUSTRALIA' | 'AUSTRIA' | 'AZERBAIJAN' | 'BAHAMAS' | 'BAHRAIN' | 'BANGLADESH' | 'BARBADOS' | 'BELARUS' | 'BELGIUM' | 'BELIZE' | 'BENIN' | 'BERMUDA' | 'BHUTAN' | 'BOLIVIA' | 'BONAIRE_SINT_EUSTATIUS_AND_SABA' | 'BOSNIA_AND_HERZEGOVINA' | 'BOTSWANA' | 'BOUVET_ISLAND' | 'BRAZIL' | 'BRITISH_INDIAN_OCEAN_TERRITORY' | 'BRUNEI_DARUSSALAM' | 'BULGARIA' | 'BURKINA_FASO' | 'BURUNDI' | 'CAMBODIA' | 'CAMEROON' | 'CANADA' | 'CAPE_VERDE' | 'CAYMAN_ISLANDS' | 'CENTRAL_AFRICAN_REPUBLIC' | 'CHAD' | 'CHILE' | 'CHINA' | 'CHRISTMAS_ISLAND' | 'COCOS_ISLANDS' | 'COLOMBIA' | 'COMOROS' | 'CONGO' | 'CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE' | 'COOK_ISLANDS' | 'COSTA_RICA' | 'CROATIA' | 'CUBA' | 'CURAÇAO' | 'CYPRUS' | 'CZECH_REPUBLIC' | 'CÔTE_DIVOIRE' | 'DENMARK' | 'DJIBOUTI' | 'DOMINICA' | 'DOMINICAN_REPUBLIC' | 'EAST_TIMOR' | 'ECUADOR' | 'EGYPT' | 'EL_SALVADOR' | 'EQUATORIAL_GUINEA' | 'ERITREA' | 'ESTONIA' | 'ETHIOPIA' | 'FALKLAND_ISLANDS' | 'FAROE_ISLANDS' | 'FIJI' | 'FINLAND' | 'FRANCE' | 'FRENCH_GUIANA' | 'FRENCH_POLYNESIA' | 'FRENCH_SOUTHERN_TERRITORIES' | 'GABON' | 'GAMBIA' | 'Georgia' | 'GERMANY' | 'GHANA' | 'GIBRALTAR' | 'GREECE' | 'GREENLAND' | 'GRENADA' | 'GUADELOUPE' | 'GUAM' | 'GUATEMALA' | 'GUERNSEY' | 'GUINEA' | 'GUINEA_BISSAU' | 'GUYANA' | 'HAITI' | 'HEARD_ISLAND_AND_MCDONALD_ISLANDS' | 'HONDURAS' | 'HONG_KONG' | 'Hungary' | 'ICELAND' | 'INDIA' | 'INDONESIA' | 'IRAN' | 'IRAQ' | 'IRELAND' | 'ISLE_OF_MAN' | 'ISRAEL' | 'ITALY' | 'JAMAICA' | 'JAPAN' | 'JERSEY' | 'JORDAN' | 'KAZAKHSTAN' | 'KENYA' | 'KIRIBATI' | 'KOSOVO' | 'KOREA_DEMOCRATIC_PEOPLE_REPUBLIC_OF' | 'KOREA_REPUBLIC_OF' | 'KUWAIT' | 'KYRGYZSTAN' | 'LAO_PEOPLE_DEMOCRATIC_REPUBLIC' | 'LATVIA' | 'LEBANON' | 'LESOTHO' | 'LIBERIA' | 'LIBYAN' | 'LIECHTENSTEIN' | 'LITHUANIA' | 'LUXEMBOURG' | 'MACAO' | 'MADAGASCAR' | 'MALAWI' | 'MALAYSIA' | 'MALDIVES' | 'MALI' | 'MALTA' | 'MARSHALL_ISLANDS' | 'MARTINIQUE' | 'MAURITANIA' | 'MAURITIUS' | 'MAYOTTE' | 'MEXICO' | 'MICRONESIA' | 'MOLDOVA_REPUBLIC_OF' | 'MONACO' | 'MONGOLIA' | 'MONTENEGRO' | 'MONTSERRAT' | 'MOROCCO' | 'MOZAMBIQUE' | 'MYANMAR' | 'NAMIBIA' | 'NAURU' | 'NEPAL' | 'NETHERLANDS' | 'NETHERLANDS_ANTILLES' | 'NEW_CALEDONIA' | 'NEW_ZEALAND' | 'NICARAGUA' | 'NIGER' | 'NIGERIA' | 'NIUE' | 'NORFOLK_ISLAND' | 'NORTHERN_MARIANA_ISLANDS' | 'NORWAY' | 'OMAN' | 'PAKISTAN' | 'PALAU' | 'PALESTINIAN_TERRITORY_OCCUPIED' | 'PANAMA' | 'PAPUA_NEW_GUINEA' | 'PARAGUAY' | 'PERU' | 'PHILIPPINES' | 'PITCAIRN' | 'POLAND' | 'PORTUGAL' | 'PUERTO_RICO' | 'QATAR' | 'ROMANIA' | 'RUSSIAN_FEDERATION' | 'RWANDA' | 'RÉUNION' | 'SAINT_BARTHÉLEMY_BL' | 'SAINT_HELENA' | 'SAINT_KITTS_AND_NEVIS' | 'SAINT_LUCIA' | 'SAINT_MARTIN_FRENCH_PART' | 'SAINT_PIERRE_AND_MIQUELON' | 'SAINT_VINCENT_AND_THE_GRENADINES' | 'SAMOA' | 'SAN_MARINO' | 'SAO_TOME_AND_PRINCIPE' | 'SAUDI_ARABIA' | 'SENEGAL' | 'SERBIA' | 'SEYCHELLES' | 'SIERRA_LEONE' | 'SINGAPORE' | 'SINT_MAARTEN_DUTCH_PART' | 'SLOVAKIA' | 'SLOVENIA' | 'SOLOMON_ISLANDS' | 'SOMALIA' | 'SOUTH_AFRICA' | 'SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS' | 'SOUTH_SUDAN' | 'SPAIN' | 'SRI_LANKA' | 'SUDAN' | 'SURINAME' | 'SVALBARD_AND_JAN_MAYEN' | 'SWAZILAND' | 'SWEDEN' | 'SWITZERLAND' | 'SYRIAN_ARAB_REPUBLIC' | 'TAIWAN' | 'TAJIKISTAN' | 'THAILAND' | 'THE_FORMER_YUGOSLAV_REPUBLIC_OF_MACEDONIA' | 'TOGO' | 'TOKELAU' | 'TONGA' | 'TRINIDAD_AND_TOBAGO' | 'TUNISIA' | 'TURKEY' | 'TURKMENISTAN' | 'TURKS_AND_CAICOS_ISLANDS' | 'TUVALU' | 'UGANDA' | 'UKRAINE' | 'UNITED_ARAB_EMIRATES' | 'UNITED_KINGDOM' | 'UNITED_REPUBLIC_OF_TANZANIA' | 'UNITED_STATES_MINOR_OUTLYING_ISLANDS' | 'URUGUAY' | 'USA' | 'UZBEKISTAN' | 'VANUATU' | 'VATICAN_CITY_STATE' | 'VENEZUELA' | 'VIET_NAM' | 'VIRGIN_ISLANDS_GB' | 'VIRGIN_ISLANDS_USA' | 'WALLIS_AND_FUTUNA' | 'WESTERN_SAHARA' | 'YEMEN' | 'ZAMBIA' | 'ZIMBABWE' | null
}
export type MultiCompanyCustomerEntityGridRowPersonFirstName = {
 [MultiCompanyCustomerEntityGridRowProp.PersonFirstName] : string | null
}
export type MultiCompanyCustomerEntityGridRowPersonLastName = {
 [MultiCompanyCustomerEntityGridRowProp.PersonLastName] : string | null
}
export type MultiCompanyCustomerEntityGridRowPersonNameEnglish = {
 [MultiCompanyCustomerEntityGridRowProp.PersonNameEnglish] : string | null
}
export type MultiCompanyCustomerEntityGridRowRegistrationTrafficSourceAffiliateId = {
 [MultiCompanyCustomerEntityGridRowProp.RegistrationTrafficSourceAffiliateId] : string | null
}
export type MultiCompanyCustomerEntityGridRowRegistrationStatus = {
 [MultiCompanyCustomerEntityGridRowProp.RegistrationStatus] : 'LEAD' | 'DEMO' | 'REAL' | 'REAL_FUNDED' | null
}
export type MultiCompanyCustomerEntityGridRowTotalDeposits = {
 [MultiCompanyCustomerEntityGridRowProp.TotalDeposits] : number | null
}
export type MultiCompanyCustomerEntityGridRow = 
 Partial<MultiCompanyCustomerEntityGridRowAssignedPoolName> & 
 Partial<MultiCompanyCustomerEntityGridRowAssignedUser> & 
 Partial<MultiCompanyCustomerEntityGridRowComplianceDataComplianceStage> & 
 Partial<MultiCompanyCustomerEntityGridRowComplianceDataCustomerQuestionnaireScore> & 
 Partial<MultiCompanyCustomerEntityGridRowCreationTime> & 
 MultiCompanyCustomerEntityGridRowId & 
 Partial<MultiCompanyCustomerEntityGridRowJointAccountReason> & 
 Partial<MultiCompanyCustomerEntityGridRowJointPrimaryOwner> & 
 Partial<MultiCompanyCustomerEntityGridRowObjective> & 
 Partial<MultiCompanyCustomerEntityGridRowPersonCountry> & 
 Partial<MultiCompanyCustomerEntityGridRowPersonFirstName> & 
 Partial<MultiCompanyCustomerEntityGridRowPersonLastName> & 
 Partial<MultiCompanyCustomerEntityGridRowPersonNameEnglish> & 
 Partial<MultiCompanyCustomerEntityGridRowRegistrationTrafficSourceAffiliateId> & 
 Partial<MultiCompanyCustomerEntityGridRowRegistrationStatus> & 
 Partial<MultiCompanyCustomerEntityGridRowTotalDeposits>

export enum NoteEntityGridRowProp {
 CreatedBy = 'createdBy',
 CreationTime = 'creationTime',
 Description = 'description',
 EntityId = 'entityId',
 EntityType = 'entityType',
 Favorite = 'favorite',
 Id = 'id',
 SectionName = 'sectionName'
}
export type NoteEntityGridRowCreatedBy = {
 [NoteEntityGridRowProp.CreatedBy] : string | null
}
export type NoteEntityGridRowCreationTime = {
 [NoteEntityGridRowProp.CreationTime] : number | null
}
export type NoteEntityGridRowDescription = {
 [NoteEntityGridRowProp.Description] : string | null
}
export type NoteEntityGridRowEntityId = {
 [NoteEntityGridRowProp.EntityId] : number | null
}
export type NoteEntityGridRowEntityType = {
 [NoteEntityGridRowProp.EntityType] : string | null
}
export type NoteEntityGridRowFavorite = {
 [NoteEntityGridRowProp.Favorite] : boolean | null
}
export type NoteEntityGridRowId = {
 [NoteEntityGridRowProp.Id] : number
}
export type NoteEntityGridRowSectionName = {
 [NoteEntityGridRowProp.SectionName] : string | null
}
export type NoteEntityGridRow = 
 Partial<NoteEntityGridRowCreatedBy> & 
 Partial<NoteEntityGridRowCreationTime> & 
 Partial<NoteEntityGridRowDescription> & 
 Partial<NoteEntityGridRowEntityId> & 
 Partial<NoteEntityGridRowEntityType> & 
 Partial<NoteEntityGridRowFavorite> & 
 NoteEntityGridRowId & 
 Partial<NoteEntityGridRowSectionName>

export enum PayPalAccountDepositEntityGridRowProp {
 Auth3D = 'auth3D',
 BaseCurrencyAmount = 'baseCurrencyAmount',
 BaseCurrencyConvRate = 'baseCurrencyConvRate',
 BonusDataAdjustedAmount = 'bonusData.adjustedAmount',
 BonusExpirationDate = 'bonusExpirationDate',
 CcExpDate = 'ccExpDate',
 CcNumber = 'ccNumber',
 CreationTime = 'creationTime',
 Ecdd = 'ecdd',
 ExternalId = 'externalId',
 Id = 'id',
 ModificationTime = 'modificationTime',
 ModifiedBy = 'modifiedBy',
 ReasonInternalReason = 'reason.internalReason',
 SourceAmount = 'source.amount',
 SourceCurrency = 'source.currency',
 Status = 'status',
 TargetAmount = 'target.amount',
 TargetCurrency = 'target.currency',
 TargetCurrencyConvRate = 'targetCurrencyConvRate',
 TransactionType = 'transactionType',
 TxSubType = 'txSubType'
}
export type PayPalAccountDepositEntityGridRowAuth3D = {
 [PayPalAccountDepositEntityGridRowProp.Auth3D] : boolean | null
}
export type PayPalAccountDepositEntityGridRowBaseCurrencyAmount = {
 [PayPalAccountDepositEntityGridRowProp.BaseCurrencyAmount] : number | null
}
export type PayPalAccountDepositEntityGridRowBaseCurrencyConvRate = {
 [PayPalAccountDepositEntityGridRowProp.BaseCurrencyConvRate] : number | null
}
export type PayPalAccountDepositEntityGridRowBonusDataAdjustedAmount = {
 [PayPalAccountDepositEntityGridRowProp.BonusDataAdjustedAmount] : number | null
}
export type PayPalAccountDepositEntityGridRowBonusExpirationDate = {
 [PayPalAccountDepositEntityGridRowProp.BonusExpirationDate] : number | null
}
export type PayPalAccountDepositEntityGridRowCcExpDate = {
 [PayPalAccountDepositEntityGridRowProp.CcExpDate] : string | null
}
export type PayPalAccountDepositEntityGridRowCcNumber = {
 [PayPalAccountDepositEntityGridRowProp.CcNumber] : string | null
}
export type PayPalAccountDepositEntityGridRowCreationTime = {
 [PayPalAccountDepositEntityGridRowProp.CreationTime] : number | null
}
export type PayPalAccountDepositEntityGridRowEcdd = {
 [PayPalAccountDepositEntityGridRowProp.Ecdd] : boolean | null
}
export type PayPalAccountDepositEntityGridRowExternalId = {
 [PayPalAccountDepositEntityGridRowProp.ExternalId] : string | null
}
export type PayPalAccountDepositEntityGridRowId = {
 [PayPalAccountDepositEntityGridRowProp.Id] : number
}
export type PayPalAccountDepositEntityGridRowModificationTime = {
 [PayPalAccountDepositEntityGridRowProp.ModificationTime] : number | null
}
export type PayPalAccountDepositEntityGridRowModifiedBy = {
 [PayPalAccountDepositEntityGridRowProp.ModifiedBy] : string | null
}
export type PayPalAccountDepositEntityGridRowReasonInternalReason = {
 [PayPalAccountDepositEntityGridRowProp.ReasonInternalReason] : string | null
}
export type PayPalAccountDepositEntityGridRowSourceAmount = {
 [PayPalAccountDepositEntityGridRowProp.SourceAmount] : number | null
}
export type PayPalAccountDepositEntityGridRowSourceCurrency = {
 [PayPalAccountDepositEntityGridRowProp.SourceCurrency] : 'USD' | 'EUR' | 'GBP' | 'CAD' | 'JPY' | 'AED' | 'PLN' | 'AZN' | 'INR' | 'NZD' | 'CUP' | 'EGP' | 'LBP' | 'RMB' | 'AUD' | 'ILS' | 'RON' | 'CHF' | 'CZK' | 'DKK' | 'RUB' | 'BGN' | 'HRK' | 'CNY' | 'MXN' | 'CLP' | 'ALL' | 'NOK' | 'SEK' | 'HUF' | 'BRL' | 'ZAR' | 'HKD' | 'SGD' | 'THB' | 'TRY' | 'KRW' | 'SKK' | 'LKR' | 'COP' | 'VND' | 'CNH' | 'SAR' | 'MYR' | 'USDT' | 'LOCAL_CURRENCY' | null
}
export type PayPalAccountDepositEntityGridRowStatus = {
 [PayPalAccountDepositEntityGridRowProp.Status] : 'PENDING' | 'PENDING_COMPLIANCE' | 'DONE' | 'FAILED' | 'REJECTED' | 'PENDING_PM_APPROVAL' | 'CANCELLED_PENDING_PM_APPROVAL' | 'CANCELLED_PENDING_COMPLIANCE' | null
}
export type PayPalAccountDepositEntityGridRowTargetAmount = {
 [PayPalAccountDepositEntityGridRowProp.TargetAmount] : number | null
}
export type PayPalAccountDepositEntityGridRowTargetCurrency = {
 [PayPalAccountDepositEntityGridRowProp.TargetCurrency] : 'USD' | 'EUR' | 'GBP' | 'CAD' | 'JPY' | 'AED' | 'PLN' | 'AZN' | 'INR' | 'NZD' | 'CUP' | 'EGP' | 'LBP' | 'RMB' | 'AUD' | 'ILS' | 'RON' | 'CHF' | 'CZK' | 'DKK' | 'RUB' | 'BGN' | 'HRK' | 'CNY' | 'MXN' | 'CLP' | 'ALL' | 'NOK' | 'SEK' | 'HUF' | 'BRL' | 'ZAR' | 'HKD' | 'SGD' | 'THB' | 'TRY' | 'KRW' | 'SKK' | 'LKR' | 'COP' | 'VND' | 'CNH' | 'SAR' | 'MYR' | 'USDT' | 'LOCAL_CURRENCY' | null
}
export type PayPalAccountDepositEntityGridRowTargetCurrencyConvRate = {
 [PayPalAccountDepositEntityGridRowProp.TargetCurrencyConvRate] : number | null
}
export type PayPalAccountDepositEntityGridRowTransactionType = {
 [PayPalAccountDepositEntityGridRowProp.TransactionType] : 'DEPOSIT' | 'WITHDRAWAL' | 'CORRECTION' | null
}
export type PayPalAccountDepositEntityGridRowTxSubType = {
 [PayPalAccountDepositEntityGridRowProp.TxSubType] : 'NEGATIVE_ADJUSTMENT' | 'NEGATIVE_DEALING_CORRECTION' | 'NEGATIVE_FRAUD_ADJUSTMENT' | 'NEGATIVE_BONUS_ADJUSTMENT' | 'CLOSING_ACCOUNT_BOOK_NEGATIVE' | 'PARTNER_NEGATIVE_ADJUSTMENT' | 'POSITIVE_ADJUSTMENT' | 'POSITIVE_DEALING_CORRECTION' | 'POSITIVE_FRAUD_ADJUSTMENT' | 'POSITIVE_BONUS_ADJUSTMENT' | 'CLOSING_ACCOUNT_BOOK_POSITIVE' | 'PARTNER_PAYMENT' | 'PARTNER_BONUS' | 'BONUS' | 'CREDIT_CARD_DEPOSIT' | 'WIRE_TRANSFER_DEPOSIT' | 'CREDIT_CREDIT_CARD_WITHDRAWAL' | 'VOID_CREDIT_CARD_WITHDRAWAL' | 'REFUND_CREDIT_CARD_WITHDRAWAL' | 'WIRE_TRANSFER_WITHDRAWAL' | 'MANUAL_DEPOSIT' | 'INTERNAL_DEPOSIT' | 'MANUAL_WITHDRAWAL' | 'INTERNAL_WITHDRAWAL' | 'LIBERTY_RESERVE_DEPOSIT' | 'LIBERTY_RESERVE_WITHDRAWAL' | 'ENVOY_DEPOSIT' | 'ENVOY_WITHDRAWAL' | 'WM_WITHDRAWAL' | 'NETELLER_DEPOSIT' | 'MONEYBOOKERS_DEPOSIT' | 'QIWI_DEPOSIT' | 'WEBMONEY_DEPOSIT' | 'CHINAUNION_DEPOSIT' | 'CUP_DEPOSIT' | 'CHINAUNION_WITHDRAWAL' | 'LOBANET_DEPOSIT' | 'QIWI_WITHDRAWAL' | 'PSP_DEPOSIT' | 'BAOFOO_DEPOSIT' | 'SOLIDPAY_DEPOSIT' | 'FOCAL_DEPOSIT' | 'PAYGATE_DEPOSIT' | 'PAYMENT_ASIA_DEPOSIT' | 'CRYPTO_WITHDRAWAL' | 'MD_APM_WITHDRAWAL' | null
}
export type PayPalAccountDepositEntityGridRow = 
 Partial<PayPalAccountDepositEntityGridRowAuth3D> & 
 Partial<PayPalAccountDepositEntityGridRowBaseCurrencyAmount> & 
 Partial<PayPalAccountDepositEntityGridRowBaseCurrencyConvRate> & 
 Partial<PayPalAccountDepositEntityGridRowBonusDataAdjustedAmount> & 
 Partial<PayPalAccountDepositEntityGridRowBonusExpirationDate> & 
 Partial<PayPalAccountDepositEntityGridRowCcExpDate> & 
 Partial<PayPalAccountDepositEntityGridRowCcNumber> & 
 Partial<PayPalAccountDepositEntityGridRowCreationTime> & 
 Partial<PayPalAccountDepositEntityGridRowEcdd> & 
 Partial<PayPalAccountDepositEntityGridRowExternalId> & 
 PayPalAccountDepositEntityGridRowId & 
 Partial<PayPalAccountDepositEntityGridRowModificationTime> & 
 Partial<PayPalAccountDepositEntityGridRowModifiedBy> & 
 Partial<PayPalAccountDepositEntityGridRowReasonInternalReason> & 
 Partial<PayPalAccountDepositEntityGridRowSourceAmount> & 
 PayPalAccountDepositEntityGridRowSourceCurrency & 
 Partial<PayPalAccountDepositEntityGridRowStatus> & 
 Partial<PayPalAccountDepositEntityGridRowTargetAmount> & 
 PayPalAccountDepositEntityGridRowTargetCurrency & 
 Partial<PayPalAccountDepositEntityGridRowTargetCurrencyConvRate> & 
 Partial<PayPalAccountDepositEntityGridRowTransactionType> & 
 Partial<PayPalAccountDepositEntityGridRowTxSubType>

export enum PhoneSmsVerificationInfoEntityGridRowProp {
 Code = 'code',
 CreationTime = 'creationTime',
 Id = 'id',
 Phone = 'phone',
 Source = 'source',
 VerificationCount = 'verificationCount',
 VerificationTime = 'verificationTime'
}
export type PhoneSmsVerificationInfoEntityGridRowCode = {
 [PhoneSmsVerificationInfoEntityGridRowProp.Code] : string | null
}
export type PhoneSmsVerificationInfoEntityGridRowCreationTime = {
 [PhoneSmsVerificationInfoEntityGridRowProp.CreationTime] : number | null
}
export type PhoneSmsVerificationInfoEntityGridRowId = {
 [PhoneSmsVerificationInfoEntityGridRowProp.Id] : number
}
export type PhoneSmsVerificationInfoEntityGridRowPhone = {
 [PhoneSmsVerificationInfoEntityGridRowProp.Phone] : string | null
}
export type PhoneSmsVerificationInfoEntityGridRowSource = {
 [PhoneSmsVerificationInfoEntityGridRowProp.Source] : 'REGISTRATION' | 'LOGIN' | 'UPDATE_PASSWORD' | null
}
export type PhoneSmsVerificationInfoEntityGridRowVerificationCount = {
 [PhoneSmsVerificationInfoEntityGridRowProp.VerificationCount] : number | null
}
export type PhoneSmsVerificationInfoEntityGridRowVerificationTime = {
 [PhoneSmsVerificationInfoEntityGridRowProp.VerificationTime] : number | null
}
export type PhoneSmsVerificationInfoEntityGridRow = 
 Partial<PhoneSmsVerificationInfoEntityGridRowCode> & 
 Partial<PhoneSmsVerificationInfoEntityGridRowCreationTime> & 
 PhoneSmsVerificationInfoEntityGridRowId & 
 Partial<PhoneSmsVerificationInfoEntityGridRowPhone> & 
 Partial<PhoneSmsVerificationInfoEntityGridRowSource> & 
 Partial<PhoneSmsVerificationInfoEntityGridRowVerificationCount> & 
 Partial<PhoneSmsVerificationInfoEntityGridRowVerificationTime>

export enum PspAccountCustomerEntityGridRowProp {
 CreatedBy = 'createdBy',
 CreationTime = 'creationTime',
 Id = 'id',
 ModificationTime = 'modificationTime',
 ModifiedBy = 'modifiedBy',
 PaymentAccountStatus = 'paymentAccountStatus',
 PspAccountExternalAccountId = 'pspAccount.externalAccountId',
 PspAccountPayPalAccountEmail = 'pspAccount.payPalAccount.email',
 PspAccountPayPalAccountName = 'pspAccount.payPalAccount.name',
 PspAccountPaymentServiceProviderName = 'pspAccount.paymentServiceProvider.name'
}
export type PspAccountCustomerEntityGridRowCreatedBy = {
 [PspAccountCustomerEntityGridRowProp.CreatedBy] : string | null
}
export type PspAccountCustomerEntityGridRowCreationTime = {
 [PspAccountCustomerEntityGridRowProp.CreationTime] : number | null
}
export type PspAccountCustomerEntityGridRowId = {
 [PspAccountCustomerEntityGridRowProp.Id] : number
}
export type PspAccountCustomerEntityGridRowModificationTime = {
 [PspAccountCustomerEntityGridRowProp.ModificationTime] : number | null
}
export type PspAccountCustomerEntityGridRowModifiedBy = {
 [PspAccountCustomerEntityGridRowProp.ModifiedBy] : string | null
}
export type PspAccountCustomerEntityGridRowPaymentAccountStatus = {
 [PspAccountCustomerEntityGridRowProp.PaymentAccountStatus] : 'PENDING' | 'APPROVED' | 'REJECTED' | 'BLACK_LISTED' | 'REVOKE_PENDING' | null
}
export type PspAccountCustomerEntityGridRowPspAccountExternalAccountId = {
 [PspAccountCustomerEntityGridRowProp.PspAccountExternalAccountId] : string | null
}
export type PspAccountCustomerEntityGridRowPspAccountPayPalAccountEmail = {
 [PspAccountCustomerEntityGridRowProp.PspAccountPayPalAccountEmail] : string | null
}
export type PspAccountCustomerEntityGridRowPspAccountPayPalAccountName = {
 [PspAccountCustomerEntityGridRowProp.PspAccountPayPalAccountName] : string | null
}
export type PspAccountCustomerEntityGridRowPspAccountPaymentServiceProviderName = {
 [PspAccountCustomerEntityGridRowProp.PspAccountPaymentServiceProviderName] : string | null
}
export type PspAccountCustomerEntityGridRow = 
 Partial<PspAccountCustomerEntityGridRowCreatedBy> & 
 Partial<PspAccountCustomerEntityGridRowCreationTime> & 
 PspAccountCustomerEntityGridRowId & 
 Partial<PspAccountCustomerEntityGridRowModificationTime> & 
 Partial<PspAccountCustomerEntityGridRowModifiedBy> & 
 Partial<PspAccountCustomerEntityGridRowPaymentAccountStatus> & 
 Partial<PspAccountCustomerEntityGridRowPspAccountExternalAccountId> & 
 Partial<PspAccountCustomerEntityGridRowPspAccountPayPalAccountEmail> & 
 Partial<PspAccountCustomerEntityGridRowPspAccountPayPalAccountName> & 
 Partial<PspAccountCustomerEntityGridRowPspAccountPaymentServiceProviderName>

export enum QuestionnaireGroupEntityGridRowProp {
 CreatedBy = 'createdBy',
 CreationTime = 'creationTime',
 Id = 'id',
 ModificationTime = 'modificationTime',
 ModifiedBy = 'modifiedBy',
 Name = 'name',
 NumberOfColumns = 'numberOfColumns',
 Position = 'position',
 Title = 'title'
}
export type QuestionnaireGroupEntityGridRowCreatedBy = {
 [QuestionnaireGroupEntityGridRowProp.CreatedBy] : string | null
}
export type QuestionnaireGroupEntityGridRowCreationTime = {
 [QuestionnaireGroupEntityGridRowProp.CreationTime] : number | null
}
export type QuestionnaireGroupEntityGridRowId = {
 [QuestionnaireGroupEntityGridRowProp.Id] : number
}
export type QuestionnaireGroupEntityGridRowModificationTime = {
 [QuestionnaireGroupEntityGridRowProp.ModificationTime] : number | null
}
export type QuestionnaireGroupEntityGridRowModifiedBy = {
 [QuestionnaireGroupEntityGridRowProp.ModifiedBy] : string | null
}
export type QuestionnaireGroupEntityGridRowName = {
 [QuestionnaireGroupEntityGridRowProp.Name] : string | null
}
export type QuestionnaireGroupEntityGridRowNumberOfColumns = {
 [QuestionnaireGroupEntityGridRowProp.NumberOfColumns] : number | null
}
export type QuestionnaireGroupEntityGridRowPosition = {
 [QuestionnaireGroupEntityGridRowProp.Position] : number | null
}
export type QuestionnaireGroupEntityGridRowTitle = {
 [QuestionnaireGroupEntityGridRowProp.Title] : string | null
}
export type QuestionnaireGroupEntityGridRow = 
 Partial<QuestionnaireGroupEntityGridRowCreatedBy> & 
 Partial<QuestionnaireGroupEntityGridRowCreationTime> & 
 QuestionnaireGroupEntityGridRowId & 
 Partial<QuestionnaireGroupEntityGridRowModificationTime> & 
 Partial<QuestionnaireGroupEntityGridRowModifiedBy> & 
 Partial<QuestionnaireGroupEntityGridRowName> & 
 Partial<QuestionnaireGroupEntityGridRowNumberOfColumns> & 
 Partial<QuestionnaireGroupEntityGridRowPosition> & 
 Partial<QuestionnaireGroupEntityGridRowTitle>

export enum RegistrationEntityGridRowProp {
 CreationTime = 'creationTime',
 Id = 'id',
 MarketingParamsCampaign = 'marketingParams.campaign',
 MarketingParamsCount = 'marketingParams.count',
 MarketingParamsRegistrationServiceType = 'marketingParams.registrationServiceType',
 MarketingParamsTerm = 'marketingParams.term',
 TrafficSourceAffiliateId = 'trafficSource.affiliateId',
 TrafficSourcePromotionName = 'trafficSource.promotionName'
}
export type RegistrationEntityGridRowCreationTime = {
 [RegistrationEntityGridRowProp.CreationTime] : number | null
}
export type RegistrationEntityGridRowId = {
 [RegistrationEntityGridRowProp.Id] : number
}
export type RegistrationEntityGridRowMarketingParamsCampaign = {
 [RegistrationEntityGridRowProp.MarketingParamsCampaign] : string | null
}
export type RegistrationEntityGridRowMarketingParamsCount = {
 [RegistrationEntityGridRowProp.MarketingParamsCount] : number | null
}
export type RegistrationEntityGridRowMarketingParamsRegistrationServiceType = {
 [RegistrationEntityGridRowProp.MarketingParamsRegistrationServiceType] : string | null
}
export type RegistrationEntityGridRowMarketingParamsTerm = {
 [RegistrationEntityGridRowProp.MarketingParamsTerm] : string | null
}
export type RegistrationEntityGridRowTrafficSourceAffiliateId = {
 [RegistrationEntityGridRowProp.TrafficSourceAffiliateId] : string | null
}
export type RegistrationEntityGridRowTrafficSourcePromotionName = {
 [RegistrationEntityGridRowProp.TrafficSourcePromotionName] : string | null
}
export type RegistrationEntityGridRow = 
 Partial<RegistrationEntityGridRowCreationTime> & 
 RegistrationEntityGridRowId & 
 Partial<RegistrationEntityGridRowMarketingParamsCampaign> & 
 Partial<RegistrationEntityGridRowMarketingParamsCount> & 
 Partial<RegistrationEntityGridRowMarketingParamsRegistrationServiceType> & 
 Partial<RegistrationEntityGridRowMarketingParamsTerm> & 
 Partial<RegistrationEntityGridRowTrafficSourceAffiliateId> & 
 Partial<RegistrationEntityGridRowTrafficSourcePromotionName>

export enum RelatedCustomerEntityGridRowProp {
 ComplianceDataComplianceStage = 'complianceData.complianceStage',
 ComplianceDataCustomerQuestionnaireScore = 'complianceData.customerQuestionnaire.score',
 CreationTime = 'creationTime',
 DuplicationVerified = 'duplicationVerified',
 Id = 'id',
 Objective = 'objective',
 PersonCountry = 'person.country',
 PersonFirstName = 'person.firstName',
 PersonLastName = 'person.lastName',
 PersonNameEnglish = 'person.nameEnglish',
 RegistrationTrafficSourceAffiliateId = 'registration.trafficSource.affiliateId',
 RegistrationStatus = 'registrationStatus',
 Test = 'test',
 TotalDeposits = 'totalDeposits'
}
export type RelatedCustomerEntityGridRowComplianceDataComplianceStage = {
 [RelatedCustomerEntityGridRowProp.ComplianceDataComplianceStage] : 'NON_COMPLIANT' | 'COMPLIANT' | 'PENDING_COMPLIANCE' | 'LIMITED_COMPLIED' | 'COMPLIANCE_REVOKED' | 'COMPLIANCE_SUSPENDED' | null
}
export type RelatedCustomerEntityGridRowComplianceDataCustomerQuestionnaireScore = {
 [RelatedCustomerEntityGridRowProp.ComplianceDataCustomerQuestionnaireScore] : number | null
}
export type RelatedCustomerEntityGridRowCreationTime = {
 [RelatedCustomerEntityGridRowProp.CreationTime] : number | null
}
export type RelatedCustomerEntityGridRowDuplicationVerified = {
 [RelatedCustomerEntityGridRowProp.DuplicationVerified] : boolean | null
}
export type RelatedCustomerEntityGridRowId = {
 [RelatedCustomerEntityGridRowProp.Id] : number
}
export type RelatedCustomerEntityGridRowObjective = {
 [RelatedCustomerEntityGridRowProp.Objective] : 'SALE_INTRODUCTION_CALL' | 'DEPOSIT' | 'COMPLETE_COMPLIANCE' | 'RETENTION' | null
}
export type RelatedCustomerEntityGridRowPersonCountry = {
 [RelatedCustomerEntityGridRowProp.PersonCountry] : 'NA' | 'AFGHANISTAN' | 'ÅLAND_ISLANDS' | 'ALBANIA' | 'ALGERIA' | 'AMERICAN_SAMOA' | 'ANDORRA' | 'ANGOLA' | 'ANGUILLA' | 'ANTARCTICA' | 'ANTIGUA_AND_BARBUDA' | 'ARGENTINA' | 'ARMENIA' | 'ARUBA' | 'AUSTRALIA' | 'AUSTRIA' | 'AZERBAIJAN' | 'BAHAMAS' | 'BAHRAIN' | 'BANGLADESH' | 'BARBADOS' | 'BELARUS' | 'BELGIUM' | 'BELIZE' | 'BENIN' | 'BERMUDA' | 'BHUTAN' | 'BOLIVIA' | 'BONAIRE_SINT_EUSTATIUS_AND_SABA' | 'BOSNIA_AND_HERZEGOVINA' | 'BOTSWANA' | 'BOUVET_ISLAND' | 'BRAZIL' | 'BRITISH_INDIAN_OCEAN_TERRITORY' | 'BRUNEI_DARUSSALAM' | 'BULGARIA' | 'BURKINA_FASO' | 'BURUNDI' | 'CAMBODIA' | 'CAMEROON' | 'CANADA' | 'CAPE_VERDE' | 'CAYMAN_ISLANDS' | 'CENTRAL_AFRICAN_REPUBLIC' | 'CHAD' | 'CHILE' | 'CHINA' | 'CHRISTMAS_ISLAND' | 'COCOS_ISLANDS' | 'COLOMBIA' | 'COMOROS' | 'CONGO' | 'CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE' | 'COOK_ISLANDS' | 'COSTA_RICA' | 'CROATIA' | 'CUBA' | 'CURAÇAO' | 'CYPRUS' | 'CZECH_REPUBLIC' | 'CÔTE_DIVOIRE' | 'DENMARK' | 'DJIBOUTI' | 'DOMINICA' | 'DOMINICAN_REPUBLIC' | 'EAST_TIMOR' | 'ECUADOR' | 'EGYPT' | 'EL_SALVADOR' | 'EQUATORIAL_GUINEA' | 'ERITREA' | 'ESTONIA' | 'ETHIOPIA' | 'FALKLAND_ISLANDS' | 'FAROE_ISLANDS' | 'FIJI' | 'FINLAND' | 'FRANCE' | 'FRENCH_GUIANA' | 'FRENCH_POLYNESIA' | 'FRENCH_SOUTHERN_TERRITORIES' | 'GABON' | 'GAMBIA' | 'Georgia' | 'GERMANY' | 'GHANA' | 'GIBRALTAR' | 'GREECE' | 'GREENLAND' | 'GRENADA' | 'GUADELOUPE' | 'GUAM' | 'GUATEMALA' | 'GUERNSEY' | 'GUINEA' | 'GUINEA_BISSAU' | 'GUYANA' | 'HAITI' | 'HEARD_ISLAND_AND_MCDONALD_ISLANDS' | 'HONDURAS' | 'HONG_KONG' | 'Hungary' | 'ICELAND' | 'INDIA' | 'INDONESIA' | 'IRAN' | 'IRAQ' | 'IRELAND' | 'ISLE_OF_MAN' | 'ISRAEL' | 'ITALY' | 'JAMAICA' | 'JAPAN' | 'JERSEY' | 'JORDAN' | 'KAZAKHSTAN' | 'KENYA' | 'KIRIBATI' | 'KOSOVO' | 'KOREA_DEMOCRATIC_PEOPLE_REPUBLIC_OF' | 'KOREA_REPUBLIC_OF' | 'KUWAIT' | 'KYRGYZSTAN' | 'LAO_PEOPLE_DEMOCRATIC_REPUBLIC' | 'LATVIA' | 'LEBANON' | 'LESOTHO' | 'LIBERIA' | 'LIBYAN' | 'LIECHTENSTEIN' | 'LITHUANIA' | 'LUXEMBOURG' | 'MACAO' | 'MADAGASCAR' | 'MALAWI' | 'MALAYSIA' | 'MALDIVES' | 'MALI' | 'MALTA' | 'MARSHALL_ISLANDS' | 'MARTINIQUE' | 'MAURITANIA' | 'MAURITIUS' | 'MAYOTTE' | 'MEXICO' | 'MICRONESIA' | 'MOLDOVA_REPUBLIC_OF' | 'MONACO' | 'MONGOLIA' | 'MONTENEGRO' | 'MONTSERRAT' | 'MOROCCO' | 'MOZAMBIQUE' | 'MYANMAR' | 'NAMIBIA' | 'NAURU' | 'NEPAL' | 'NETHERLANDS' | 'NETHERLANDS_ANTILLES' | 'NEW_CALEDONIA' | 'NEW_ZEALAND' | 'NICARAGUA' | 'NIGER' | 'NIGERIA' | 'NIUE' | 'NORFOLK_ISLAND' | 'NORTHERN_MARIANA_ISLANDS' | 'NORWAY' | 'OMAN' | 'PAKISTAN' | 'PALAU' | 'PALESTINIAN_TERRITORY_OCCUPIED' | 'PANAMA' | 'PAPUA_NEW_GUINEA' | 'PARAGUAY' | 'PERU' | 'PHILIPPINES' | 'PITCAIRN' | 'POLAND' | 'PORTUGAL' | 'PUERTO_RICO' | 'QATAR' | 'ROMANIA' | 'RUSSIAN_FEDERATION' | 'RWANDA' | 'RÉUNION' | 'SAINT_BARTHÉLEMY_BL' | 'SAINT_HELENA' | 'SAINT_KITTS_AND_NEVIS' | 'SAINT_LUCIA' | 'SAINT_MARTIN_FRENCH_PART' | 'SAINT_PIERRE_AND_MIQUELON' | 'SAINT_VINCENT_AND_THE_GRENADINES' | 'SAMOA' | 'SAN_MARINO' | 'SAO_TOME_AND_PRINCIPE' | 'SAUDI_ARABIA' | 'SENEGAL' | 'SERBIA' | 'SEYCHELLES' | 'SIERRA_LEONE' | 'SINGAPORE' | 'SINT_MAARTEN_DUTCH_PART' | 'SLOVAKIA' | 'SLOVENIA' | 'SOLOMON_ISLANDS' | 'SOMALIA' | 'SOUTH_AFRICA' | 'SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS' | 'SOUTH_SUDAN' | 'SPAIN' | 'SRI_LANKA' | 'SUDAN' | 'SURINAME' | 'SVALBARD_AND_JAN_MAYEN' | 'SWAZILAND' | 'SWEDEN' | 'SWITZERLAND' | 'SYRIAN_ARAB_REPUBLIC' | 'TAIWAN' | 'TAJIKISTAN' | 'THAILAND' | 'THE_FORMER_YUGOSLAV_REPUBLIC_OF_MACEDONIA' | 'TOGO' | 'TOKELAU' | 'TONGA' | 'TRINIDAD_AND_TOBAGO' | 'TUNISIA' | 'TURKEY' | 'TURKMENISTAN' | 'TURKS_AND_CAICOS_ISLANDS' | 'TUVALU' | 'UGANDA' | 'UKRAINE' | 'UNITED_ARAB_EMIRATES' | 'UNITED_KINGDOM' | 'UNITED_REPUBLIC_OF_TANZANIA' | 'UNITED_STATES_MINOR_OUTLYING_ISLANDS' | 'URUGUAY' | 'USA' | 'UZBEKISTAN' | 'VANUATU' | 'VATICAN_CITY_STATE' | 'VENEZUELA' | 'VIET_NAM' | 'VIRGIN_ISLANDS_GB' | 'VIRGIN_ISLANDS_USA' | 'WALLIS_AND_FUTUNA' | 'WESTERN_SAHARA' | 'YEMEN' | 'ZAMBIA' | 'ZIMBABWE' | null
}
export type RelatedCustomerEntityGridRowPersonFirstName = {
 [RelatedCustomerEntityGridRowProp.PersonFirstName] : string | null
}
export type RelatedCustomerEntityGridRowPersonLastName = {
 [RelatedCustomerEntityGridRowProp.PersonLastName] : string | null
}
export type RelatedCustomerEntityGridRowPersonNameEnglish = {
 [RelatedCustomerEntityGridRowProp.PersonNameEnglish] : string | null
}
export type RelatedCustomerEntityGridRowRegistrationTrafficSourceAffiliateId = {
 [RelatedCustomerEntityGridRowProp.RegistrationTrafficSourceAffiliateId] : string | null
}
export type RelatedCustomerEntityGridRowRegistrationStatus = {
 [RelatedCustomerEntityGridRowProp.RegistrationStatus] : 'LEAD' | 'DEMO' | 'REAL' | 'REAL_FUNDED' | null
}
export type RelatedCustomerEntityGridRowTest = {
 [RelatedCustomerEntityGridRowProp.Test] : boolean | null
}
export type RelatedCustomerEntityGridRowTotalDeposits = {
 [RelatedCustomerEntityGridRowProp.TotalDeposits] : number | null
}
export type RelatedCustomerEntityGridRow = 
 Partial<RelatedCustomerEntityGridRowComplianceDataComplianceStage> & 
 Partial<RelatedCustomerEntityGridRowComplianceDataCustomerQuestionnaireScore> & 
 Partial<RelatedCustomerEntityGridRowCreationTime> & 
 Partial<RelatedCustomerEntityGridRowDuplicationVerified> & 
 RelatedCustomerEntityGridRowId & 
 Partial<RelatedCustomerEntityGridRowObjective> & 
 Partial<RelatedCustomerEntityGridRowPersonCountry> & 
 Partial<RelatedCustomerEntityGridRowPersonFirstName> & 
 Partial<RelatedCustomerEntityGridRowPersonLastName> & 
 Partial<RelatedCustomerEntityGridRowPersonNameEnglish> & 
 Partial<RelatedCustomerEntityGridRowRegistrationTrafficSourceAffiliateId> & 
 Partial<RelatedCustomerEntityGridRowRegistrationStatus> & 
 Partial<RelatedCustomerEntityGridRowTest> & 
 Partial<RelatedCustomerEntityGridRowTotalDeposits>

export enum RelatedTransactionEntityGridRowProp {
 Auth3D = 'auth3D',
 BaseCurrencyAmount = 'baseCurrencyAmount',
 BaseCurrencyConvRate = 'baseCurrencyConvRate',
 BonusDataAdjustedAmount = 'bonusData.adjustedAmount',
 BonusExpirationDate = 'bonusExpirationDate',
 CcExpDate = 'ccExpDate',
 CcNumber = 'ccNumber',
 CreationTime = 'creationTime',
 Ecdd = 'ecdd',
 ExternalId = 'externalId',
 Id = 'id',
 ModificationTime = 'modificationTime',
 ModifiedBy = 'modifiedBy',
 ReasonInternalReason = 'reason.internalReason',
 SourceAmount = 'source.amount',
 SourceCurrency = 'source.currency',
 Status = 'status',
 TargetAmount = 'target.amount',
 TargetCurrency = 'target.currency',
 TargetCurrencyConvRate = 'targetCurrencyConvRate',
 TransactionType = 'transactionType',
 TxSubType = 'txSubType'
}
export type RelatedTransactionEntityGridRowAuth3D = {
 [RelatedTransactionEntityGridRowProp.Auth3D] : boolean | null
}
export type RelatedTransactionEntityGridRowBaseCurrencyAmount = {
 [RelatedTransactionEntityGridRowProp.BaseCurrencyAmount] : number | null
}
export type RelatedTransactionEntityGridRowBaseCurrencyConvRate = {
 [RelatedTransactionEntityGridRowProp.BaseCurrencyConvRate] : number | null
}
export type RelatedTransactionEntityGridRowBonusDataAdjustedAmount = {
 [RelatedTransactionEntityGridRowProp.BonusDataAdjustedAmount] : number | null
}
export type RelatedTransactionEntityGridRowBonusExpirationDate = {
 [RelatedTransactionEntityGridRowProp.BonusExpirationDate] : number | null
}
export type RelatedTransactionEntityGridRowCcExpDate = {
 [RelatedTransactionEntityGridRowProp.CcExpDate] : string | null
}
export type RelatedTransactionEntityGridRowCcNumber = {
 [RelatedTransactionEntityGridRowProp.CcNumber] : string | null
}
export type RelatedTransactionEntityGridRowCreationTime = {
 [RelatedTransactionEntityGridRowProp.CreationTime] : number | null
}
export type RelatedTransactionEntityGridRowEcdd = {
 [RelatedTransactionEntityGridRowProp.Ecdd] : boolean | null
}
export type RelatedTransactionEntityGridRowExternalId = {
 [RelatedTransactionEntityGridRowProp.ExternalId] : string | null
}
export type RelatedTransactionEntityGridRowId = {
 [RelatedTransactionEntityGridRowProp.Id] : number
}
export type RelatedTransactionEntityGridRowModificationTime = {
 [RelatedTransactionEntityGridRowProp.ModificationTime] : number | null
}
export type RelatedTransactionEntityGridRowModifiedBy = {
 [RelatedTransactionEntityGridRowProp.ModifiedBy] : string | null
}
export type RelatedTransactionEntityGridRowReasonInternalReason = {
 [RelatedTransactionEntityGridRowProp.ReasonInternalReason] : string | null
}
export type RelatedTransactionEntityGridRowSourceAmount = {
 [RelatedTransactionEntityGridRowProp.SourceAmount] : number | null
}
export type RelatedTransactionEntityGridRowSourceCurrency = {
 [RelatedTransactionEntityGridRowProp.SourceCurrency] : 'USD' | 'EUR' | 'GBP' | 'CAD' | 'JPY' | 'AED' | 'PLN' | 'AZN' | 'INR' | 'NZD' | 'CUP' | 'EGP' | 'LBP' | 'RMB' | 'AUD' | 'ILS' | 'RON' | 'CHF' | 'CZK' | 'DKK' | 'RUB' | 'BGN' | 'HRK' | 'CNY' | 'MXN' | 'CLP' | 'ALL' | 'NOK' | 'SEK' | 'HUF' | 'BRL' | 'ZAR' | 'HKD' | 'SGD' | 'THB' | 'TRY' | 'KRW' | 'SKK' | 'LKR' | 'COP' | 'VND' | 'CNH' | 'SAR' | 'MYR' | 'USDT' | 'LOCAL_CURRENCY' | null
}
export type RelatedTransactionEntityGridRowStatus = {
 [RelatedTransactionEntityGridRowProp.Status] : 'PENDING' | 'PENDING_COMPLIANCE' | 'DONE' | 'FAILED' | 'REJECTED' | 'PENDING_PM_APPROVAL' | 'CANCELLED_PENDING_PM_APPROVAL' | 'CANCELLED_PENDING_COMPLIANCE' | null
}
export type RelatedTransactionEntityGridRowTargetAmount = {
 [RelatedTransactionEntityGridRowProp.TargetAmount] : number | null
}
export type RelatedTransactionEntityGridRowTargetCurrency = {
 [RelatedTransactionEntityGridRowProp.TargetCurrency] : 'USD' | 'EUR' | 'GBP' | 'CAD' | 'JPY' | 'AED' | 'PLN' | 'AZN' | 'INR' | 'NZD' | 'CUP' | 'EGP' | 'LBP' | 'RMB' | 'AUD' | 'ILS' | 'RON' | 'CHF' | 'CZK' | 'DKK' | 'RUB' | 'BGN' | 'HRK' | 'CNY' | 'MXN' | 'CLP' | 'ALL' | 'NOK' | 'SEK' | 'HUF' | 'BRL' | 'ZAR' | 'HKD' | 'SGD' | 'THB' | 'TRY' | 'KRW' | 'SKK' | 'LKR' | 'COP' | 'VND' | 'CNH' | 'SAR' | 'MYR' | 'USDT' | 'LOCAL_CURRENCY' | null
}
export type RelatedTransactionEntityGridRowTargetCurrencyConvRate = {
 [RelatedTransactionEntityGridRowProp.TargetCurrencyConvRate] : number | null
}
export type RelatedTransactionEntityGridRowTransactionType = {
 [RelatedTransactionEntityGridRowProp.TransactionType] : 'DEPOSIT' | 'WITHDRAWAL' | 'CORRECTION' | null
}
export type RelatedTransactionEntityGridRowTxSubType = {
 [RelatedTransactionEntityGridRowProp.TxSubType] : 'NEGATIVE_ADJUSTMENT' | 'NEGATIVE_DEALING_CORRECTION' | 'NEGATIVE_FRAUD_ADJUSTMENT' | 'NEGATIVE_BONUS_ADJUSTMENT' | 'CLOSING_ACCOUNT_BOOK_NEGATIVE' | 'PARTNER_NEGATIVE_ADJUSTMENT' | 'POSITIVE_ADJUSTMENT' | 'POSITIVE_DEALING_CORRECTION' | 'POSITIVE_FRAUD_ADJUSTMENT' | 'POSITIVE_BONUS_ADJUSTMENT' | 'CLOSING_ACCOUNT_BOOK_POSITIVE' | 'PARTNER_PAYMENT' | 'PARTNER_BONUS' | 'BONUS' | 'CREDIT_CARD_DEPOSIT' | 'WIRE_TRANSFER_DEPOSIT' | 'CREDIT_CREDIT_CARD_WITHDRAWAL' | 'VOID_CREDIT_CARD_WITHDRAWAL' | 'REFUND_CREDIT_CARD_WITHDRAWAL' | 'WIRE_TRANSFER_WITHDRAWAL' | 'MANUAL_DEPOSIT' | 'INTERNAL_DEPOSIT' | 'MANUAL_WITHDRAWAL' | 'INTERNAL_WITHDRAWAL' | 'LIBERTY_RESERVE_DEPOSIT' | 'LIBERTY_RESERVE_WITHDRAWAL' | 'ENVOY_DEPOSIT' | 'ENVOY_WITHDRAWAL' | 'WM_WITHDRAWAL' | 'NETELLER_DEPOSIT' | 'MONEYBOOKERS_DEPOSIT' | 'QIWI_DEPOSIT' | 'WEBMONEY_DEPOSIT' | 'CHINAUNION_DEPOSIT' | 'CUP_DEPOSIT' | 'CHINAUNION_WITHDRAWAL' | 'LOBANET_DEPOSIT' | 'QIWI_WITHDRAWAL' | 'PSP_DEPOSIT' | 'BAOFOO_DEPOSIT' | 'SOLIDPAY_DEPOSIT' | 'FOCAL_DEPOSIT' | 'PAYGATE_DEPOSIT' | 'PAYMENT_ASIA_DEPOSIT' | 'CRYPTO_WITHDRAWAL' | 'MD_APM_WITHDRAWAL' | null
}
export type RelatedTransactionEntityGridRow = 
 Partial<RelatedTransactionEntityGridRowAuth3D> & 
 Partial<RelatedTransactionEntityGridRowBaseCurrencyAmount> & 
 Partial<RelatedTransactionEntityGridRowBaseCurrencyConvRate> & 
 Partial<RelatedTransactionEntityGridRowBonusDataAdjustedAmount> & 
 Partial<RelatedTransactionEntityGridRowBonusExpirationDate> & 
 Partial<RelatedTransactionEntityGridRowCcExpDate> & 
 Partial<RelatedTransactionEntityGridRowCcNumber> & 
 Partial<RelatedTransactionEntityGridRowCreationTime> & 
 Partial<RelatedTransactionEntityGridRowEcdd> & 
 Partial<RelatedTransactionEntityGridRowExternalId> & 
 RelatedTransactionEntityGridRowId & 
 Partial<RelatedTransactionEntityGridRowModificationTime> & 
 Partial<RelatedTransactionEntityGridRowModifiedBy> & 
 Partial<RelatedTransactionEntityGridRowReasonInternalReason> & 
 Partial<RelatedTransactionEntityGridRowSourceAmount> & 
 RelatedTransactionEntityGridRowSourceCurrency & 
 Partial<RelatedTransactionEntityGridRowStatus> & 
 Partial<RelatedTransactionEntityGridRowTargetAmount> & 
 RelatedTransactionEntityGridRowTargetCurrency & 
 Partial<RelatedTransactionEntityGridRowTargetCurrencyConvRate> & 
 Partial<RelatedTransactionEntityGridRowTransactionType> & 
 Partial<RelatedTransactionEntityGridRowTxSubType>

export enum SubscriptionEntityGridRowProp {
 CreationTime = 'creationTime',
 EndDate = 'endDate',
 Id = 'id',
 ModificationTime = 'modificationTime',
 ModifiedBy = 'modifiedBy',
 Status = 'status',
 SubscriptionDefinitionName = 'subscriptionDefinition.name',
 SubscriptionDefinitionServiceType = 'subscriptionDefinition.serviceType'
}
export type SubscriptionEntityGridRowCreationTime = {
 [SubscriptionEntityGridRowProp.CreationTime] : number | null
}
export type SubscriptionEntityGridRowEndDate = {
 [SubscriptionEntityGridRowProp.EndDate] : number | null
}
export type SubscriptionEntityGridRowId = {
 [SubscriptionEntityGridRowProp.Id] : number
}
export type SubscriptionEntityGridRowModificationTime = {
 [SubscriptionEntityGridRowProp.ModificationTime] : number | null
}
export type SubscriptionEntityGridRowModifiedBy = {
 [SubscriptionEntityGridRowProp.ModifiedBy] : string | null
}
export type SubscriptionEntityGridRowStatus = {
 [SubscriptionEntityGridRowProp.Status] : 'ACTIVE' | 'PENDING' | 'INACTIVE' | null
}
export type SubscriptionEntityGridRowSubscriptionDefinitionName = {
 [SubscriptionEntityGridRowProp.SubscriptionDefinitionName] : string | null
}
export type SubscriptionEntityGridRowSubscriptionDefinitionServiceType = {
 [SubscriptionEntityGridRowProp.SubscriptionDefinitionServiceType] : 'SUBSCRIPTION' | 'SERVICE' | 'MARKETING_EMAILS' | null
}
export type SubscriptionEntityGridRow = 
 Partial<SubscriptionEntityGridRowCreationTime> & 
 Partial<SubscriptionEntityGridRowEndDate> & 
 SubscriptionEntityGridRowId & 
 Partial<SubscriptionEntityGridRowModificationTime> & 
 Partial<SubscriptionEntityGridRowModifiedBy> & 
 Partial<SubscriptionEntityGridRowStatus> & 
 Partial<SubscriptionEntityGridRowSubscriptionDefinitionName> & 
 Partial<SubscriptionEntityGridRowSubscriptionDefinitionServiceType>

export enum TBARequestEntityGridRowProp {
 CreationTime = 'creationTime',
 Id = 'id',
 ModificationTime = 'modificationTime',
 ModifiedBy = 'modifiedBy',
 Source = 'source',
 SourceCurrency = 'source.currency',
 SourceCustomer = 'source.customer',
 SourceCustomerBrand = 'source.customer.brand',
 SourceAmount = 'sourceAmount',
 Status = 'status',
 Target = 'target',
 TargetCurrency = 'target.currency',
 TargetAmount = 'targetAmount',
 TransactionProcessingType = 'transactionProcessingType'
}
export type TBARequestEntityGridRowCreationTime = {
 [TBARequestEntityGridRowProp.CreationTime] : number | null
}
export type TBARequestEntityGridRowId = {
 [TBARequestEntityGridRowProp.Id] : number
}
export type TBARequestEntityGridRowModificationTime = {
 [TBARequestEntityGridRowProp.ModificationTime] : number | null
}
export type TBARequestEntityGridRowModifiedBy = {
 [TBARequestEntityGridRowProp.ModifiedBy] : string | null
}
export type TBARequestEntityGridRowSource = {
 [TBARequestEntityGridRowProp.Source] : any /* Entity */
}
export type TBARequestEntityGridRowSourceCurrency = {
 [TBARequestEntityGridRowProp.SourceCurrency] : 'USD' | 'EUR' | 'GBP' | 'CAD' | 'JPY' | 'AED' | 'PLN' | 'AZN' | 'INR' | 'NZD' | 'CUP' | 'EGP' | 'LBP' | 'RMB' | 'AUD' | 'ILS' | 'RON' | 'CHF' | 'CZK' | 'DKK' | 'RUB' | 'BGN' | 'HRK' | 'CNY' | 'MXN' | 'CLP' | 'ALL' | 'NOK' | 'SEK' | 'HUF' | 'BRL' | 'ZAR' | 'HKD' | 'SGD' | 'THB' | 'TRY' | 'KRW' | 'SKK' | 'LKR' | 'COP' | 'VND' | 'CNH' | 'SAR' | 'MYR' | 'USDT' | 'LOCAL_CURRENCY' | null
}
export type TBARequestEntityGridRowSourceCustomer = {
 [TBARequestEntityGridRowProp.SourceCustomer] : any /* Entity */
}
export type TBARequestEntityGridRowSourceCustomerBrand = {
 [TBARequestEntityGridRowProp.SourceCustomerBrand] : any /* Entity */
}
export type TBARequestEntityGridRowSourceAmount = {
 [TBARequestEntityGridRowProp.SourceAmount] : number | null
}
export type TBARequestEntityGridRowStatus = {
 [TBARequestEntityGridRowProp.Status] : 'NEW' | 'COMPLETED' | 'PENDING_FUNDS_REMOVAL' | 'PENDING_BALANCE_UPDATE' | 'FUNDS_REMOVED' | 'REJECTED' | 'FAILED' | null
}
export type TBARequestEntityGridRowTarget = {
 [TBARequestEntityGridRowProp.Target] : any /* Entity */
}
export type TBARequestEntityGridRowTargetCurrency = {
 [TBARequestEntityGridRowProp.TargetCurrency] : 'USD' | 'EUR' | 'GBP' | 'CAD' | 'JPY' | 'AED' | 'PLN' | 'AZN' | 'INR' | 'NZD' | 'CUP' | 'EGP' | 'LBP' | 'RMB' | 'AUD' | 'ILS' | 'RON' | 'CHF' | 'CZK' | 'DKK' | 'RUB' | 'BGN' | 'HRK' | 'CNY' | 'MXN' | 'CLP' | 'ALL' | 'NOK' | 'SEK' | 'HUF' | 'BRL' | 'ZAR' | 'HKD' | 'SGD' | 'THB' | 'TRY' | 'KRW' | 'SKK' | 'LKR' | 'COP' | 'VND' | 'CNH' | 'SAR' | 'MYR' | 'USDT' | 'LOCAL_CURRENCY' | null
}
export type TBARequestEntityGridRowTargetAmount = {
 [TBARequestEntityGridRowProp.TargetAmount] : number | null
}
export type TBARequestEntityGridRowTransactionProcessingType = {
 [TBARequestEntityGridRowProp.TransactionProcessingType] : 'ADJUSTMENT_BASED' | 'DEPOSIT_BASED' | null
}
export type TBARequestEntityGridRow = 
 Partial<TBARequestEntityGridRowCreationTime> & 
 TBARequestEntityGridRowId & 
 Partial<TBARequestEntityGridRowModificationTime> & 
 Partial<TBARequestEntityGridRowModifiedBy> & 
 Partial<TBARequestEntityGridRowSource> & 
 Partial<TBARequestEntityGridRowSourceCurrency> & 
 Partial<TBARequestEntityGridRowSourceCustomer> & 
 Partial<TBARequestEntityGridRowSourceCustomerBrand> & 
 Partial<TBARequestEntityGridRowSourceAmount> & 
 Partial<TBARequestEntityGridRowStatus> & 
 Partial<TBARequestEntityGridRowTarget> & 
 Partial<TBARequestEntityGridRowTargetCurrency> & 
 Partial<TBARequestEntityGridRowTargetAmount> & 
 Partial<TBARequestEntityGridRowTransactionProcessingType>

export enum TaskEntityGridRowProp {
 AssignedPoolName = 'assignedPool.name',
 AssignedUser = 'assignedUser',
 CreationTime = 'creationTime',
 Creator = 'creator',
 Customer = 'customer',
 CustomerBusinessDomain = 'customer.businessDomain',
 CustomerPersonCountry = 'customer.person.country',
 CustomerPersonLanguage = 'customer.person.language',
 CustomerRegistrationStatus = 'customer.registrationStatus',
 CustomerTotalDeposits = 'customer.totalDeposits',
 CustomerTotalWithdrawals = 'customer.totalWithdrawals',
 DueDate = 'dueDate',
 Id = 'id',
 Medium = 'medium',
 ModificationTime = 'modificationTime',
 ModifiedBy = 'modifiedBy',
 Priority = 'priority',
 StartDate = 'startDate',
 Status = 'status',
 Subject = 'subject',
 TaskCategoryLabel = 'taskCategory.label'
}
export type TaskEntityGridRowAssignedPoolName = {
 [TaskEntityGridRowProp.AssignedPoolName] : string | null
}
export type TaskEntityGridRowAssignedUser = {
 [TaskEntityGridRowProp.AssignedUser] : any /* Entity */
}
export type TaskEntityGridRowCreationTime = {
 [TaskEntityGridRowProp.CreationTime] : number | null
}
export type TaskEntityGridRowCreator = {
 [TaskEntityGridRowProp.Creator] : any /* Entity */
}
export type TaskEntityGridRowCustomer = {
 [TaskEntityGridRowProp.Customer] : any /* Entity */
}
export type TaskEntityGridRowCustomerBusinessDomain = {
 [TaskEntityGridRowProp.CustomerBusinessDomain] : any /* Entity */
}
export type TaskEntityGridRowCustomerPersonCountry = {
 [TaskEntityGridRowProp.CustomerPersonCountry] : 'NA' | 'AFGHANISTAN' | 'ÅLAND_ISLANDS' | 'ALBANIA' | 'ALGERIA' | 'AMERICAN_SAMOA' | 'ANDORRA' | 'ANGOLA' | 'ANGUILLA' | 'ANTARCTICA' | 'ANTIGUA_AND_BARBUDA' | 'ARGENTINA' | 'ARMENIA' | 'ARUBA' | 'AUSTRALIA' | 'AUSTRIA' | 'AZERBAIJAN' | 'BAHAMAS' | 'BAHRAIN' | 'BANGLADESH' | 'BARBADOS' | 'BELARUS' | 'BELGIUM' | 'BELIZE' | 'BENIN' | 'BERMUDA' | 'BHUTAN' | 'BOLIVIA' | 'BONAIRE_SINT_EUSTATIUS_AND_SABA' | 'BOSNIA_AND_HERZEGOVINA' | 'BOTSWANA' | 'BOUVET_ISLAND' | 'BRAZIL' | 'BRITISH_INDIAN_OCEAN_TERRITORY' | 'BRUNEI_DARUSSALAM' | 'BULGARIA' | 'BURKINA_FASO' | 'BURUNDI' | 'CAMBODIA' | 'CAMEROON' | 'CANADA' | 'CAPE_VERDE' | 'CAYMAN_ISLANDS' | 'CENTRAL_AFRICAN_REPUBLIC' | 'CHAD' | 'CHILE' | 'CHINA' | 'CHRISTMAS_ISLAND' | 'COCOS_ISLANDS' | 'COLOMBIA' | 'COMOROS' | 'CONGO' | 'CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE' | 'COOK_ISLANDS' | 'COSTA_RICA' | 'CROATIA' | 'CUBA' | 'CURAÇAO' | 'CYPRUS' | 'CZECH_REPUBLIC' | 'CÔTE_DIVOIRE' | 'DENMARK' | 'DJIBOUTI' | 'DOMINICA' | 'DOMINICAN_REPUBLIC' | 'EAST_TIMOR' | 'ECUADOR' | 'EGYPT' | 'EL_SALVADOR' | 'EQUATORIAL_GUINEA' | 'ERITREA' | 'ESTONIA' | 'ETHIOPIA' | 'FALKLAND_ISLANDS' | 'FAROE_ISLANDS' | 'FIJI' | 'FINLAND' | 'FRANCE' | 'FRENCH_GUIANA' | 'FRENCH_POLYNESIA' | 'FRENCH_SOUTHERN_TERRITORIES' | 'GABON' | 'GAMBIA' | 'Georgia' | 'GERMANY' | 'GHANA' | 'GIBRALTAR' | 'GREECE' | 'GREENLAND' | 'GRENADA' | 'GUADELOUPE' | 'GUAM' | 'GUATEMALA' | 'GUERNSEY' | 'GUINEA' | 'GUINEA_BISSAU' | 'GUYANA' | 'HAITI' | 'HEARD_ISLAND_AND_MCDONALD_ISLANDS' | 'HONDURAS' | 'HONG_KONG' | 'Hungary' | 'ICELAND' | 'INDIA' | 'INDONESIA' | 'IRAN' | 'IRAQ' | 'IRELAND' | 'ISLE_OF_MAN' | 'ISRAEL' | 'ITALY' | 'JAMAICA' | 'JAPAN' | 'JERSEY' | 'JORDAN' | 'KAZAKHSTAN' | 'KENYA' | 'KIRIBATI' | 'KOSOVO' | 'KOREA_DEMOCRATIC_PEOPLE_REPUBLIC_OF' | 'KOREA_REPUBLIC_OF' | 'KUWAIT' | 'KYRGYZSTAN' | 'LAO_PEOPLE_DEMOCRATIC_REPUBLIC' | 'LATVIA' | 'LEBANON' | 'LESOTHO' | 'LIBERIA' | 'LIBYAN' | 'LIECHTENSTEIN' | 'LITHUANIA' | 'LUXEMBOURG' | 'MACAO' | 'MADAGASCAR' | 'MALAWI' | 'MALAYSIA' | 'MALDIVES' | 'MALI' | 'MALTA' | 'MARSHALL_ISLANDS' | 'MARTINIQUE' | 'MAURITANIA' | 'MAURITIUS' | 'MAYOTTE' | 'MEXICO' | 'MICRONESIA' | 'MOLDOVA_REPUBLIC_OF' | 'MONACO' | 'MONGOLIA' | 'MONTENEGRO' | 'MONTSERRAT' | 'MOROCCO' | 'MOZAMBIQUE' | 'MYANMAR' | 'NAMIBIA' | 'NAURU' | 'NEPAL' | 'NETHERLANDS' | 'NETHERLANDS_ANTILLES' | 'NEW_CALEDONIA' | 'NEW_ZEALAND' | 'NICARAGUA' | 'NIGER' | 'NIGERIA' | 'NIUE' | 'NORFOLK_ISLAND' | 'NORTHERN_MARIANA_ISLANDS' | 'NORWAY' | 'OMAN' | 'PAKISTAN' | 'PALAU' | 'PALESTINIAN_TERRITORY_OCCUPIED' | 'PANAMA' | 'PAPUA_NEW_GUINEA' | 'PARAGUAY' | 'PERU' | 'PHILIPPINES' | 'PITCAIRN' | 'POLAND' | 'PORTUGAL' | 'PUERTO_RICO' | 'QATAR' | 'ROMANIA' | 'RUSSIAN_FEDERATION' | 'RWANDA' | 'RÉUNION' | 'SAINT_BARTHÉLEMY_BL' | 'SAINT_HELENA' | 'SAINT_KITTS_AND_NEVIS' | 'SAINT_LUCIA' | 'SAINT_MARTIN_FRENCH_PART' | 'SAINT_PIERRE_AND_MIQUELON' | 'SAINT_VINCENT_AND_THE_GRENADINES' | 'SAMOA' | 'SAN_MARINO' | 'SAO_TOME_AND_PRINCIPE' | 'SAUDI_ARABIA' | 'SENEGAL' | 'SERBIA' | 'SEYCHELLES' | 'SIERRA_LEONE' | 'SINGAPORE' | 'SINT_MAARTEN_DUTCH_PART' | 'SLOVAKIA' | 'SLOVENIA' | 'SOLOMON_ISLANDS' | 'SOMALIA' | 'SOUTH_AFRICA' | 'SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS' | 'SOUTH_SUDAN' | 'SPAIN' | 'SRI_LANKA' | 'SUDAN' | 'SURINAME' | 'SVALBARD_AND_JAN_MAYEN' | 'SWAZILAND' | 'SWEDEN' | 'SWITZERLAND' | 'SYRIAN_ARAB_REPUBLIC' | 'TAIWAN' | 'TAJIKISTAN' | 'THAILAND' | 'THE_FORMER_YUGOSLAV_REPUBLIC_OF_MACEDONIA' | 'TOGO' | 'TOKELAU' | 'TONGA' | 'TRINIDAD_AND_TOBAGO' | 'TUNISIA' | 'TURKEY' | 'TURKMENISTAN' | 'TURKS_AND_CAICOS_ISLANDS' | 'TUVALU' | 'UGANDA' | 'UKRAINE' | 'UNITED_ARAB_EMIRATES' | 'UNITED_KINGDOM' | 'UNITED_REPUBLIC_OF_TANZANIA' | 'UNITED_STATES_MINOR_OUTLYING_ISLANDS' | 'URUGUAY' | 'USA' | 'UZBEKISTAN' | 'VANUATU' | 'VATICAN_CITY_STATE' | 'VENEZUELA' | 'VIET_NAM' | 'VIRGIN_ISLANDS_GB' | 'VIRGIN_ISLANDS_USA' | 'WALLIS_AND_FUTUNA' | 'WESTERN_SAHARA' | 'YEMEN' | 'ZAMBIA' | 'ZIMBABWE' | null
}
export type TaskEntityGridRowCustomerPersonLanguage = {
 [TaskEntityGridRowProp.CustomerPersonLanguage] : 'OTHER' | 'ALBANIAN' | 'ARABIC' | 'BULGARIAN' | 'CATALAN' | 'CHINESE' | 'CHINESETR' | 'CROATIAN' | 'CZECH' | 'DANISH' | 'DUTCH' | 'ENGLISH' | 'ESTONIAN' | 'FINNISH' | 'FRENCH' | 'GALICIAN' | 'GERMAN' | 'GREEK' | 'HEBREW' | 'HINDI' | 'HUNGARIAN' | 'INDONESIAN' | 'ITALIAN' | 'JAPANESE' | 'KOREAN' | 'LATVIAN' | 'LITHUANIAN' | 'MALAY' | 'MALTESE' | 'NORWEGIAN' | 'PERSIAN' | 'POLISH' | 'PORTUGUESE' | 'PUNJABI' | 'ROMANIAN' | 'RUSSIAN' | 'SERBIAN' | 'SLOVAK' | 'SLOVENIAN' | 'SPANISH' | 'SWEDISH' | 'TAGALOG' | 'THAI' | 'TURKISH' | 'UKRAINIAN' | 'URDU' | 'VIETNAMESE' | null
}
export type TaskEntityGridRowCustomerRegistrationStatus = {
 [TaskEntityGridRowProp.CustomerRegistrationStatus] : 'LEAD' | 'DEMO' | 'REAL' | 'REAL_FUNDED' | null
}
export type TaskEntityGridRowCustomerTotalDeposits = {
 [TaskEntityGridRowProp.CustomerTotalDeposits] : number | null
}
export type TaskEntityGridRowCustomerTotalWithdrawals = {
 [TaskEntityGridRowProp.CustomerTotalWithdrawals] : number | null
}
export type TaskEntityGridRowDueDate = {
 [TaskEntityGridRowProp.DueDate] : number | null
}
export type TaskEntityGridRowId = {
 [TaskEntityGridRowProp.Id] : number
}
export type TaskEntityGridRowMedium = {
 [TaskEntityGridRowProp.Medium] : 'INTERNAL' | 'MAIL' | 'PHONE' | 'LIVE_CHAT' | 'SMS' | 'MEETING' | 'ZENDESK' | 'APP_POPUP' | 'APP_PUSH' | 'RECORDING' | 'ZENDESK_CHAT' | null
}
export type TaskEntityGridRowModificationTime = {
 [TaskEntityGridRowProp.ModificationTime] : number | null
}
export type TaskEntityGridRowModifiedBy = {
 [TaskEntityGridRowProp.ModifiedBy] : string | null
}
export type TaskEntityGridRowPriority = {
 [TaskEntityGridRowProp.Priority] : 'HIGH' | 'MEDIUM' | 'LOW' | null
}
export type TaskEntityGridRowStartDate = {
 [TaskEntityGridRowProp.StartDate] : number | null
}
export type TaskEntityGridRowStatus = {
 [TaskEntityGridRowProp.Status] : 'NEW' | 'IN_PROGRESS' | 'REJECTED' | 'FAILED' | 'RESOLVED' | 'CLOSED' | 'CANCELED' | null
}
export type TaskEntityGridRowSubject = {
 [TaskEntityGridRowProp.Subject] : string | null
}
export type TaskEntityGridRowTaskCategoryLabel = {
 [TaskEntityGridRowProp.TaskCategoryLabel] : string | null
}
export type TaskEntityGridRow = 
 Partial<TaskEntityGridRowAssignedPoolName> & 
 Partial<TaskEntityGridRowAssignedUser> & 
 Partial<TaskEntityGridRowCreationTime> & 
 Partial<TaskEntityGridRowCreator> & 
 Partial<TaskEntityGridRowCustomer> & 
 Partial<TaskEntityGridRowCustomerBusinessDomain> & 
 Partial<TaskEntityGridRowCustomerPersonCountry> & 
 Partial<TaskEntityGridRowCustomerPersonLanguage> & 
 Partial<TaskEntityGridRowCustomerRegistrationStatus> & 
 Partial<TaskEntityGridRowCustomerTotalDeposits> & 
 Partial<TaskEntityGridRowCustomerTotalWithdrawals> & 
 Partial<TaskEntityGridRowDueDate> & 
 TaskEntityGridRowId & 
 Partial<TaskEntityGridRowMedium> & 
 Partial<TaskEntityGridRowModificationTime> & 
 Partial<TaskEntityGridRowModifiedBy> & 
 Partial<TaskEntityGridRowPriority> & 
 Partial<TaskEntityGridRowStartDate> & 
 Partial<TaskEntityGridRowStatus> & 
 Partial<TaskEntityGridRowSubject> & 
 Partial<TaskEntityGridRowTaskCategoryLabel>

export enum TradingAccountEntityGridRowProp {
 AutoTradePlatformType = 'autoTradePlatformType',
 CreationTime = 'creationTime',
 Currency = 'currency',
 Customer = 'customer',
 Id = 'id',
 Islamic = 'islamic',
 Leverage = 'leverage',
 Omnibus = 'omnibus',
 PlatformAccountId = 'platformAccountId',
 ReportingType = 'reportingType',
 Test = 'test',
 TotalDeposits = 'totalDeposits',
 TotalWithdrawals = 'totalWithdrawals',
 TradePlatformType = 'tradePlatformType',
 TradingAccountInstrumentType = 'tradingAccountInstrumentType',
 TradingAccountMode = 'tradingAccountMode',
 TradingAccountStatus = 'tradingAccountStatus',
 TradingAccountType = 'tradingAccountType',
 TradingTotalsEquity = 'tradingTotals.equity',
 TradingTotalsMarginFree = 'tradingTotals.marginFree',
 UserName = 'userName'
}
export type TradingAccountEntityGridRowAutoTradePlatformType = {
 [TradingAccountEntityGridRowProp.AutoTradePlatformType] : 'NA' | 'TRADENCY' | 'CURRENSEE' | 'SIGNAL_TRADER' | 'FOREX_STRATEGY' | null
}
export type TradingAccountEntityGridRowCreationTime = {
 [TradingAccountEntityGridRowProp.CreationTime] : number | null
}
export type TradingAccountEntityGridRowCurrency = {
 [TradingAccountEntityGridRowProp.Currency] : 'USD' | 'EUR' | 'GBP' | 'CAD' | 'JPY' | 'PLN' | 'AUD' | 'NOK' | 'SEK' | 'CZK' | 'DKK' | 'RUB' | 'RON' | 'BGN' | 'HRK' | 'HUF' | 'ZAR' | 'NZD' | 'LKR' | 'CHF' | 'INR' | 'MXN' | 'AED' | 'BRL' | 'COP' | null
}
export type TradingAccountEntityGridRowCustomer = {
 [TradingAccountEntityGridRowProp.Customer] : any /* Entity */
}
export type TradingAccountEntityGridRowId = {
 [TradingAccountEntityGridRowProp.Id] : number
}
export type TradingAccountEntityGridRowIslamic = {
 [TradingAccountEntityGridRowProp.Islamic] : boolean | null
}
export type TradingAccountEntityGridRowLeverage = {
 [TradingAccountEntityGridRowProp.Leverage] : any /* Entity */
}
export type TradingAccountEntityGridRowOmnibus = {
 [TradingAccountEntityGridRowProp.Omnibus] : boolean | null
}
export type TradingAccountEntityGridRowPlatformAccountId = {
 [TradingAccountEntityGridRowProp.PlatformAccountId] : string | null
}
export type TradingAccountEntityGridRowReportingType = {
 [TradingAccountEntityGridRowProp.ReportingType] : 'Single' | 'Delegated' | 'DoubleDelegated' | null
}
export type TradingAccountEntityGridRowTest = {
 [TradingAccountEntityGridRowProp.Test] : boolean | null
}
export type TradingAccountEntityGridRowTotalDeposits = {
 [TradingAccountEntityGridRowProp.TotalDeposits] : number | null
}
export type TradingAccountEntityGridRowTotalWithdrawals = {
 [TradingAccountEntityGridRowProp.TotalWithdrawals] : number | null
}
export type TradingAccountEntityGridRowTradePlatformType = {
 [TradingAccountEntityGridRowProp.TradePlatformType] : 'ACT' | 'MT4' | 'FOREX_TRADER' | 'IFP_GAMING' | 'MULTI_TRADER' | 'WEB_FX' | 'SPOT_OPTION' | 'COSMOS' | 'BINARYOPTIONS' | 'PLUS500' | 'MT5' | 'TTA' | 'DMA' | null
}
export type TradingAccountEntityGridRowTradingAccountInstrumentType = {
 [TradingAccountEntityGridRowProp.TradingAccountInstrumentType] : 'CFD' | 'SPREAD_BETTING' | 'QUANT_RANKS' | 'SHARE_DEALING' | 'ASSET_MANAGEMENT' | 'CRYPTO' | null
}
export type TradingAccountEntityGridRowTradingAccountMode = {
 [TradingAccountEntityGridRowProp.TradingAccountMode] : 'FULL' | 'READ_ONLY' | 'LONG_ONLY' | 'SHORT_ONLY' | 'NO' | null
}
export type TradingAccountEntityGridRowTradingAccountStatus = {
 [TradingAccountEntityGridRowProp.TradingAccountStatus] : 'INACTIVE' | 'ACTIVE' | 'CLOSED' | 'PENDING' | 'ARCHIVED' | null
}
export type TradingAccountEntityGridRowTradingAccountType = {
 [TradingAccountEntityGridRowProp.TradingAccountType] : 'REAL' | 'DEMO' | null
}
export type TradingAccountEntityGridRowTradingTotalsEquity = {
 [TradingAccountEntityGridRowProp.TradingTotalsEquity] : number | null
}
export type TradingAccountEntityGridRowTradingTotalsMarginFree = {
 [TradingAccountEntityGridRowProp.TradingTotalsMarginFree] : number | null
}
export type TradingAccountEntityGridRowUserName = {
 [TradingAccountEntityGridRowProp.UserName] : string | null
}
export type TradingAccountEntityGridRow = 
 Partial<TradingAccountEntityGridRowAutoTradePlatformType> & 
 Partial<TradingAccountEntityGridRowCreationTime> & 
 Partial<TradingAccountEntityGridRowCurrency> & 
 Partial<TradingAccountEntityGridRowCustomer> & 
 TradingAccountEntityGridRowId & 
 Partial<TradingAccountEntityGridRowIslamic> & 
 Partial<TradingAccountEntityGridRowLeverage> & 
 Partial<TradingAccountEntityGridRowOmnibus> & 
 Partial<TradingAccountEntityGridRowPlatformAccountId> & 
 Partial<TradingAccountEntityGridRowReportingType> & 
 Partial<TradingAccountEntityGridRowTest> & 
 Partial<TradingAccountEntityGridRowTotalDeposits> & 
 Partial<TradingAccountEntityGridRowTotalWithdrawals> & 
 Partial<TradingAccountEntityGridRowTradePlatformType> & 
 Partial<TradingAccountEntityGridRowTradingAccountInstrumentType> & 
 Partial<TradingAccountEntityGridRowTradingAccountMode> & 
 TradingAccountEntityGridRowTradingAccountStatus & 
 Partial<TradingAccountEntityGridRowTradingAccountType> & 
 Partial<TradingAccountEntityGridRowTradingTotalsEquity> & 
 Partial<TradingAccountEntityGridRowTradingTotalsMarginFree> & 
 Partial<TradingAccountEntityGridRowUserName>

export enum WireTransferDepositEntityGridRowProp {
 Auth3D = 'auth3D',
 BaseCurrencyAmount = 'baseCurrencyAmount',
 BaseCurrencyConvRate = 'baseCurrencyConvRate',
 BonusDataAdjustedAmount = 'bonusData.adjustedAmount',
 BonusExpirationDate = 'bonusExpirationDate',
 CcExpDate = 'ccExpDate',
 CcNumber = 'ccNumber',
 CreationTime = 'creationTime',
 Ecdd = 'ecdd',
 ExternalId = 'externalId',
 Id = 'id',
 ModificationTime = 'modificationTime',
 ModifiedBy = 'modifiedBy',
 ReasonInternalReason = 'reason.internalReason',
 SourceAmount = 'source.amount',
 SourceCurrency = 'source.currency',
 Status = 'status',
 TargetAmount = 'target.amount',
 TargetCurrency = 'target.currency',
 TargetCurrencyConvRate = 'targetCurrencyConvRate',
 TransactionType = 'transactionType',
 TxSubType = 'txSubType'
}
export type WireTransferDepositEntityGridRowAuth3D = {
 [WireTransferDepositEntityGridRowProp.Auth3D] : boolean | null
}
export type WireTransferDepositEntityGridRowBaseCurrencyAmount = {
 [WireTransferDepositEntityGridRowProp.BaseCurrencyAmount] : number | null
}
export type WireTransferDepositEntityGridRowBaseCurrencyConvRate = {
 [WireTransferDepositEntityGridRowProp.BaseCurrencyConvRate] : number | null
}
export type WireTransferDepositEntityGridRowBonusDataAdjustedAmount = {
 [WireTransferDepositEntityGridRowProp.BonusDataAdjustedAmount] : number | null
}
export type WireTransferDepositEntityGridRowBonusExpirationDate = {
 [WireTransferDepositEntityGridRowProp.BonusExpirationDate] : number | null
}
export type WireTransferDepositEntityGridRowCcExpDate = {
 [WireTransferDepositEntityGridRowProp.CcExpDate] : string | null
}
export type WireTransferDepositEntityGridRowCcNumber = {
 [WireTransferDepositEntityGridRowProp.CcNumber] : string | null
}
export type WireTransferDepositEntityGridRowCreationTime = {
 [WireTransferDepositEntityGridRowProp.CreationTime] : number | null
}
export type WireTransferDepositEntityGridRowEcdd = {
 [WireTransferDepositEntityGridRowProp.Ecdd] : boolean | null
}
export type WireTransferDepositEntityGridRowExternalId = {
 [WireTransferDepositEntityGridRowProp.ExternalId] : string | null
}
export type WireTransferDepositEntityGridRowId = {
 [WireTransferDepositEntityGridRowProp.Id] : number
}
export type WireTransferDepositEntityGridRowModificationTime = {
 [WireTransferDepositEntityGridRowProp.ModificationTime] : number | null
}
export type WireTransferDepositEntityGridRowModifiedBy = {
 [WireTransferDepositEntityGridRowProp.ModifiedBy] : string | null
}
export type WireTransferDepositEntityGridRowReasonInternalReason = {
 [WireTransferDepositEntityGridRowProp.ReasonInternalReason] : string | null
}
export type WireTransferDepositEntityGridRowSourceAmount = {
 [WireTransferDepositEntityGridRowProp.SourceAmount] : number | null
}
export type WireTransferDepositEntityGridRowSourceCurrency = {
 [WireTransferDepositEntityGridRowProp.SourceCurrency] : 'USD' | 'EUR' | 'GBP' | 'CAD' | 'JPY' | 'AED' | 'PLN' | 'AZN' | 'INR' | 'NZD' | 'CUP' | 'EGP' | 'LBP' | 'RMB' | 'AUD' | 'ILS' | 'RON' | 'CHF' | 'CZK' | 'DKK' | 'RUB' | 'BGN' | 'HRK' | 'CNY' | 'MXN' | 'CLP' | 'ALL' | 'NOK' | 'SEK' | 'HUF' | 'BRL' | 'ZAR' | 'HKD' | 'SGD' | 'THB' | 'TRY' | 'KRW' | 'SKK' | 'LKR' | 'COP' | 'VND' | 'CNH' | 'SAR' | 'MYR' | 'USDT' | 'LOCAL_CURRENCY' | null
}
export type WireTransferDepositEntityGridRowStatus = {
 [WireTransferDepositEntityGridRowProp.Status] : 'PENDING' | 'PENDING_COMPLIANCE' | 'DONE' | 'FAILED' | 'REJECTED' | 'PENDING_PM_APPROVAL' | 'CANCELLED_PENDING_PM_APPROVAL' | 'CANCELLED_PENDING_COMPLIANCE' | null
}
export type WireTransferDepositEntityGridRowTargetAmount = {
 [WireTransferDepositEntityGridRowProp.TargetAmount] : number | null
}
export type WireTransferDepositEntityGridRowTargetCurrency = {
 [WireTransferDepositEntityGridRowProp.TargetCurrency] : 'USD' | 'EUR' | 'GBP' | 'CAD' | 'JPY' | 'AED' | 'PLN' | 'AZN' | 'INR' | 'NZD' | 'CUP' | 'EGP' | 'LBP' | 'RMB' | 'AUD' | 'ILS' | 'RON' | 'CHF' | 'CZK' | 'DKK' | 'RUB' | 'BGN' | 'HRK' | 'CNY' | 'MXN' | 'CLP' | 'ALL' | 'NOK' | 'SEK' | 'HUF' | 'BRL' | 'ZAR' | 'HKD' | 'SGD' | 'THB' | 'TRY' | 'KRW' | 'SKK' | 'LKR' | 'COP' | 'VND' | 'CNH' | 'SAR' | 'MYR' | 'USDT' | 'LOCAL_CURRENCY' | null
}
export type WireTransferDepositEntityGridRowTargetCurrencyConvRate = {
 [WireTransferDepositEntityGridRowProp.TargetCurrencyConvRate] : number | null
}
export type WireTransferDepositEntityGridRowTransactionType = {
 [WireTransferDepositEntityGridRowProp.TransactionType] : 'DEPOSIT' | 'WITHDRAWAL' | 'CORRECTION' | null
}
export type WireTransferDepositEntityGridRowTxSubType = {
 [WireTransferDepositEntityGridRowProp.TxSubType] : 'NEGATIVE_ADJUSTMENT' | 'NEGATIVE_DEALING_CORRECTION' | 'NEGATIVE_FRAUD_ADJUSTMENT' | 'NEGATIVE_BONUS_ADJUSTMENT' | 'CLOSING_ACCOUNT_BOOK_NEGATIVE' | 'PARTNER_NEGATIVE_ADJUSTMENT' | 'POSITIVE_ADJUSTMENT' | 'POSITIVE_DEALING_CORRECTION' | 'POSITIVE_FRAUD_ADJUSTMENT' | 'POSITIVE_BONUS_ADJUSTMENT' | 'CLOSING_ACCOUNT_BOOK_POSITIVE' | 'PARTNER_PAYMENT' | 'PARTNER_BONUS' | 'BONUS' | 'CREDIT_CARD_DEPOSIT' | 'WIRE_TRANSFER_DEPOSIT' | 'CREDIT_CREDIT_CARD_WITHDRAWAL' | 'VOID_CREDIT_CARD_WITHDRAWAL' | 'REFUND_CREDIT_CARD_WITHDRAWAL' | 'WIRE_TRANSFER_WITHDRAWAL' | 'MANUAL_DEPOSIT' | 'INTERNAL_DEPOSIT' | 'MANUAL_WITHDRAWAL' | 'INTERNAL_WITHDRAWAL' | 'LIBERTY_RESERVE_DEPOSIT' | 'LIBERTY_RESERVE_WITHDRAWAL' | 'ENVOY_DEPOSIT' | 'ENVOY_WITHDRAWAL' | 'WM_WITHDRAWAL' | 'NETELLER_DEPOSIT' | 'MONEYBOOKERS_DEPOSIT' | 'QIWI_DEPOSIT' | 'WEBMONEY_DEPOSIT' | 'CHINAUNION_DEPOSIT' | 'CUP_DEPOSIT' | 'CHINAUNION_WITHDRAWAL' | 'LOBANET_DEPOSIT' | 'QIWI_WITHDRAWAL' | 'PSP_DEPOSIT' | 'BAOFOO_DEPOSIT' | 'SOLIDPAY_DEPOSIT' | 'FOCAL_DEPOSIT' | 'PAYGATE_DEPOSIT' | 'PAYMENT_ASIA_DEPOSIT' | 'CRYPTO_WITHDRAWAL' | 'MD_APM_WITHDRAWAL' | null
}
export type WireTransferDepositEntityGridRow = 
 Partial<WireTransferDepositEntityGridRowAuth3D> & 
 Partial<WireTransferDepositEntityGridRowBaseCurrencyAmount> & 
 Partial<WireTransferDepositEntityGridRowBaseCurrencyConvRate> & 
 Partial<WireTransferDepositEntityGridRowBonusDataAdjustedAmount> & 
 Partial<WireTransferDepositEntityGridRowBonusExpirationDate> & 
 Partial<WireTransferDepositEntityGridRowCcExpDate> & 
 Partial<WireTransferDepositEntityGridRowCcNumber> & 
 Partial<WireTransferDepositEntityGridRowCreationTime> & 
 Partial<WireTransferDepositEntityGridRowEcdd> & 
 Partial<WireTransferDepositEntityGridRowExternalId> & 
 WireTransferDepositEntityGridRowId & 
 Partial<WireTransferDepositEntityGridRowModificationTime> & 
 Partial<WireTransferDepositEntityGridRowModifiedBy> & 
 Partial<WireTransferDepositEntityGridRowReasonInternalReason> & 
 Partial<WireTransferDepositEntityGridRowSourceAmount> & 
 WireTransferDepositEntityGridRowSourceCurrency & 
 Partial<WireTransferDepositEntityGridRowStatus> & 
 Partial<WireTransferDepositEntityGridRowTargetAmount> & 
 WireTransferDepositEntityGridRowTargetCurrency & 
 Partial<WireTransferDepositEntityGridRowTargetCurrencyConvRate> & 
 Partial<WireTransferDepositEntityGridRowTransactionType> & 
 Partial<WireTransferDepositEntityGridRowTxSubType>

export enum WireTransferWithdrawalEntityGridRowProp {
 Auth3D = 'auth3D',
 BaseCurrencyAmount = 'baseCurrencyAmount',
 BaseCurrencyConvRate = 'baseCurrencyConvRate',
 BonusDataAdjustedAmount = 'bonusData.adjustedAmount',
 BonusExpirationDate = 'bonusExpirationDate',
 CcExpDate = 'ccExpDate',
 CcNumber = 'ccNumber',
 CreationTime = 'creationTime',
 Ecdd = 'ecdd',
 ExternalId = 'externalId',
 Id = 'id',
 ModificationTime = 'modificationTime',
 ModifiedBy = 'modifiedBy',
 ReasonInternalReason = 'reason.internalReason',
 SourceAmount = 'source.amount',
 SourceCurrency = 'source.currency',
 Status = 'status',
 TargetAmount = 'target.amount',
 TargetCurrency = 'target.currency',
 TargetCurrencyConvRate = 'targetCurrencyConvRate',
 TransactionType = 'transactionType',
 TxSubType = 'txSubType'
}
export type WireTransferWithdrawalEntityGridRowAuth3D = {
 [WireTransferWithdrawalEntityGridRowProp.Auth3D] : boolean | null
}
export type WireTransferWithdrawalEntityGridRowBaseCurrencyAmount = {
 [WireTransferWithdrawalEntityGridRowProp.BaseCurrencyAmount] : number | null
}
export type WireTransferWithdrawalEntityGridRowBaseCurrencyConvRate = {
 [WireTransferWithdrawalEntityGridRowProp.BaseCurrencyConvRate] : number | null
}
export type WireTransferWithdrawalEntityGridRowBonusDataAdjustedAmount = {
 [WireTransferWithdrawalEntityGridRowProp.BonusDataAdjustedAmount] : number | null
}
export type WireTransferWithdrawalEntityGridRowBonusExpirationDate = {
 [WireTransferWithdrawalEntityGridRowProp.BonusExpirationDate] : number | null
}
export type WireTransferWithdrawalEntityGridRowCcExpDate = {
 [WireTransferWithdrawalEntityGridRowProp.CcExpDate] : string | null
}
export type WireTransferWithdrawalEntityGridRowCcNumber = {
 [WireTransferWithdrawalEntityGridRowProp.CcNumber] : string | null
}
export type WireTransferWithdrawalEntityGridRowCreationTime = {
 [WireTransferWithdrawalEntityGridRowProp.CreationTime] : number | null
}
export type WireTransferWithdrawalEntityGridRowEcdd = {
 [WireTransferWithdrawalEntityGridRowProp.Ecdd] : boolean | null
}
export type WireTransferWithdrawalEntityGridRowExternalId = {
 [WireTransferWithdrawalEntityGridRowProp.ExternalId] : string | null
}
export type WireTransferWithdrawalEntityGridRowId = {
 [WireTransferWithdrawalEntityGridRowProp.Id] : number
}
export type WireTransferWithdrawalEntityGridRowModificationTime = {
 [WireTransferWithdrawalEntityGridRowProp.ModificationTime] : number | null
}
export type WireTransferWithdrawalEntityGridRowModifiedBy = {
 [WireTransferWithdrawalEntityGridRowProp.ModifiedBy] : string | null
}
export type WireTransferWithdrawalEntityGridRowReasonInternalReason = {
 [WireTransferWithdrawalEntityGridRowProp.ReasonInternalReason] : string | null
}
export type WireTransferWithdrawalEntityGridRowSourceAmount = {
 [WireTransferWithdrawalEntityGridRowProp.SourceAmount] : number | null
}
export type WireTransferWithdrawalEntityGridRowSourceCurrency = {
 [WireTransferWithdrawalEntityGridRowProp.SourceCurrency] : 'USD' | 'EUR' | 'GBP' | 'CAD' | 'JPY' | 'AED' | 'PLN' | 'AZN' | 'INR' | 'NZD' | 'CUP' | 'EGP' | 'LBP' | 'RMB' | 'AUD' | 'ILS' | 'RON' | 'CHF' | 'CZK' | 'DKK' | 'RUB' | 'BGN' | 'HRK' | 'CNY' | 'MXN' | 'CLP' | 'ALL' | 'NOK' | 'SEK' | 'HUF' | 'BRL' | 'ZAR' | 'HKD' | 'SGD' | 'THB' | 'TRY' | 'KRW' | 'SKK' | 'LKR' | 'COP' | 'VND' | 'CNH' | 'SAR' | 'MYR' | 'USDT' | 'LOCAL_CURRENCY' | null
}
export type WireTransferWithdrawalEntityGridRowStatus = {
 [WireTransferWithdrawalEntityGridRowProp.Status] : 'PENDING' | 'PENDING_COMPLIANCE' | 'DONE' | 'FAILED' | 'REJECTED' | 'PENDING_PM_APPROVAL' | 'CANCELLED_PENDING_PM_APPROVAL' | 'CANCELLED_PENDING_COMPLIANCE' | null
}
export type WireTransferWithdrawalEntityGridRowTargetAmount = {
 [WireTransferWithdrawalEntityGridRowProp.TargetAmount] : number | null
}
export type WireTransferWithdrawalEntityGridRowTargetCurrency = {
 [WireTransferWithdrawalEntityGridRowProp.TargetCurrency] : 'USD' | 'EUR' | 'GBP' | 'CAD' | 'JPY' | 'AED' | 'PLN' | 'AZN' | 'INR' | 'NZD' | 'CUP' | 'EGP' | 'LBP' | 'RMB' | 'AUD' | 'ILS' | 'RON' | 'CHF' | 'CZK' | 'DKK' | 'RUB' | 'BGN' | 'HRK' | 'CNY' | 'MXN' | 'CLP' | 'ALL' | 'NOK' | 'SEK' | 'HUF' | 'BRL' | 'ZAR' | 'HKD' | 'SGD' | 'THB' | 'TRY' | 'KRW' | 'SKK' | 'LKR' | 'COP' | 'VND' | 'CNH' | 'SAR' | 'MYR' | 'USDT' | 'LOCAL_CURRENCY' | null
}
export type WireTransferWithdrawalEntityGridRowTargetCurrencyConvRate = {
 [WireTransferWithdrawalEntityGridRowProp.TargetCurrencyConvRate] : number | null
}
export type WireTransferWithdrawalEntityGridRowTransactionType = {
 [WireTransferWithdrawalEntityGridRowProp.TransactionType] : 'DEPOSIT' | 'WITHDRAWAL' | 'CORRECTION' | null
}
export type WireTransferWithdrawalEntityGridRowTxSubType = {
 [WireTransferWithdrawalEntityGridRowProp.TxSubType] : 'NEGATIVE_ADJUSTMENT' | 'NEGATIVE_DEALING_CORRECTION' | 'NEGATIVE_FRAUD_ADJUSTMENT' | 'NEGATIVE_BONUS_ADJUSTMENT' | 'CLOSING_ACCOUNT_BOOK_NEGATIVE' | 'PARTNER_NEGATIVE_ADJUSTMENT' | 'POSITIVE_ADJUSTMENT' | 'POSITIVE_DEALING_CORRECTION' | 'POSITIVE_FRAUD_ADJUSTMENT' | 'POSITIVE_BONUS_ADJUSTMENT' | 'CLOSING_ACCOUNT_BOOK_POSITIVE' | 'PARTNER_PAYMENT' | 'PARTNER_BONUS' | 'BONUS' | 'CREDIT_CARD_DEPOSIT' | 'WIRE_TRANSFER_DEPOSIT' | 'CREDIT_CREDIT_CARD_WITHDRAWAL' | 'VOID_CREDIT_CARD_WITHDRAWAL' | 'REFUND_CREDIT_CARD_WITHDRAWAL' | 'WIRE_TRANSFER_WITHDRAWAL' | 'MANUAL_DEPOSIT' | 'INTERNAL_DEPOSIT' | 'MANUAL_WITHDRAWAL' | 'INTERNAL_WITHDRAWAL' | 'LIBERTY_RESERVE_DEPOSIT' | 'LIBERTY_RESERVE_WITHDRAWAL' | 'ENVOY_DEPOSIT' | 'ENVOY_WITHDRAWAL' | 'WM_WITHDRAWAL' | 'NETELLER_DEPOSIT' | 'MONEYBOOKERS_DEPOSIT' | 'QIWI_DEPOSIT' | 'WEBMONEY_DEPOSIT' | 'CHINAUNION_DEPOSIT' | 'CUP_DEPOSIT' | 'CHINAUNION_WITHDRAWAL' | 'LOBANET_DEPOSIT' | 'QIWI_WITHDRAWAL' | 'PSP_DEPOSIT' | 'BAOFOO_DEPOSIT' | 'SOLIDPAY_DEPOSIT' | 'FOCAL_DEPOSIT' | 'PAYGATE_DEPOSIT' | 'PAYMENT_ASIA_DEPOSIT' | 'CRYPTO_WITHDRAWAL' | 'MD_APM_WITHDRAWAL' | null
}
export type WireTransferWithdrawalEntityGridRow = 
 Partial<WireTransferWithdrawalEntityGridRowAuth3D> & 
 Partial<WireTransferWithdrawalEntityGridRowBaseCurrencyAmount> & 
 Partial<WireTransferWithdrawalEntityGridRowBaseCurrencyConvRate> & 
 Partial<WireTransferWithdrawalEntityGridRowBonusDataAdjustedAmount> & 
 Partial<WireTransferWithdrawalEntityGridRowBonusExpirationDate> & 
 Partial<WireTransferWithdrawalEntityGridRowCcExpDate> & 
 Partial<WireTransferWithdrawalEntityGridRowCcNumber> & 
 Partial<WireTransferWithdrawalEntityGridRowCreationTime> & 
 Partial<WireTransferWithdrawalEntityGridRowEcdd> & 
 Partial<WireTransferWithdrawalEntityGridRowExternalId> & 
 WireTransferWithdrawalEntityGridRowId & 
 Partial<WireTransferWithdrawalEntityGridRowModificationTime> & 
 Partial<WireTransferWithdrawalEntityGridRowModifiedBy> & 
 Partial<WireTransferWithdrawalEntityGridRowReasonInternalReason> & 
 Partial<WireTransferWithdrawalEntityGridRowSourceAmount> & 
 WireTransferWithdrawalEntityGridRowSourceCurrency & 
 Partial<WireTransferWithdrawalEntityGridRowStatus> & 
 Partial<WireTransferWithdrawalEntityGridRowTargetAmount> & 
 WireTransferWithdrawalEntityGridRowTargetCurrency & 
 Partial<WireTransferWithdrawalEntityGridRowTargetCurrencyConvRate> & 
 Partial<WireTransferWithdrawalEntityGridRowTransactionType> & 
 Partial<WireTransferWithdrawalEntityGridRowTxSubType>

export enum WithdrawalEntityGridRowProp {
 Auth3D = 'auth3D',
 BaseCurrencyAmount = 'baseCurrencyAmount',
 BaseCurrencyConvRate = 'baseCurrencyConvRate',
 BonusDataAdjustedAmount = 'bonusData.adjustedAmount',
 BonusExpirationDate = 'bonusExpirationDate',
 CcExpDate = 'ccExpDate',
 CcNumber = 'ccNumber',
 CreationTime = 'creationTime',
 Ecdd = 'ecdd',
 ExternalId = 'externalId',
 Id = 'id',
 ModificationTime = 'modificationTime',
 ModifiedBy = 'modifiedBy',
 ReasonInternalReason = 'reason.internalReason',
 SourceAmount = 'source.amount',
 SourceCurrency = 'source.currency',
 Status = 'status',
 TargetAmount = 'target.amount',
 TargetCurrency = 'target.currency',
 TargetCurrencyConvRate = 'targetCurrencyConvRate',
 TransactionType = 'transactionType',
 TxSubType = 'txSubType'
}
export type WithdrawalEntityGridRowAuth3D = {
 [WithdrawalEntityGridRowProp.Auth3D] : boolean | null
}
export type WithdrawalEntityGridRowBaseCurrencyAmount = {
 [WithdrawalEntityGridRowProp.BaseCurrencyAmount] : number | null
}
export type WithdrawalEntityGridRowBaseCurrencyConvRate = {
 [WithdrawalEntityGridRowProp.BaseCurrencyConvRate] : number | null
}
export type WithdrawalEntityGridRowBonusDataAdjustedAmount = {
 [WithdrawalEntityGridRowProp.BonusDataAdjustedAmount] : number | null
}
export type WithdrawalEntityGridRowBonusExpirationDate = {
 [WithdrawalEntityGridRowProp.BonusExpirationDate] : number | null
}
export type WithdrawalEntityGridRowCcExpDate = {
 [WithdrawalEntityGridRowProp.CcExpDate] : string | null
}
export type WithdrawalEntityGridRowCcNumber = {
 [WithdrawalEntityGridRowProp.CcNumber] : string | null
}
export type WithdrawalEntityGridRowCreationTime = {
 [WithdrawalEntityGridRowProp.CreationTime] : number | null
}
export type WithdrawalEntityGridRowEcdd = {
 [WithdrawalEntityGridRowProp.Ecdd] : boolean | null
}
export type WithdrawalEntityGridRowExternalId = {
 [WithdrawalEntityGridRowProp.ExternalId] : string | null
}
export type WithdrawalEntityGridRowId = {
 [WithdrawalEntityGridRowProp.Id] : number
}
export type WithdrawalEntityGridRowModificationTime = {
 [WithdrawalEntityGridRowProp.ModificationTime] : number | null
}
export type WithdrawalEntityGridRowModifiedBy = {
 [WithdrawalEntityGridRowProp.ModifiedBy] : string | null
}
export type WithdrawalEntityGridRowReasonInternalReason = {
 [WithdrawalEntityGridRowProp.ReasonInternalReason] : string | null
}
export type WithdrawalEntityGridRowSourceAmount = {
 [WithdrawalEntityGridRowProp.SourceAmount] : number | null
}
export type WithdrawalEntityGridRowSourceCurrency = {
 [WithdrawalEntityGridRowProp.SourceCurrency] : 'USD' | 'EUR' | 'GBP' | 'CAD' | 'JPY' | 'AED' | 'PLN' | 'AZN' | 'INR' | 'NZD' | 'CUP' | 'EGP' | 'LBP' | 'RMB' | 'AUD' | 'ILS' | 'RON' | 'CHF' | 'CZK' | 'DKK' | 'RUB' | 'BGN' | 'HRK' | 'CNY' | 'MXN' | 'CLP' | 'ALL' | 'NOK' | 'SEK' | 'HUF' | 'BRL' | 'ZAR' | 'HKD' | 'SGD' | 'THB' | 'TRY' | 'KRW' | 'SKK' | 'LKR' | 'COP' | 'VND' | 'CNH' | 'SAR' | 'MYR' | 'USDT' | 'LOCAL_CURRENCY' | null
}
export type WithdrawalEntityGridRowStatus = {
 [WithdrawalEntityGridRowProp.Status] : 'PENDING' | 'PENDING_COMPLIANCE' | 'DONE' | 'FAILED' | 'REJECTED' | 'PENDING_PM_APPROVAL' | 'CANCELLED_PENDING_PM_APPROVAL' | 'CANCELLED_PENDING_COMPLIANCE' | null
}
export type WithdrawalEntityGridRowTargetAmount = {
 [WithdrawalEntityGridRowProp.TargetAmount] : number | null
}
export type WithdrawalEntityGridRowTargetCurrency = {
 [WithdrawalEntityGridRowProp.TargetCurrency] : 'USD' | 'EUR' | 'GBP' | 'CAD' | 'JPY' | 'AED' | 'PLN' | 'AZN' | 'INR' | 'NZD' | 'CUP' | 'EGP' | 'LBP' | 'RMB' | 'AUD' | 'ILS' | 'RON' | 'CHF' | 'CZK' | 'DKK' | 'RUB' | 'BGN' | 'HRK' | 'CNY' | 'MXN' | 'CLP' | 'ALL' | 'NOK' | 'SEK' | 'HUF' | 'BRL' | 'ZAR' | 'HKD' | 'SGD' | 'THB' | 'TRY' | 'KRW' | 'SKK' | 'LKR' | 'COP' | 'VND' | 'CNH' | 'SAR' | 'MYR' | 'USDT' | 'LOCAL_CURRENCY' | null
}
export type WithdrawalEntityGridRowTargetCurrencyConvRate = {
 [WithdrawalEntityGridRowProp.TargetCurrencyConvRate] : number | null
}
export type WithdrawalEntityGridRowTransactionType = {
 [WithdrawalEntityGridRowProp.TransactionType] : 'DEPOSIT' | 'WITHDRAWAL' | 'CORRECTION' | null
}
export type WithdrawalEntityGridRowTxSubType = {
 [WithdrawalEntityGridRowProp.TxSubType] : 'NEGATIVE_ADJUSTMENT' | 'NEGATIVE_DEALING_CORRECTION' | 'NEGATIVE_FRAUD_ADJUSTMENT' | 'NEGATIVE_BONUS_ADJUSTMENT' | 'CLOSING_ACCOUNT_BOOK_NEGATIVE' | 'PARTNER_NEGATIVE_ADJUSTMENT' | 'POSITIVE_ADJUSTMENT' | 'POSITIVE_DEALING_CORRECTION' | 'POSITIVE_FRAUD_ADJUSTMENT' | 'POSITIVE_BONUS_ADJUSTMENT' | 'CLOSING_ACCOUNT_BOOK_POSITIVE' | 'PARTNER_PAYMENT' | 'PARTNER_BONUS' | 'BONUS' | 'CREDIT_CARD_DEPOSIT' | 'WIRE_TRANSFER_DEPOSIT' | 'CREDIT_CREDIT_CARD_WITHDRAWAL' | 'VOID_CREDIT_CARD_WITHDRAWAL' | 'REFUND_CREDIT_CARD_WITHDRAWAL' | 'WIRE_TRANSFER_WITHDRAWAL' | 'MANUAL_DEPOSIT' | 'INTERNAL_DEPOSIT' | 'MANUAL_WITHDRAWAL' | 'INTERNAL_WITHDRAWAL' | 'LIBERTY_RESERVE_DEPOSIT' | 'LIBERTY_RESERVE_WITHDRAWAL' | 'ENVOY_DEPOSIT' | 'ENVOY_WITHDRAWAL' | 'WM_WITHDRAWAL' | 'NETELLER_DEPOSIT' | 'MONEYBOOKERS_DEPOSIT' | 'QIWI_DEPOSIT' | 'WEBMONEY_DEPOSIT' | 'CHINAUNION_DEPOSIT' | 'CUP_DEPOSIT' | 'CHINAUNION_WITHDRAWAL' | 'LOBANET_DEPOSIT' | 'QIWI_WITHDRAWAL' | 'PSP_DEPOSIT' | 'BAOFOO_DEPOSIT' | 'SOLIDPAY_DEPOSIT' | 'FOCAL_DEPOSIT' | 'PAYGATE_DEPOSIT' | 'PAYMENT_ASIA_DEPOSIT' | 'CRYPTO_WITHDRAWAL' | 'MD_APM_WITHDRAWAL' | null
}
export type WithdrawalEntityGridRow = 
 Partial<WithdrawalEntityGridRowAuth3D> & 
 Partial<WithdrawalEntityGridRowBaseCurrencyAmount> & 
 Partial<WithdrawalEntityGridRowBaseCurrencyConvRate> & 
 Partial<WithdrawalEntityGridRowBonusDataAdjustedAmount> & 
 Partial<WithdrawalEntityGridRowBonusExpirationDate> & 
 Partial<WithdrawalEntityGridRowCcExpDate> & 
 Partial<WithdrawalEntityGridRowCcNumber> & 
 Partial<WithdrawalEntityGridRowCreationTime> & 
 Partial<WithdrawalEntityGridRowEcdd> & 
 Partial<WithdrawalEntityGridRowExternalId> & 
 WithdrawalEntityGridRowId & 
 Partial<WithdrawalEntityGridRowModificationTime> & 
 Partial<WithdrawalEntityGridRowModifiedBy> & 
 Partial<WithdrawalEntityGridRowReasonInternalReason> & 
 Partial<WithdrawalEntityGridRowSourceAmount> & 
 WithdrawalEntityGridRowSourceCurrency & 
 Partial<WithdrawalEntityGridRowStatus> & 
 Partial<WithdrawalEntityGridRowTargetAmount> & 
 WithdrawalEntityGridRowTargetCurrency & 
 Partial<WithdrawalEntityGridRowTargetCurrencyConvRate> & 
 Partial<WithdrawalEntityGridRowTransactionType> & 
 Partial<WithdrawalEntityGridRowTxSubType>

export enum WithdrawalRequestEntityGridRowProp {
 ApprovedAmount = 'approvedAmount',
 ApprovedCurrency = 'approvedCurrency',
 AssignedPoolName = 'assignedPool.name',
 AssignedUser = 'assignedUser',
 Auth3D = 'auth3D',
 CreatedBy = 'createdBy',
 CreationTime = 'creationTime',
 Id = 'id',
 MethodType = 'methodType',
 ModificationTime = 'modificationTime',
 ModifiedBy = 'modifiedBy',
 Priority = 'priority',
 RequestedAmount = 'requestedAmount',
 RequestedCurrency = 'requestedCurrency',
 Status = 'status',
 TradingAccountCurrency = 'tradingAccount.currency',
 TradingAccountCustomerBrandName = 'tradingAccount.customer.brand.name',
 TradingAccountCustomerCompanyRegulationCountryCompanyRegulationPartnerCompanyName = 'tradingAccount.customer.companyRegulationCountry.companyRegulation.partnerCompany.name',
 TradingAccountCustomerComplianceDataComplianceStage = 'tradingAccount.customer.complianceData.complianceStage',
 TradingAccountCustomerNumberOfDeposits = 'tradingAccount.customer.numberOfDeposits',
 TradingAccountCustomerNumberOfWithdrawals = 'tradingAccount.customer.numberOfWithdrawals',
 TradingAccountCustomerTotalDeposits = 'tradingAccount.customer.totalDeposits',
 TradingAccountCustomerTotalWithdrawals = 'tradingAccount.customer.totalWithdrawals',
 TradingAccountAmount = 'tradingAccountAmount'
}
export type WithdrawalRequestEntityGridRowApprovedAmount = {
 [WithdrawalRequestEntityGridRowProp.ApprovedAmount] : number | null
}
export type WithdrawalRequestEntityGridRowApprovedCurrency = {
 [WithdrawalRequestEntityGridRowProp.ApprovedCurrency] : 'USD' | 'EUR' | 'GBP' | 'CAD' | 'JPY' | 'AED' | 'PLN' | 'AZN' | 'INR' | 'NZD' | 'CUP' | 'EGP' | 'LBP' | 'RMB' | 'AUD' | 'ILS' | 'RON' | 'CHF' | 'CZK' | 'DKK' | 'RUB' | 'BGN' | 'HRK' | 'CNY' | 'MXN' | 'CLP' | 'ALL' | 'NOK' | 'SEK' | 'HUF' | 'BRL' | 'ZAR' | 'HKD' | 'SGD' | 'THB' | 'TRY' | 'KRW' | 'SKK' | 'LKR' | 'COP' | 'VND' | 'CNH' | 'SAR' | 'MYR' | 'USDT' | 'LOCAL_CURRENCY' | null
}
export type WithdrawalRequestEntityGridRowAssignedPoolName = {
 [WithdrawalRequestEntityGridRowProp.AssignedPoolName] : string | null
}
export type WithdrawalRequestEntityGridRowAssignedUser = {
 [WithdrawalRequestEntityGridRowProp.AssignedUser] : any /* Entity */
}
export type WithdrawalRequestEntityGridRowAuth3D = {
 [WithdrawalRequestEntityGridRowProp.Auth3D] : boolean | null
}
export type WithdrawalRequestEntityGridRowCreatedBy = {
 [WithdrawalRequestEntityGridRowProp.CreatedBy] : string | null
}
export type WithdrawalRequestEntityGridRowCreationTime = {
 [WithdrawalRequestEntityGridRowProp.CreationTime] : number | null
}
export type WithdrawalRequestEntityGridRowId = {
 [WithdrawalRequestEntityGridRowProp.Id] : number
}
export type WithdrawalRequestEntityGridRowMethodType = {
 [WithdrawalRequestEntityGridRowProp.MethodType] : any /* Entity */
}
export type WithdrawalRequestEntityGridRowModificationTime = {
 [WithdrawalRequestEntityGridRowProp.ModificationTime] : number | null
}
export type WithdrawalRequestEntityGridRowModifiedBy = {
 [WithdrawalRequestEntityGridRowProp.ModifiedBy] : string | null
}
export type WithdrawalRequestEntityGridRowPriority = {
 [WithdrawalRequestEntityGridRowProp.Priority] : 'HIGH' | 'MEDIUM' | 'LOW' | null
}
export type WithdrawalRequestEntityGridRowRequestedAmount = {
 [WithdrawalRequestEntityGridRowProp.RequestedAmount] : number | null
}
export type WithdrawalRequestEntityGridRowRequestedCurrency = {
 [WithdrawalRequestEntityGridRowProp.RequestedCurrency] : 'USD' | 'EUR' | 'GBP' | 'CAD' | 'JPY' | 'AED' | 'PLN' | 'AZN' | 'INR' | 'NZD' | 'CUP' | 'EGP' | 'LBP' | 'RMB' | 'AUD' | 'ILS' | 'RON' | 'CHF' | 'CZK' | 'DKK' | 'RUB' | 'BGN' | 'HRK' | 'CNY' | 'MXN' | 'CLP' | 'ALL' | 'NOK' | 'SEK' | 'HUF' | 'BRL' | 'ZAR' | 'HKD' | 'SGD' | 'THB' | 'TRY' | 'KRW' | 'SKK' | 'LKR' | 'COP' | 'VND' | 'CNH' | 'SAR' | 'MYR' | 'USDT' | 'LOCAL_CURRENCY' | null
}
export type WithdrawalRequestEntityGridRowStatus = {
 [WithdrawalRequestEntityGridRowProp.Status] : 'NEW' | 'APPROVED' | 'COMPLETED' | 'REJECTED' | 'CANCELED' | 'FUNDS_REMOVED' | 'PENDING_FUNDS_REMOVAL' | 'PENDING_CANCELLATION' | null
}
export type WithdrawalRequestEntityGridRowTradingAccountCurrency = {
 [WithdrawalRequestEntityGridRowProp.TradingAccountCurrency] : 'USD' | 'EUR' | 'GBP' | 'CAD' | 'JPY' | 'AED' | 'PLN' | 'AZN' | 'INR' | 'NZD' | 'CUP' | 'EGP' | 'LBP' | 'RMB' | 'AUD' | 'ILS' | 'RON' | 'CHF' | 'CZK' | 'DKK' | 'RUB' | 'BGN' | 'HRK' | 'CNY' | 'MXN' | 'CLP' | 'ALL' | 'NOK' | 'SEK' | 'HUF' | 'BRL' | 'ZAR' | 'HKD' | 'SGD' | 'THB' | 'TRY' | 'KRW' | 'SKK' | 'LKR' | 'COP' | 'VND' | 'CNH' | 'SAR' | 'MYR' | 'USDT' | 'LOCAL_CURRENCY' | null
}
export type WithdrawalRequestEntityGridRowTradingAccountCustomerBrandName = {
 [WithdrawalRequestEntityGridRowProp.TradingAccountCustomerBrandName] : string | null
}
export type WithdrawalRequestEntityGridRowTradingAccountCustomerCompanyRegulationCountryCompanyRegulationPartnerCompanyName = {
 [WithdrawalRequestEntityGridRowProp.TradingAccountCustomerCompanyRegulationCountryCompanyRegulationPartnerCompanyName] : string | null
}
export type WithdrawalRequestEntityGridRowTradingAccountCustomerComplianceDataComplianceStage = {
 [WithdrawalRequestEntityGridRowProp.TradingAccountCustomerComplianceDataComplianceStage] : 'NON_COMPLIANT' | 'COMPLIANT' | 'PENDING_COMPLIANCE' | 'LIMITED_COMPLIED' | 'COMPLIANCE_REVOKED' | 'COMPLIANCE_SUSPENDED' | null
}
export type WithdrawalRequestEntityGridRowTradingAccountCustomerNumberOfDeposits = {
 [WithdrawalRequestEntityGridRowProp.TradingAccountCustomerNumberOfDeposits] : number | null
}
export type WithdrawalRequestEntityGridRowTradingAccountCustomerNumberOfWithdrawals = {
 [WithdrawalRequestEntityGridRowProp.TradingAccountCustomerNumberOfWithdrawals] : number | null
}
export type WithdrawalRequestEntityGridRowTradingAccountCustomerTotalDeposits = {
 [WithdrawalRequestEntityGridRowProp.TradingAccountCustomerTotalDeposits] : number | null
}
export type WithdrawalRequestEntityGridRowTradingAccountCustomerTotalWithdrawals = {
 [WithdrawalRequestEntityGridRowProp.TradingAccountCustomerTotalWithdrawals] : number | null
}
export type WithdrawalRequestEntityGridRowTradingAccountAmount = {
 [WithdrawalRequestEntityGridRowProp.TradingAccountAmount] : number | null
}
export type WithdrawalRequestEntityGridRow = 
 Partial<WithdrawalRequestEntityGridRowApprovedAmount> & 
 Partial<WithdrawalRequestEntityGridRowApprovedCurrency> & 
 Partial<WithdrawalRequestEntityGridRowAssignedPoolName> & 
 Partial<WithdrawalRequestEntityGridRowAssignedUser> & 
 Partial<WithdrawalRequestEntityGridRowAuth3D> & 
 Partial<WithdrawalRequestEntityGridRowCreatedBy> & 
 Partial<WithdrawalRequestEntityGridRowCreationTime> & 
 WithdrawalRequestEntityGridRowId & 
 Partial<WithdrawalRequestEntityGridRowMethodType> & 
 Partial<WithdrawalRequestEntityGridRowModificationTime> & 
 Partial<WithdrawalRequestEntityGridRowModifiedBy> & 
 Partial<WithdrawalRequestEntityGridRowPriority> & 
 Partial<WithdrawalRequestEntityGridRowRequestedAmount> & 
 Partial<WithdrawalRequestEntityGridRowRequestedCurrency> & 
 Partial<WithdrawalRequestEntityGridRowStatus> & 
 Partial<WithdrawalRequestEntityGridRowTradingAccountCurrency> & 
 Partial<WithdrawalRequestEntityGridRowTradingAccountCustomerBrandName> & 
 Partial<WithdrawalRequestEntityGridRowTradingAccountCustomerCompanyRegulationCountryCompanyRegulationPartnerCompanyName> & 
 Partial<WithdrawalRequestEntityGridRowTradingAccountCustomerComplianceDataComplianceStage> & 
 WithdrawalRequestEntityGridRowTradingAccountCustomerNumberOfDeposits & 
 WithdrawalRequestEntityGridRowTradingAccountCustomerNumberOfWithdrawals & 
 Partial<WithdrawalRequestEntityGridRowTradingAccountCustomerTotalDeposits> & 
 Partial<WithdrawalRequestEntityGridRowTradingAccountCustomerTotalWithdrawals> & 
 Partial<WithdrawalRequestEntityGridRowTradingAccountAmount>

